/*
 * Clerk.js v2 - d42c049 (dirty) - ###VERSION###
 * (c) 2011-2024 Clerk.io ApS
 * https://clerk.io
 */
/*
 * File: src/main.coffee 
 */

/*
The main Clerk object.

The purpose of Clerk is to make it super easy to use embed results from Clerk.io's API on any website.

The Clerk object both handles rendering pure HTML embed-blocks and provides an easy JavaScript interface for developers.

All methods on the object (except 'lib') is the only public exposed interfaces.
All methods should be accessed by passing their name as a string as the first parameter to the Clerk object.
All following arguments will be passed on to the method as arguments.

>
> Clerk('foo', 2, 4) // call the Clerk.foo method with the parameters 2 and 4.
>
 */

(function() {
  var Clerk, _loadScript, _wrap_content, _wrap_ui_popup, _wrap_ui_slider,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
    slice = [].slice;

  Clerk = (function() {
    function Clerk() {
      var key, self, value;
      this._clerk = true;
      this._event_handlers = {
        '*': []
      };
      this._content_attempts = 0;
      this._subscriptions = {};
      self = (function(_this) {
        return function() {
          var args, command;
          args = Array.prototype.slice.call(arguments);
          command = args[0];
          args = args.slice(1);
          if (self[command]) {
            return self[command].apply(self, args);
          }
        };
      })(this);
      for (key in this) {
        value = this[key];
        self[key] = value;
      }
      return self;
    }

    Clerk.prototype.config = function(arg1, arg2) {
      var arg, i, key, len, logger, ref, ret, set, value;
      if (!this._config) {
        this._config = {};
      }
      set = (function(_this) {
        return function(key, value, dict) {
          var _key, _value, characters, e, error1, storage, subkeys, visitor;
          if (indexOf.call(key, '.') >= 0) {
            subkeys = key.split(/\.(.+)/);
            return set(subkeys[1], value, dict[subkeys[0]]);
          }
          if (key === 'visitor') {
            storage = _this.lib('storage');
            switch (value) {
              case 'persistent':
                try {
                  storage.get('clerk-visitor-id');
                } catch (error1) {
                  e = error1;
                  logger.error('Could not load clerk visitor id. Attempted to fix issue', {
                    error: e
                  });
                  storage.remove('clerk-visitor-id');
                }
                if (storage.get('clerk-visitor-id')) {
                  visitor = storage.get('clerk-visitor-id');
                  value = visitor;
                } else {
                  visitor = '';
                  characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                  while (visitor.length < 8) {
                    visitor += characters.charAt(Math.floor(Math.random() * characters.length));
                  }
                  storage.set('clerk-visitor-id', visitor);
                  value = visitor;
                }
                break;
              case 'auto':
                storage.remove('clerk-visitor-id');
                break;
              case null:
                storage.remove('clerk-visitor-id');
                break;
              case void 0:
                storage.remove('clerk-visitor-id');
                break;
            }
          }
          if (typeof value === 'object' && key !== 'visitor') {
            if (!dict[key]) {
              dict[key] = {};
            }
            for (_key in value) {
              _value = value[_key];
              dict[key][_key] = _value;
            }
          } else {
            dict[key] = value;
          }
          if (!('visitor' in dict)) {
            return dict['visitor'] = 'auto';
          }
        };
      })(this);
      logger = this.lib('logger');
      switch (typeof arg1) {
        case 'object':
          logger.log('Updated configuration', arg1);
          for (key in arg1) {
            value = arg1[key];
            set(key, value, this._config);
          }
          break;
        case 'string':
          if (arg2) {
            logger.log('Updated configuration', {
              key: arg1,
              value: arg2
            });
            set(arg1, arg2, this._config);
          } else {
            ref = arg1.split('.');
            for (i = 0, len = ref.length; i < len; i++) {
              arg = ref[i];
              if (ret) {
                ret[arg];
              } else {
                ret = this._config[arg];
              }
            }
            return ret;
          }
      }
      if (this._config['collect_email']) {
        return this.collect_emails();
      }
    };

    Clerk.prototype.content = function() {
      var action, action_args, content, content_lib, content_params, contents, css_selector, dom, element, exclude_lib, exit_lib, facets_lib, fn, i, j, len, len1, livesearch_lib, loaded_contents, omnisearch_lib, popup_lib, ref, search_lib, slider_lib, splittest_lib, visitor_lib, wrapped_content;
      css_selector = arguments[0], action = arguments[1], action_args = 3 <= arguments.length ? slice.call(arguments, 2) : [];
      if (!this.config('loaded') && this._content_attempts < 10) {
        this._content_attempts += 1;
        setTimeout((function(_this) {
          return function() {
            return _this.content.apply(_this, [css_selector, action].concat(slice.call(action_args)));
          };
        })(this), 20);
        return;
      }
      this._content_attempts = 0;
      dom = this.lib('dom');
      content_lib = this.lib('content');
      exclude_lib = this.lib('ui.content.exclude');
      splittest_lib = this.lib('ui.content.splittest');
      exit_lib = this.lib('ui.content.exit');
      livesearch_lib = this.lib('ui.content.livesearch');
      omnisearch_lib = this.lib('ui.content.omnisearch');
      search_lib = this.lib('ui.content.search');
      facets_lib = this.lib('ui.content.facets');
      visitor_lib = this.lib('ui.content.visitor');
      slider_lib = this.lib('ui.slider');
      popup_lib = this.lib('ui.popup');
      content_params = {};
      if (action && typeof action === 'object') {
        content_params = action;
        action = void 0;
      }
      contents = [];
      loaded_contents = this.config('contents');
      ref = dom.find(css_selector);
      fn = (function(_this) {
        return function(element) {
          var api, arg, content, j, len1, template;
          template = element.data('template');
          api = element.data('api');
          if ((template != null) && (loaded_contents != null) && template[0] === '@' && !(template.slice(1) in loaded_contents)) {
            return;
          }
          if (!template && !api) {
            template = content_params['template'];
            if (!template) {
              for (j = 0, len1 = action_args.length; j < len1; j++) {
                arg = action_args[j];
                if (!(typeof arg === 'object' && 'template' in arg)) {
                  continue;
                }
                template = arg['template'];
                api = arg['api'];
                break;
              }
            }
          }
          if (content_lib.is_content(element)) {
            if (!content_lib.get(element).model()['multi-init']) {
              contents.push(content_lib.get(element));
              return;
            }
          }
          if (!template && !api) {
            return;
          }
          content = content_lib.create(element);
          content.model(content_params);
          if (content.model('exclude-from') != null) {
            exclude_lib.create(content);
          }
          if (content.model('split-test') != null) {
            splittest_lib.create(content);
          }
          if ((content.model('bind-live-search') != null) || (content.model('instant-search') != null)) {
            livesearch_lib.create(content);
          }
          if ((element.data('api') != null) && element.data('api').match('omni')) {
            omnisearch_lib.create(content);
          }
          if (content.model('query') != null) {
            search_lib.create(content);
          }
          if (content.model('exit-intent') != null) {
            exit_lib.create(content);
          }
          if (content.model('facets-target') != null) {
            facets_lib.create(content);
          }
          if ((content.model('show') != null) || (content.model('hide') != null)) {
            visitor_lib.create(content);
          }
          content.on('*').then(function(type, data) {
            var handler, handlers, name, ref1, results;
            ref1 = _this._event_handlers;
            results = [];
            for (name in ref1) {
              handlers = ref1[name];
              if (name === type) {
                results.push((function() {
                  var k, len2, results1;
                  results1 = [];
                  for (k = 0, len2 = handlers.length; k < len2; k++) {
                    handler = handlers[k];
                    if (!handler.css_selector || content.element.matches(handler.css_selector)) {
                      results1.push(handler.callback(_wrap_content(content), data));
                    } else {
                      results1.push(void 0);
                    }
                  }
                  return results1;
                })());
              } else {
                results.push(void 0);
              }
            }
            return results;
          });
          content.on('rendered').then(function() {
            var k, l, len2, len3, popup, ref1, ref2, results, slider;
            ref1 = dom.find('.clerk-slider', content.target._element);
            for (k = 0, len2 = ref1.length; k < len2; k++) {
              slider = ref1[k];
              slider_lib.create(slider);
            }
            ref2 = dom.find('.clerk-popup', content.target._element);
            results = [];
            for (l = 0, len3 = ref2.length; l < len3; l++) {
              popup = ref2[l];
              results.push(popup_lib.create(popup));
            }
            return results;
          });
          content.reload();
          return contents.push(content);
        };
      })(this);
      for (i = 0, len = ref.length; i < len; i++) {
        element = ref[i];
        fn(element);
      }
      if (action) {
        for (j = 0, len1 = contents.length; j < len1; j++) {
          content = contents[j];
          wrapped_content = _wrap_content(content);
          if (typeof action === 'function') {
            action(wrapped_content);
          } else {
            wrapped_content[action].apply(wrapped_content, action_args);
            return;
          }
        }
      }
      return contents;
    };

    Clerk.prototype.visitor = function(type, arg1, arg2, arg3) {
      var callback, name, query, value, visitor;
      visitor = this.lib('visitor').get();
      switch (type) {
        case 'id':
          callback = arg1;
          return callback(visitor.id);
        case 'attr':
          if (typeof arg2 === 'function') {
            name = arg1;
            callback = arg2;
            return callback(visitor.attr(name));
          } else {
            name = arg1;
            value = arg2;
            return visitor.log_attr(name, value);
          }
          break;
        case 'event':
          if (typeof arg3 === 'function') {
            type = arg1;
            value = arg2;
            callback = arg3;
            return callback(visitor.event(type, value));
          } else if (typeof arg2 === 'function') {
            type = arg1;
            callback = arg2;
            return callback(visitor.event(type, null));
          } else {
            type = arg1;
            value = arg2;
            return visitor.log_event(type, value);
          }
          break;
        case 'match':
          query = arg1;
          callback = arg2;
          return callback(visitor["eval"](query));
      }
    };

    Clerk.prototype.on = function(event, arg1, arg2) {
      var callback, css_selector;
      if (arg2) {
        css_selector = arg1;
        callback = arg2;
      } else {
        callback = arg1;
        css_selector = null;
      }
      if (!this._event_handlers[event]) {
        this._event_handlers[event] = [];
      }
      return this._event_handlers[event].push({
        css_selector: css_selector,
        callback: callback
      });
    };

    Clerk.prototype.subscribe = function() {
      var args, callback_func, deferred, event, q;
      event = arguments[0], callback_func = arguments[1], args = 3 <= arguments.length ? slice.call(arguments, 2) : [];
      q = this.lib('q');
      deferred = q.defer();
      if (!(event in this._subscriptions)) {
        this._subscriptions[event] = [];
        callback_func.apply(null, args).then((function(_this) {
          return function(response) {
            var def, i, len, ref, results;
            _this.config(event, response);
            ref = _this._subscriptions[event];
            results = [];
            for (i = 0, len = ref.length; i < len; i++) {
              def = ref[i];
              results.push(def.resolve(response));
            }
            return results;
          };
        })(this));
      }
      this._subscriptions[event].push(deferred);
      return deferred.promise;
    };

    Clerk.prototype.ui = function(component, css_selector, action) {
      var element, ui_component, ui_lib, wrapper;
      element = this.lib('dom').find(css_selector)[0];
      switch (component) {
        case 'popup':
          ui_lib = this.lib('ui.popup');
          wrapper = _wrap_ui_popup;
          break;
        case 'slider':
          ui_lib = this.lib('ui.slider');
          wrapper = _wrap_ui_slider;
      }
      ui_component = wrapper(ui_lib.create(element));
      if (typeof action === 'function') {
        return action(ui_component);
      } else {
        ui_component[action]();
      }
    };

    Clerk.prototype.click = function(arg1, arg2) {
      var api, css_selector, dom, element, fn, i, j, len, len1, link, link_selector, links, logger, metadata, product_id, ref;
      api = this.lib('api');
      logger = this.lib('logger');
      if ((arg1 != null) && (arg2 != null)) {
        product_id = arg1;
        metadata = arg2;
        api.call('log/click', {
          product: product_id,
          labels: metadata.labels,
          api: metadata.api,
          n: metadata.n,
          external: metadata.external
        }).then(function() {
          return logger.log('Logged click on Clerk.io product', {
            product: product_id,
            metadata: metadata
          });
        });
      } else if (arg1 != null) {
        css_selector = arg1;
        dom = this.lib('dom');
        link_selector = 'a, button, *[onclick], input[type="button"], input[type="submit"]';
        ref = dom.find(css_selector);
        for (i = 0, len = ref.length; i < len; i++) {
          element = ref[i];
          product_id = element.data('clerk-product-id');
          links = dom.find(link_selector, element.raw());
          fn = (function(_this) {
            return function(product_id, link) {
              if (product_id && !link.data('clerk-click-tracking-added')) {
                link.on('click').then(function(event) {
                  if ((link.data('__clerk-has-continued')) != null) {
                    return;
                  }
                  link.data('__clerk-has-continued', true);
                  if (product_id !== parseInt(product_id)) {
                    product_id = product_id.toString();
                  }
                  api.call('log/click', {
                    product: product_id
                  });
                  return logger.log('Clicked on Clerk.io product', {
                    product: product_id
                  });
                });
                return link.data('clerk-click-tracking-added', true);
              }
            };
          })(this);
          for (j = 0, len1 = links.length; j < len1; j++) {
            link = links[j];
            fn(product_id, link);
          }
        }
      }
    };

    Clerk.prototype.call = function(endpoint, args, callback, error) {
      var response;
      if (args == null) {
        args = {};
      }
      response = this.lib('api').call(endpoint, args);
      if (callback != null) {
        response.then(callback);
      }
      if (error != null) {
        response["catch"](error);
      }
      return response;
    };

    Clerk.prototype.lib = function(name, lib) {
      if (!this._libs) {
        this._libs = {};
      }
      if (lib) {
        return this._libs[name] = lib;
      } else {
        return this._libs[name];
      }
    };

    Clerk.prototype.event_handlers = function(type) {
      var _event, event_list, i, len, ref;
      if (!this._event_handlers[type]) {
        return [];
      }
      event_list = [];
      ref = this._event_handlers[type];
      for (i = 0, len = ref.length; i < len; i++) {
        _event = ref[i];
        event_list.push(_event.callback);
      }
      return event_list;
    };

    Clerk.prototype.cart = function(action, products) {
      var api, logger;
      api = this.lib('api');
      logger = this.lib('logger');
      switch (action) {
        case 'add':
          api.call('log/basket/add', {
            product: products
          });
          return logger.log('Added product to cart.', {
            product: products
          });
        case 'remove':
          api.call('log/basket/remove', {
            product: products
          });
          return logger.log('Removed product from cart.', {
            product: products
          });
        case 'set':
          api.call('log/basket/set', {
            products: products
          });
          return logger.log('Cart set.', {
            products: products
          });
        default:
          return logger.error('Action was not recognised, allowed actions is "add", "remove" and "set"', {
            action: action,
            products: products
          });
      }
    };

    Clerk.prototype.collect_emails = function() {
      var dom, element, i, len, logger, ref, results, submit_if_valid_email;
      logger = this.lib('logger');
      dom = this.lib('dom');
      logger.log('Automatic e-mail collection is activated.');
      submit_if_valid_email = (function(_this) {
        return function(element) {
          var args, value;
          value = element.value();
          if ((value != null) && value.indexOf('@') > 0 && value.indexOf('.') > 0) {
            return _this.call('log/email', args = {
              'email': value
            });
          }
        };
      })(this);
      ref = dom.find('input');
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        element = ref[i];
        results.push((function(_this) {
          return function(element) {
            _this._email_timeout = null;
            element.on('keyup').then(function() {
              clearTimeout(this._email_timeout);
              return this._email_timeout = setTimeout((function() {
                return submit_if_valid_email(element);
              }), 2500);
            });
            return element.on('blur').then(function() {
              clearTimeout(this._email_timeout);
              return this._email_timeout = setTimeout((function() {
                return submit_if_valid_email(element);
              }), 100);
            });
          };
        })(this)(element));
      }
      return results;
    };

    Clerk.prototype.inject_chat = function() {
      var logger;
      logger = this.lib('logger');
      return _loadScript('https://cdn.clerk.io/chat/clerkChat.js', ((function(_this) {
        return function() {
          return logger.log('Injected clerkChat.js');
        };
      })(this)), true);
    };

    return Clerk;

  })();

  _wrap_content = function(content) {
    return {
      id: content.ident,
      element: content.element.raw(),
      param: function(key, value) {
        if (value !== void 0 || typeof key === 'object') {
          content.model(key, value);
          return content.reload();
        } else {
          return content.model(key);
        }
      },
      more: function(n) {
        var limit;
        limit = content.model('limit');
        if (limit == null) {
          limit = n;
        }
        if ((n == null) || n <= 0) {
          n = Math.min(Math.max(limit, 10), 100);
        }
        content.model('limit', limit + n);
        return content.reload();
      }
    };
  };

  _wrap_ui_popup = function(popup) {
    return {
      show: function() {
        return popup.show();
      },
      hide: function() {
        return popup.hide();
      }
    };
  };

  _wrap_ui_slider = function(slider) {
    return {
      next: function() {
        return slider.next();
      },
      prev: function() {
        return slider.prev();
      }
    };
  };

  _loadScript = function(url, callback, isModule) {
    var script;
    script = document.createElement('script');
    script.type = isModule ? 'module' : 'text/javascript';
    script.src = url;
    script.onload = callback;
    return document.head.appendChild(script);
  };

  if (!window.Clerk._clerk) {
    window.Clerk = new Clerk();
  } else {
    console.error('[Clerk.js] Clerk.js is loaded more than one time on this page!');
  }

}).call(this);

/*
 * File: src/core/api.coffee 
 */
(function() {
  var Clerk;

  Clerk = window.Clerk;

  Clerk.lib('api', {
    call: function(endpoint, args) {
      var api_version, debug, deferred, dom, json, language, logger, params, price_context, protocol, proxy, q, start, utils, visitor;
      if (args == null) {
        args = {};
      }
      q = Clerk.lib('q');
      dom = Clerk.lib('dom');
      json = Clerk.lib('json');
      utils = Clerk.lib('utils');
      logger = Clerk.lib('logger').component('API');
      deferred = q.defer();
      if (Clerk.config('failed_to_load')) {
        return deferred.promise;
      }
      if (!args.key) {
        args.key = Clerk.config('key');
      }
      if (!args.key || typeof args.key !== 'string') {
        logger.error('No API key provided.');
        return deferred.promise;
      }
      if (args.api_version) {
        api_version = args.api_version;
        delete args.api_version;
      } else {
        api_version = 'v2';
      }
      params = utils.get_URI_components();
      if (params['clerk_api_flags'] != null) {
        args.flags = params['clerk_api_flags'];
      }
      visitor = Clerk.config('visitor');
      if (visitor != null) {
        args.visitor = visitor;
      }
      language = Clerk.config('language');
      if (language && !args.language) {
        args.language = language;
      }
      price_context = Clerk.config('price_context');
      if (price_context && !args.price_context) {
        args.price_context = price_context;
      }
      debug = Clerk.config('debug');
      if (debug.collect && debug.level === 'log') {
        args.debug = true;
      }
      if (endpoint.match('config/')) {
        args._ = Math.round((new Date()).getTime() / (1000 * 60));
      } else {
        args._ = Math.round((new Date()).getTime() / 1000.);
      }
      if (args.query) {
        args.query = "" + args.query;
      }
      protocol = 'https';
      proxy = Clerk.config('proxy');
      start = new Date() / 1000;
      dom.jsonp(protocol + "://" + proxy + "/" + api_version + "/" + endpoint, {
        payload: json.encode(args)
      }).then((function(_this) {
        return function(response) {
          if (typeof response === 'object' && response.status === 'error') {
            logger.error(response.message, {
              api: endpoint,
              args: args,
              response: response,
              protocol: protocol,
              proxy: proxy,
              time: new Date() / 1000 - start
            });
            return deferred.reject(response);
          } else {
            logger.log('Recieved API response.', {
              api: endpoint,
              args: args,
              response: response,
              time: new Date() / 1000 - start
            });
            return deferred.resolve(response);
          }
        };
      })(this))["catch"]((function(_this) {
        return function() {
          if (!Clerk.config('failed_to_load')) {
            logger.error('Failed API call!', {
              api: endpoint,
              args: args,
              time: new Date() / 1000 - start
            });
          }
          return deferred.reject();
        };
      })(this));
      return deferred.promise;
    }
  });

}).call(this);

/*
 * File: src/core/logger.coffee 
 */
(function() {
  var Clerk, _init_origin, _init_time, _init_user_agent, _series_id, collect, hashCode, log, log_wrapped;

  Clerk = window.Clerk;

  _init_time = window.performance ? window.performance.timing.domInteractive : Date.now();

  _series_id = Math.floor(Math.random() * 100000000);

  _init_origin = window.location.href;

  _init_user_agent = navigator.userAgent;

  Clerk.lib('logger', {
    log: function(message, args) {
      return log('log', message, args);
    },
    warn: function(message, args) {
      return log('warn', message, args);
    },
    error: function(message, args) {
      return log('error', message, args);
    },
    component: function(component) {
      return {
        log: function(message, args) {
          return log('log', message, args, component);
        },
        warn: function(message, args) {
          return log('warn', message, args, component);
        },
        error: function(message, args) {
          return log('error', message, args, component);
        }
      };
    }
  });

  log = function(type, message, args, component) {
    var config, level;
    if (args == null) {
      args = {};
    }
    if (component == null) {
      component = null;
    }
    config = Clerk.config('debug');
    if (!(config != null ? config.enable : void 0)) {
      return;
    }
    if (config != null ? config.verify : void 0) {
      verify();
      return;
    }
    level = config ? config.level : 'error';
    if (level === 'error' && type !== 'error') {
      return;
    } else if (level === 'warn' && type === 'log') {
      return;
    }
    return Clerk('subscribe', hashCode(message), log_wrapped, type, message, args, component);
  };

  log_wrapped = function(type, message, args, component) {
    var T, config;
    if (args == null) {
      args = {};
    }
    if (component == null) {
      component = null;
    }
    config = Clerk.config('debug');
    T = ((Date.now() - _init_time) / 1000).toFixed(3);
    if (component) {
      console[type]('[Clerk.io]', "[T+" + T + "]", "[" + component + "]", message, args);
    } else {
      console[type]('[Clerk.io]', "[T+" + T + "]", message, args);
    }
    if (config != null ? config.collect : void 0) {
      if (component) {
        message = "[" + component + "] " + message;
      }
      return collect(type, message, args);
    } else {
      return Clerk.lib('q').defer().promise;
    }
  };

  hashCode = function(s) {
    return s.split('').reduce(function(a, b) {
      return ((a << 5) - a) + b.charCodeAt(0);
    }, 0);
  };

  collect = function(type, message, metadata) {
    var dom, json, key, payload, protocol, proxy, ref;
    dom = Clerk.lib('dom');
    json = Clerk.lib('json');
    key = Clerk.config('key');
    proxy = Clerk.config('proxy');
    if (Clerk.config('failed_to_load') || (metadata != null ? (ref = metadata.response) != null ? ref.code : void 0 : void 0) === 403) {
      return Clerk.lib('q').defer().promise;
    }
    protocol = 'https';
    metadata.origin = window.location.href;
    metadata.init_origin = _init_origin;
    metadata.user_agent = navigator.userAgent;
    metadata.init_user_agent = _init_user_agent;
    payload = json.encode({
      key: key,
      source: 'Clerk.js',
      series: _series_id,
      message: message,
      type: type,
      metadata: metadata,
      _: Math.round((new Date()).getTime() / 1000)
    });
    if (payload.length > 2048) {
      payload = json.encode({
        key: key,
        source: 'Clerk.js',
        series: _series_id,
        message: message,
        type: type,
        metadata: {
          metadata_dropped: 'Mata-data was to large and was thus dropped.',
          origin: window.location.href,
          init_origin: _init_origin,
          user_agent: navigator.userAgent,
          init_user_agent: _init_user_agent
        }
      });
    }
    return dom.jsonp(protocol + "://" + proxy + "/v2/log/debug", {
      payload: payload
    });
  };

}).call(this);

/*
 * File: src/core/visitor.coffee 
 */
(function() {
  var Clerk, Visitor, _visitor, _visitor_key,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  Clerk = window.Clerk;

  _visitor = null;

  _visitor_key = '__clerk-vp';

  Clerk.lib('visitor', {
    get: function() {
      if (_visitor === null) {
        _visitor = new Visitor({
          id: 42
        });
      }
      return _visitor;
    }
  });

  Visitor = (function() {
    function Visitor(profile) {
      this.repr = bind(this.repr, this);
      this["eval"] = bind(this["eval"], this);
      this.log_attr = bind(this.log_attr, this);
      this.log_event = bind(this.log_event, this);
      this.event = bind(this.event, this);
      this.attr = bind(this.attr, this);
      this.id = profile.id;
      this._profile = profile;
      this._attrs = {};
      this._events = {};
      this._history = [];
      this._load();
    }

    Visitor.prototype._reset = function() {
      this._attrs = {};
      this._events = {};
      this._history = [];
      return this._save();
    };

    Visitor.prototype._load = function() {
      var stored_data;
      stored_data = Clerk.lib('storage').get(_visitor_key);
      if (stored_data) {
        this.id = stored_data.id;
        this._attrs = stored_data.attrs ? stored_data.attrs : {};
        this._events = stored_data.events ? stored_data.events : {};
        return this._history = stored_data.history ? stored_data.history : [];
      } else {
        return this._reset();
      }
    };

    Visitor.prototype._save = function() {
      return Clerk.lib('storage').set(_visitor_key, {
        id: this.id,
        events: this._events,
        history: this._history
      }, true);
    };

    Visitor.prototype.attr = function(name) {
      return this._attrs[name];
    };

    Visitor.prototype.event = function(type, value) {
      var _add, _event, _events, _value, now, occurrence, ref, ref1, type_l, value_l;
      if (value == null) {
        value = null;
      }
      now = new Date() / 1000;
      occurrence = function(timestamp) {
        var seconds_ago;
        seconds_ago = now - timestamp;
        return {
          seconds_ago: seconds_ago,
          minutes_ago: seconds_ago / 60,
          hours_ago: seconds_ago / (60 * 60),
          days_ago: seconds_ago / (60 * 60 * 24),
          weeks_ago: seconds_ago / (60 * 60 * 24 * 7),
          months_ago: seconds_ago / (60 * 60 * 24 * 30),
          years_ago: seconds_ago / (60 * 60 * 24 * 365),
          timestamp: timestamp
        };
      };
      _add = function(dict, value, event) {
        if (!dict) {
          return {
            count: event.count,
            type: event.type,
            value: value,
            first: occurrence(event.first),
            latest: occurrence(event.latest)
          };
        } else {
          return {
            count: event.count + dict.count,
            type: event.type,
            value: value,
            first: occurrence(Math.min(event.first, dict.first.timestamp)),
            latest: occurrence(Math.max(event.latest, dict.latest.timestamp))
          };
        }
      };
      _events = {};
      ref = this._events;
      for (type_l in ref) {
        _value = ref[type_l];
        if (!(indexOf.call(_events, type_l) >= 0)) {
          _events[type_l] = {};
        }
        for (value_l in _value) {
          _event = _value[value_l];
          _events[type_l][null] = _add(_events[type_l][null], null, _event);
          _events[type_l][value_l] = _add(_events[type_l][value_l], value_l, _event);
        }
      }
      if (((ref1 = _events[type]) != null ? ref1[value] : void 0) != null) {
        return _events[type][value];
      } else {
        return {};
      }
    };

    Visitor.prototype.log_pageview = function() {
      var decode, j, len, name, param, params, path, ref, ref1, value;
      path = location.path;
      params = {};
      if (location.search) {
        decode = function(str) {
          return decodeURIComponent(str.replace(/\+/g, ' '));
        };
        ref = location.search.substring(1).split('&');
        for (j = 0, len = ref.length; j < len; j++) {
          param = ref[j];
          ref1 = param.split('&'), name = ref1[0], value = ref1[1];
          params[name] = decode(value);
        }
      }
      this._history.unshift({
        path: path,
        params: params,
        time: new Date() / 1000
      });
      return this._save();
    };

    Visitor.prototype.log_event = function(type, value) {
      var event, now;
      if (value == null) {
        value = null;
      }
      now = new Date() / 1000;
      if (this._events[type] == null) {
        this._events[type] = {};
      }
      if (this._events[type][value] != null) {
        event = this._events[type][value];
      }
      if (!event) {
        event = {
          type: type,
          value: value,
          count: 1,
          first: now,
          latest: now
        };
      } else {
        event.count++;
        event.latest = now;
      }
      this._events[type][value] = event;
      return this._save();
    };

    Visitor.prototype.log_attr = function(name, value) {
      this._attrs[name] = value;
      return this._save();
    };

    Visitor.prototype["eval"] = function(expression) {
      var environment, expressions, j, len, partial_eval, ret, sub_expression, utils;
      utils = Clerk.lib('utils');
      partial_eval = (function(_this) {
        return function(expression, environment) {
          var e, error;
          try {
            if (utils["eval"](expression, environment)) {
              return true;
            } else {
              return false;
            }
          } catch (error) {
            e = error;
            return false;
          }
        };
      })(this);
      expression = expression.replace(/\bvisitor./g, '');
      expression = expression.replace(/\=/g, '==');
      environment = this.repr();
      expressions = expression.split(/(?=\bor\b|\band\b)/g);
      ret = partial_eval(expressions.shift(), environment);
      for (j = 0, len = expressions.length; j < len; j++) {
        sub_expression = expressions[j];
        if (sub_expression.substring(0, 2) === 'or') {
          ret = ret || partial_eval(sub_expression.substring(2), environment);
        } else {
          ret = ret && partial_eval(sub_expression.substring(3), environment);
        }
      }
      return ret;
    };

    Visitor.prototype.repr = function() {
      var _device, _event, _first, _latest, _most_frequent, _value, dom, duration, event, frequency, history, i, is_utm, j, k, last_time, len, len1, now, occurrence, page, pageviews, ref, sessions, type, utm, value, visit_times;
      dom = Clerk.lib('dom');
      _device = dom.device();
      now = new Date() / 1000;
      history = this._history;
      occurrence = function(timestamp) {
        var seconds_ago;
        seconds_ago = now - timestamp;
        return {
          seconds_ago: seconds_ago,
          minutes_ago: seconds_ago / 60,
          hours_ago: seconds_ago / (60 * 60),
          days_ago: seconds_ago / (60 * 60 * 24),
          weeks_ago: seconds_ago / (60 * 60 * 24 * 7),
          months_ago: seconds_ago / (60 * 60 * 24 * 30),
          years_ago: seconds_ago / (60 * 60 * 24 * 365),
          timestamp: timestamp
        };
      };
      event = function(type, value, count, first, latest) {
        return {
          type: type,
          value: value,
          count: count,
          first: occurrence(first),
          latest: occurrence(latest)
        };
      };
      sessions = 1;
      pageviews = 1;
      duration = 1;
      frequency = 0;
      last_time = now;
      visit_times = [now];
      for (j = 0, len = history.length; j < len; j++) {
        page = history[j];
        if (last_time - page.time > 60 * 30) {
          sessions++;
          visits.push(page.time);
        }
        if (sessions === 1) {
          pageviews++;
          duration = now - page.time;
        }
      }
      if (visit_times.length > 1) {
        frequency = Math.avg((function() {
          var k, ref, results;
          results = [];
          for (i = k = 0, ref = visit_times.length - 2; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
            results.push(visit_times[i + 1] - visit_times[i]);
          }
          return results;
        })());
      }
      is_utm = function(params) {
        return (params.utm_source != null) || (params.utm_medium != null) || (params.utm_name != null) || (params.utm_term != null) || (params.utm_content != null);
      };
      utm = {};
      for (k = 0, len1 = history.length; k < len1; k++) {
        page = history[k];
        if (is_utm(page.params)) {
          utm.source = page.params.utm_source;
          utm.medium = page.params.utm_medium;
          utm.name = page.params.utm_name;
          utm.term = page.params.utm_term;
          utm.content = page.params.utm_content;
          utm.time = page.time;
          break;
        }
      }
      _first = {};
      _latest = {};
      _most_frequent = {};
      ref = this._events;
      for (type in ref) {
        _value = ref[type];
        for (value in _value) {
          _event = _value[value];
          if (!(indexOf.call(_first, type) >= 0) || _first[type].first > _event.first) {
            _first[type] = _event;
          }
          if (!(indexOf.call(_latest, type) >= 0) || _latest[type].latest < _event.latest) {
            _latest[type] = _event;
          }
          if (!(indexOf.call(_most_frequent, type) >= 0) || _most_frequent[type].count < _event.count) {
            _most_frequent[type] = _event;
          }
        }
      }
      return {
        event: {
          first: _first,
          latest: _latest,
          most_frequent: _most_frequent
        },
        behavior: {
          is_first_session: sessions === 1,
          is_first_pageview: pageviews === 1,
          sessions: sessions,
          pageviews: pageviews,
          duration: duration,
          frequency: frequency
        },
        history: {
          path: function(query) {
            var l, len2;
            event = {
              count: 0,
              first: 0,
              latest: 0
            };
            for (l = 0, len2 = history.length; l < len2; l++) {
              page = history[l];
              if (page.path.indexOf(query > -1)) {
                if (event.count === 0) {
                  event.latest = page.time;
                }
                event.count++;
                event.first = page.time;
              }
            }
            if (event.count > 0) {
              return event;
            } else {
              return null;
            }
          },
          param: function(name, value) {
            var l, len2;
            if (value == null) {
              value = null;
            }
            event = {
              count: 0,
              first: 0,
              latest: 0
            };
            for (l = 0, len2 = history.length; l < len2; l++) {
              page = history[l];
              if (page.path.indexOf(query > -1)) {
                if (event.count === 0) {
                  event.latest = page.time;
                }
                event.count++;
                event.first = page.time;
              }
            }
            if (event.count > 0) {
              return event;
            } else {
              return null;
            }
          }
        },
        utm: {
          source: utm.source,
          medium: utm.medium,
          name: utm.name,
          term: utm.term,
          content: utm.content,
          occurred: occurrence(utm.time)
        },
        geo: {
          continent: {
            code: null,
            name: null
          },
          country: {
            code: null,
            name: null,
            city: null
          },
          weather: null
        },
        device: {
          is_mobile: _device.is_mobile,
          is_tablet: _device.is_tablet,
          is_desktop: _device.is_desktop,
          os: {
            name: _device.os.name,
            version: _device.os.version
          },
          browser: {
            version: _device.browser.version,
            language: _device.browser.language,
            is_incognito: _device.browser.is_incognito,
            name: _device.browser.name
          }
        }
      };
    };

    return Visitor;

  })();

}).call(this);

/*
 * File: src/core/content.coffee 
 */
(function() {
  var Clerk, Content, __find_all_product_loops, _content, _content_id_counter, _find_nested_attributes, _merge_dictionary, _pop, _sendable_model,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    slice = [].slice,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  Clerk = window.Clerk;

  _content = {};

  _content_id_counter = 1;

  Clerk.lib('content', {
    create: function(element) {
      var content, content_id;
      content_id = _content_id_counter++;
      element.data('clerk-content-id', content_id);
      content = new Content(element);
      _content[content_id] = content;
      return content;
    },
    get: function(element) {
      var content_id;
      content_id = element.data('clerk-content-id');
      if (content_id in _content) {
        return _content[content_id];
      }
    },
    is_content: function(element) {
      return element.data('clerk-content-id') != null;
    }
  });

  Content = (function() {
    function Content(element1) {
      var content_id, content_timestamp, data, dom, e, element, error, i, len, limit, loaded_contents, logger, ref, storage;
      this.element = element1;
      this.call_design = bind(this.call_design, this);
      this.load_design = bind(this.load_design, this);
      dom = Clerk.lib('dom');
      logger = Clerk.lib('logger');
      storage = Clerk.lib('storage');
      this.q = Clerk.lib('q');
      this.api = Clerk.lib('api');
      this._event_handlers = {
        '*': []
      };
      data = this.element.data();
      this._api = _pop(data, 'api');
      this._template = _pop(data, 'template');
      this._script_element_selector = _pop(data, 'template-scripts');
      this._target = _pop(data, 'target');
      this.target = this._target ? dom.find(this._target)[0] : this.element;
      this.useUrl = data['facets-in-url'];
      this._model = data;
      this.initial_limit = data['limit'];
      if (this._template && typeof this._template === 'string') {
        content_id = this._template.slice(1);
        loaded_contents = Clerk('config', 'contents');
        if ((loaded_contents != null) && content_id in loaded_contents) {
          this._api = loaded_contents[content_id].api;
          this._design_id = loaded_contents[content_id].template_id;
          if (this._design_id) {
            this.model('no_design', true);
          }
        }
      }
      if (history.state && history.state.namespace === 'clerk.js/content' && history.state[data['clerk-content-id']]) {
        limit = history.state[data['clerk-content-id']].limit;
        if (limit) {
          this.model('limit', limit);
        }
      }
      content_timestamp = window.location.search.match(/clerk_content_timestamp=([^&#]+)/);
      if (content_timestamp) {
        storage.set('content_timestamp', content_timestamp[1]);
      }
      if (storage.get('content_timestamp')) {
        this.model('content_timestamp', storage.get('content_timestamp'));
      }
      if (this.model('design')) {
        this._design_id = this.model('design');
      } else if (!this._template) {
        this._template = this.element.raw().innerHTML;
        this.model('attributes', _find_nested_attributes(this._template));
      } else if (this._template[0] === '@') {
        this.model('template', this._template.slice(1));
        this._template = null;
      } else {
        try {
          this._template = dom.find(this._template)[0].raw().innerHTML;
          if (this._script_element_selector) {
            ref = dom.find(this._script_element_selector);
            for (i = 0, len = ref.length; i < len; i++) {
              element = ref[i];
              this._template += '<script>' + element.raw().innerHTML + '</script>';
            }
          }
        } catch (error) {
          e = error;
          logger.error("Content: Could not find local template", {
            exception: e,
            templateSelector: this._template
          });
        }
        this.model('template', null);
        this.model('attributes', _find_nested_attributes(this._template));
      }
      if (this.element.attribute('id') == null) {
        this.element.attribute('id', this.model('template') != null ? this.model('template') : 'clerk-content-' + data['clerk-content-id']);
      }
      this.ident = this.element.attribute('id');
      this.logger = logger.component("Content " + this.ident);
      this.logger.log('Content initiated.');
      if (this._design_id) {
        this.load_design();
      }
    }

    Content.prototype.load_design = function() {
      var deferred, subscription_id;
      deferred = this.q.defer();
      subscription_id = 'design_' + this._design_id;
      if (Clerk('config', subscription_id)) {
        this.template = Clerk('config', subscription_id).results[0];
        this.render();
        return;
      }
      return Clerk('subscribe', subscription_id, this.call_design).then((function(_this) {
        return function(response) {
          _this.template = response.results[0];
          if (_this._response) {
            return _this.render();
          }
        };
      })(this));
    };

    Content.prototype.call_design = function() {
      var deferred;
      deferred = this.q.defer();
      if (this._design_id) {
        this.api.call('config/designs', {
          'ids': [this._design_id]
        }).then((function(_this) {
          return function(response) {
            return deferred.resolve(response);
          };
        })(this));
      }
      return deferred.promise;
    };

    Content.prototype.model = function(key, value) {
      var data, ref, ref1, ref2;
      if (typeof key === 'object') {
        if ((ref = this.logger) != null) {
          ref.log('Parameters updated.', {
            params: key
          });
        }
        data = key;
        for (key in data) {
          value = data[key];
          if (value === null) {
            delete this._model[key];
          } else {
            this._model[key] = value;
          }
        }
        return this.broadcast('model', data);
      } else if (value === null) {
        if ((ref1 = this.logger) != null) {
          ref1.log("Parameter '" + key + "' deleted.");
        }
        delete this._model[key];
        return this.broadcast('model', {
          key: value
        });
      } else if (value != null) {
        if ((ref2 = this.logger) != null) {
          ref2.log("Parameter '" + key + "' updated.", {
            param: key,
            value: value
          });
        }
        this._model[key] = value;
        return this.broadcast('model', {
          key: value
        });
      } else if (key) {
        return this._model[key];
      } else {
        return this._model;
      }
    };

    Content.prototype.on = function(name) {
      var deferred, q;
      q = Clerk.lib('q');
      deferred = q.defer();
      if (!this._event_handlers[name]) {
        this._event_handlers[name] = [];
      }
      this._event_handlers[name].push(function() {
        var args;
        args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
        return deferred.resolve.apply(deferred, args)[0];
      });
      return deferred.promise;
    };

    Content.prototype.broadcast = function(type, data) {
      var handler, handlers, i, len;
      handlers = this._event_handlers['*'];
      if (this._event_handlers[type]) {
        handlers = handlers.concat(this._event_handlers[type]);
      }
      for (i = 0, len = handlers.length; i < len; i++) {
        handler = handlers[i];
        if (handler(type, data) === false) {
          return false;
        }
      }
      return true;
    };

    Content.prototype.reload = function() {
      var deferred, q;
      q = Clerk.lib('q');
      deferred = q.defer();
      this.update().then((function(_this) {
        return function() {
          _this.render();
          return deferred.resolve();
        };
      })(this), (function(_this) {
        return function(failure) {
          return deferred.reject(failure);
        };
      })(this));
      return deferred.promise;
    };

    Content.prototype.update = function() {
      var deferred, update_version;
      deferred = this.q.defer();
      if (this.broadcast('update')) {
        this.logger.log('Update main products.', {
          api: this._api,
          args: this.model()
        });
        update_version = +new Date();
        this.latest_version = update_version;
        if (this.model('limit') && this.model('limit') !== this.initial_limit) {
          this.save_limit(this.model('limit'), this.model('clerk-content-id'));
        }
        this.api.call((this._api ? this._api : ''), _sendable_model(this.model())).then((function(_this) {
          return function(response) {
            if (update_version < _this.latest_version) {
              return;
            }
            if (!_this.broadcast('response', response)) {
              return;
            }
            _this._response = response;
            return deferred.resolve(response);
          };
        })(this), (function(_this) {
          return function(failure) {
            _this.broadcast('response', failure);
            return deferred.reject(failure);
          };
        })(this));
      }
      return deferred.promise;
    };

    Content.prototype.render = function() {
      var content, content_styling, context, data, dom, e, error, formatters, globals, i, index, j, len, len1, loop_template, model, product_loop, product_loop_replacements, product_loops, product_variable_name, products, replace_loop_template, replacement, response, template, template_lib;
      if (!this.broadcast('render')) {
        return;
      }
      dom = Clerk.lib('dom');
      template_lib = Clerk.lib('template');
      response = this._response;
      if (!response) {
        return;
      }
      products = [];
      if (this.model('api_version') === 'v3') {
        for (index in response.results) {
          if (index === 'products' && response.results[index].result) {
            products = products.concat(response.results[index].result);
          }
        }
      }
      if (response.product_data) {
        products = (function() {
          var i, len, ref, results;
          ref = response.product_data;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            data = ref[i];
            results.push(data);
          }
          return results;
        })();
      } else if (response.result) {
        products = response.result;
      }
      if (!this.model('limit') && response.result) {
        this.model('limit', response.result.length);
      }
      if (this.template) {
        template = this.template.html;
        content_styling = this.template.css;
      } else {
        template = response.template ? response.template : this._template;
        content_styling = response.content_styling ? response.content_styling : null;
      }
      if (!template) {
        return;
      }
      if (template.indexOf('#if ') > -1 || template.indexOf('#is ') > -1 || template.indexOf('#each ') > -1) {
        this.logger.error('Unsupported template language!', {
          more_info: 'The formatting language used in this looks like a Clerk.js v1 style template which is not compatible with Clerk.js v2. Please see https://docs.clerk.io/docs/clerkjs-template-language for more info on the template language used by Clerk.js v2.',
          template: template
        });
        return;
      }
      product_loops = __find_all_product_loops(template);
      product_loop_replacements = [];
      for (i = 0, len = product_loops.length; i < len; i++) {
        product_loop = product_loops[i];
        loop_template = template.substring(product_loop.start, product_loop.end);
        replace_loop_template = loop_template;
        product_variable_name = (/\{%\s*for\s+(\S+)\s+in\s+products\s*%\}/.exec(loop_template))[1];
        replace_loop_template = loop_template.replace(/<(?:button|a)\s/gm, function(match) {
          return match + (" data-clerk-product-id=\"{{ " + product_variable_name + ".id }}\" ");
        });
        product_loop_replacements.push({
          original: loop_template,
          replacement: replace_loop_template
        });
      }
      for (j = 0, len1 = product_loop_replacements.length; j < len1; j++) {
        replacement = product_loop_replacements[j];
        template = template.replace(replacement.original, replacement.replacement);
      }
      model = this.model();
      formatters = Clerk('config', 'formatters');
      globals = Clerk('config', 'globals');
      context = {};
      _merge_dictionary(context, response.content_data);
      _merge_dictionary(context, response);
      _merge_dictionary(context, model);
      _merge_dictionary(context, globals);
      _merge_dictionary(context, formatters);
      if (response.facet_context) {
        _merge_dictionary(context, response.facet_context);
      }
      context.products = products;
      context.response = response;
      context.content = model;
      context.content.id = this.ident;
      context.formatters = formatters;
      context.globals = globals;
      this.logger.log('Render content template.', {
        template: template,
        context: context
      });
      content = template_lib.compile(template, formatters)(context);
      try {
        this.target.html(content);
      } catch (error) {
        e = error;
        this.logger.error("Could not find target for template \n", {
          args: e
        });
      }
      if (content_styling != null) {
        dom.css(content_styling);
      }
      Clerk('click', '*[data-clerk-product-id]');
      return this.broadcast('rendered', context);
    };

    Content.prototype.save_limit = function(new_limit, content_id) {
      var data;
      if (!new_limit) {
        return;
      }
      if (!history.state || !history.state.namespace === 'clerk.js/content') {
        data = {
          namespace: 'clerk.js/content'
        };
      } else {
        data = history.state;
      }
      data[content_id] = {
        limit: new_limit,
        content_id: content_id
      };
      return window.history.replaceState(data, null);
    };

    return Content;

  })();

  _merge_dictionary = function(dictionary_1, dictionary_2) {
    var k, results, v;
    results = [];
    for (k in dictionary_2) {
      v = dictionary_2[k];
      if (!dictionary_1[k]) {
        results.push(dictionary_1[k] = v);
      } else {
        results.push(void 0);
      }
    }
    return results;
  };

  _sendable_model = function(model) {
    var ret_model;
    ret_model = JSON.parse(JSON.stringify(model));
    if ((ret_model.categories != null) && typeof ret_model.categories === 'object') {
      delete ret_model.categories;
    }
    if ((ret_model.pages != null) && typeof ret_model.pages === 'object') {
      delete ret_model.pages;
    }
    return ret_model;
  };

  __find_all_product_loops = function(template) {
    var _indexOfAll, for_loops_end, for_loops_start, i, inner_loops, j, len, len1, loop_end, loop_start, loops, product_for_loops_start, s;
    _indexOfAll = function(string, regexp) {
      var indexes, match;
      indexes = [];
      while ((match = regexp.exec(string))) {
        indexes.push({
          start: match.index,
          end: match.index + match[0].length
        });
      }
      return indexes;
    };
    for_loops_start = _indexOfAll(template, /\{%\s*for\s+(\S+)\s+in\s+(\S+)\s*%\}/g);
    for_loops_end = _indexOfAll(template, /\{%\s*endfor\s*%\}/g);
    product_for_loops_start = _indexOfAll(template, /\{%\s*for\s+(\S+)\s+in\s+products\s*%\}/g);
    loops = [];
    for (i = 0, len = product_for_loops_start.length; i < len; i++) {
      loop_start = product_for_loops_start[i];
      inner_loops = 0;
      for (j = 0, len1 = for_loops_end.length; j < len1; j++) {
        loop_end = for_loops_end[j];
        if (inner_loops > 0) {
          inner_loops -= 1;
        } else if (loop_end.start > loop_start.start) {
          inner_loops += ((function() {
            var l, len2, results;
            results = [];
            for (l = 0, len2 = for_loops_start.length; l < len2; l++) {
              s = for_loops_start[l];
              if (s.start > loop_start.start && s.start < loop_end.start) {
                results.push(s);
              }
            }
            return results;
          })()).length;
        }
        if (loop_end.start > loop_start.start && inner_loops === 0) {
          loops.push({
            start: loop_start.start,
            end: loop_end.end
          });
          break;
        }
      }
    }
    return loops;
  };

  _find_nested_attributes = function(template) {
    var attribute, i, j, len, len1, nested_attribute, possible_attributes, ref, template_lib, unique_attributes;
    template_lib = Clerk.lib('template');
    possible_attributes = ['id'];
    ref = template_lib.attributes(template);
    for (i = 0, len = ref.length; i < len; i++) {
      attribute = ref[i];
      nested_attribute = attribute.split(".")[1];
      while (nested_attribute) {
        possible_attributes.push(nested_attribute);
        nested_attribute = nested_attribute.split(".")[1];
      }
    }
    unique_attributes = [];
    for (j = 0, len1 = possible_attributes.length; j < len1; j++) {
      attribute = possible_attributes[j];
      if (indexOf.call(unique_attributes, attribute) < 0) {
        unique_attributes.push(attribute);
      }
    }
    return unique_attributes;
  };

  _pop = function(obj, key) {
    var value;
    value = obj[key];
    delete obj[key];
    return value;
  };

}).call(this);

/*
 * File: src/ui/slider.coffee 
 */
(function() {
  var Clerk, SLIDER_STYLING, Slider, _parsePixelValue, _slider_id_counter;

  Clerk = window.Clerk;

  _slider_id_counter = 0;

  Clerk.lib('ui.slider', {
    create: function(element) {
      return new Slider(element);
    }
  });

  Slider = (function() {
    function Slider(element1) {
      var dom, i, item, j, len, len1, next_element, prev_element, ref, ref1, url_params;
      this.element = element1;
      dom = Clerk.lib('dom');
      dom.css(SLIDER_STYLING);
      this.items = this.element.children();
      this.current_offset = 0;
      this.current_item = 0;
      url_params = decodeURIComponent(window.location.search.replace('?new_slider=', ''));
      this.new_slider = url_params === 'true';
      if (this.new_slider) {
        this.slider_viewport = dom.create('<div id="clerk-slider-viewport" class="clerk-slider-viewport"></div>')[0];
        this.element.parent().append(this.slider_viewport);
        this.slider_viewport.append(this.element);
        this.element["class"]().add('clerk-slider-new');
        this.element["class"]().remove('clerk-slider');
        this.slider_viewport.css('height', (this.element.children()[0].raw().clientHeight) + "px");
        ref = this.items;
        for (i = 0, len = ref.length; i < len; i++) {
          item = ref[i];
          item["class"]().add('clerk-slider-item-new');
        }
        prev_element = dom.create('<div class="clerk-slider-nav clerk-slider-nav-prev">&nbsp;</div>')[0];
        prev_element.on('click').then((function(_this) {
          return function() {
            return _this.prev_new();
          };
        })(this));
        this.slider_viewport.append(prev_element);
        next_element = dom.create('<div class="clerk-slider-nav clerk-slider-nav-next">&nbsp;</div>')[0];
        next_element.on('click').then((function(_this) {
          return function() {
            return _this.next_new();
          };
        })(this));
        this.slider_viewport.append(next_element);
      } else {
        if (!this.element["class"]().has('clerk-slider')) {
          this.element["class"]().add('clerk-slider');
        }
        ref1 = this.items;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          item = ref1[j];
          item["class"]().add('clerk-slider-item');
        }
        prev_element = dom.create('<div class="clerk-slider-nav clerk-slider-nav-prev">&nbsp;</div>')[0];
        prev_element.on('click').then((function(_this) {
          return function() {
            return _this.prev();
          };
        })(this));
        this.element.append(prev_element);
        next_element = dom.create('<div class="clerk-slider-nav clerk-slider-nav-next">&nbsp;</div>')[0];
        next_element.on('click').then((function(_this) {
          return function() {
            return _this.next();
          };
        })(this));
        this.element.append(next_element);
      }
      this.element.swipe().update((function(_this) {
        return function(dx, dy) {
          var k, len2, max, new_x, ref2, results;
          if (_this.new_slider) {
            max = -Math.abs((_this.items.length * _this.items[0].raw().clientWidth) - _this.slider_viewport.raw().clientWidth);
            new_x = _this.current_offset + dx;
            if (new_x > 0) {
              new_x = 0;
            }
            if (new_x < max) {
              new_x = max;
            }
            _this.element.css('transform', "translateX(" + new_x + "px)");
            return _this.element.css('transition', 'all 0s ease 0s');
          } else {
            new_x = _this.current_offset + dx;
            ref2 = _this.items;
            results = [];
            for (k = 0, len2 = ref2.length; k < len2; k++) {
              item = ref2[k];
              item.css('transition', 'none');
              results.push(item.css('left', new_x + "px"));
            }
            return results;
          }
        };
      })(this)).then((function(_this) {
        return function(dx, dy) {
          if (dx > 20 || dx < -20) {
            _this.current_offset = _this.current_offset + dx;
            _this.current_item = Math.floor(Math.abs(_this.current_offset / _this.items[0].raw().clientWidth));
            if (_this.new_slider) {
              return _this._move_to(_this.current_item);
            } else {
              return _this._move_to(_this._item_n_from_px(_this.current_offset, dx));
            }
          }
        };
      })(this));
    }

    Slider.prototype.next = function() {
      return this._move_to(this._get_next_item(1));
    };

    Slider.prototype.prev = function() {
      return this._move_to(this._get_next_item(-1));
    };

    Slider.prototype.next_new = function() {
      var max, n, new_position;
      max = -Math.abs((this.items.length * this.items[0].raw().clientWidth) - this.slider_viewport.raw().clientWidth);
      n = this._get_next_item_new(1, this.current_item);
      if (n < 0 || n >= this.items.length) {
        return;
      }
      new_position = -Math.abs(n * this.items[0].raw().clientWidth);
      if (new_position > 0) {
        new_position = 0;
      }
      if (new_position < max) {
        new_position = max;
      }
      this.element.css('transform', "translateX(" + new_position + "px)");
      this.element.css('transition', 'all 1s ease 0s');
      this.current_offset = new_position;
      return this.current_item = n;
    };

    Slider.prototype.prev_new = function() {
      var max, n, new_position;
      max = -Math.abs((this.items.length * this.items[0].raw().clientWidth) - this.slider_viewport.raw().clientWidth);
      n = this._get_next_item_new(-1, this.current_item);
      if (n < 0 || n >= this.items.length) {
        return;
      }
      new_position = -Math.abs(n * this.items[0].raw().clientWidth);
      if (new_position > 0) {
        new_position = 0;
      }
      if (new_position < max) {
        new_position = max;
      }
      this.element.css('transform', "translateX(" + new_position + "px)");
      this.element.css('transition', 'all 1s ease 0s');
      this.current_offset = new_position;
      return this.current_item = n;
    };

    Slider.prototype._item_n_from_px = function(px, dx) {
      var info, item_n, item_number;
      info = this._get_info();
      if (dx > 0) {
        item_number = Math.floor(px / info.item_width * -1);
      } else {
        item_number = Math.ceil(px / info.item_width * -1);
      }
      item_n = Math.min(Math.max(item_number, 0), info.max_scroll_item);
      if (item_number > info.max_scroll_item) {
        item_n = 0;
      }
      return item_n;
    };

    Slider.prototype._move_to = function(n) {
      var i, item, item_n_offset, len, ref, results;
      if (n < 0 || n >= this.items.length) {
        return;
      }
      item_n_offset = this.items[0].raw().getBoundingClientRect().x - this.items[n].raw().getBoundingClientRect().x;
      this.current_offset = item_n_offset;
      ref = this.items;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        item = ref[i];
        item.css('transition', 'left 300ms linear');
        results.push(item.css('left', item_n_offset + "px"));
      }
      return results;
    };

    Slider.prototype._get_next_item_new = function(direction, current) {
      var info, next_item;
      info = this._get_info_new();
      if (direction > 0) {
        next_item = current + info.visible_items - 1;
        if (next_item === current) {
          next_item += 1;
        }
        if (next_item > info.max_scroll_item) {
          next_item = info.max_scroll_item;
        }
      } else {
        next_item = current - info.visible_items;
        if (next_item === current) {
          next_item -= 1;
        }
        if (next_item < 0) {
          next_item = 0;
        }
      }
      return next_item;
    };

    Slider.prototype._get_next_item = function(direction) {
      var info, next_item;
      info = this._get_info();
      if (direction > 0) {
        next_item = info.current_item + info.visible_items;
        if (next_item === info.current_item) {
          next_item += 1;
        }
        if (info.current_item === info.max_scroll_item) {
          next_item = 0;
        } else if (next_item > info.max_scroll_item) {
          next_item = info.max_scroll_item;
        }
      } else {
        next_item = info.current_item - info.visible_items;
        if (next_item === info.current_item) {
          next_item -= 1;
        }
        if (next_item < 0 && info.current_item === 0) {
          next_item = info.max_scroll_item;
        } else if (next_item < 0) {
          next_item = 0;
        }
      }
      return next_item;
    };

    Slider.prototype._get_info_new = function() {
      var current_item, item_width, max_scroll_item, no_items, slider_offset, slider_visible_area_width, visible_items;
      slider_visible_area_width = this.element.size().inner.width;
      no_items = this.items.length;
      item_width = this.items[0].size().outer.width;
      slider_offset = this.current_offset;
      slider_visible_area_width = this.slider_viewport.size().inner.width;
      visible_items = Math.floor(slider_visible_area_width / item_width + 0.2);
      max_scroll_item = no_items - visible_items;
      current_item = Math.min(Math.abs(Math.floor(slider_offset / item_width + 0.2)), max_scroll_item);
      return {
        slider_visible_area_width: slider_visible_area_width,
        no_items: no_items,
        item_width: item_width,
        slider_offset: slider_offset,
        visible_items: visible_items,
        max_scroll_item: max_scroll_item,
        current_item: current_item
      };
    };

    Slider.prototype._get_info = function() {
      var current_item, item_width, max_scroll_item, no_items, slider_offset, slider_visible_area_width, visible_items;
      slider_visible_area_width = this.element.size().inner.width;
      no_items = this.items.length;
      item_width = this.items[0].size().outer.width;
      slider_visible_area_width = this.element.size().inner.width;
      slider_offset = _parsePixelValue(this.items[0].css('left'));
      visible_items = Math.floor(slider_visible_area_width / item_width + 0.2);
      max_scroll_item = no_items - visible_items;
      current_item = Math.min(Math.abs(Math.floor(slider_offset / item_width + 0.2)), max_scroll_item);
      return {
        slider_visible_area_width: slider_visible_area_width,
        no_items: no_items,
        item_width: item_width,
        slider_offset: slider_offset,
        visible_items: visible_items,
        max_scroll_item: max_scroll_item,
        current_item: current_item
      };
    };

    return Slider;

  })();

  _parsePixelValue = function(value) {
    return parseInt(value.replace('px', ''));
  };

  SLIDER_STYLING = ".clerk-slider-viewport { overflow: hidden; position: relative; touch-action: pan-y; } .clerk-slider { overflow: hidden; white-space: nowrap; position: relative; } .clerk-slider-new { position: absolute; will-change: transform; width: 100%; height: 100%; cursor: grab; display: flex; transform: translateX(0%); left: 0px; transition: all 1s ease 0s; } .clerk-slider-item { display: inline-block; position: relative; left: 0px; float: none !important; vertical-align: top; white-space: normal; transition: left 300ms linear; } .clerk-slider-item-new { padding: 0px; left: 0px; transform: translateX(0%); display: flex; flex-direction: column; } .clerk-slider-nav { position: absolute; top: 40%; cursor: pointer; z-index: 1; background-image: url(//cdn.clerk.io/arrows.png); background-repeat: no-repeat; width: 44px; height: 44px; } .clerk-slider-nav-next { background-position: -44px 0px; } .clerk-slider-nav-next:hover { background-position: -44px -44px; } .clerk-slider-nav-next { right: 5px; } .clerk-slider-nav-prev:hover { background-position: 0px -44px; } .clerk-slider-nav-prev { left: 5px; }";

}).call(this);

/*
 * File: src/ui/range.coffee 
 */
(function() {
  var Clerk, RANGE_STYLING, RANGE_TEMPLATE, Range;

  Clerk = window.Clerk;

  Clerk.lib('ui.range', {
    create: function(element) {
      return new Range(element);
    }
  });

  Range = (function() {
    function Range(element1, min1, max1, step, start1, end1) {
      var body, cap, data, diff, move, nearest, setup, teardown, unify;
      this.element = element1;
      this.min = min1;
      this.max = max1;
      this.step = step;
      this.start = start1;
      this.end = end1;
      this.q = Clerk.lib('q');
      this.dom = Clerk.lib('dom');
      this.logger = Clerk.lib('logger').component("Range");
      data = this.element.data();
      if (this.min == null) {
        this.min = data.min != null ? data.min : 0;
      }
      if (this.max == null) {
        this.max = data.max != null ? data.max : 100;
      }
      if (this.step == null) {
        this.step = data.step != null ? data.step : 1;
        if (this.step === 'auto') {
          diff = this.max - this.min;
          this.step = (function() {
            switch (false) {
              case !(diff < 50):
                return 1;
              case !(diff < 100):
                return 5;
              case !(diff < 500):
                return 10;
              case !(diff < 1000):
                return 50;
              default:
                return 100;
            }
          })();
        }
      }
      if (this.start == null) {
        this.start = data.start != null ? data.start : this.min;
      }
      if (this.end == null) {
        this.end = data.end != null ? data.end : this.max;
      }
      this.deferred = this.q.defer();
      this.update = this.deferred.promise;
      if (!this.element["class"]().has('clerk-range')) {
        this.element["class"]().add('clerk-range');
      }
      this.dom.css(RANGE_STYLING);
      this.element.html(RANGE_TEMPLATE);
      this.inverse_left = this.element.find('.clerk-range-inverse-left')[0];
      this.dot_left = this.element.find('.clerk-range-dot-left')[0];
      this.label_left = this.element.find('.clerk-range-label-left')[0];
      this.selected_range = this.element.find('.clerk-range-selected-range')[0];
      this.dot_right = this.element.find('.clerk-range-dot-right')[0];
      this.label_right = this.element.find('.clerk-range-label-right')[0];
      this.inverse_right = this.element.find('.clerk-range-inverse-right')[0];
      this.moving_left = false;
      this.moving_right = false;
      cap = function(x, _min, _max) {
        return Math.max(_min, Math.min(x, _max));
      };
      nearest = function(x, mod) {
        return Math.round(x / parseFloat(mod)) * mod;
      };
      unify = (function(_this) {
        return function(e) {
          if (e.changedTouches) {
            return e.changedTouches[0];
          } else {
            return e;
          }
        };
      })(this);
      setup = (function(_this) {
        return function(event) {
          var inner_width, position_left;
          position_left = _this.element.position().left;
          inner_width = _this.element.size().inner.width;
          _this.slider_bound_left = position_left;
          _this.slider_bound_right = position_left + inner_width;
          _this.dot_offset_left = _this.start - _this.min;
          _this.dot_offset_right = _this.end - _this.max;
          _this.px_per_unit = inner_width / (_this.max - _this.min);
          return _this.mouse_start_x = unify(event.raw()).clientX;
        };
      })(this);
      this.dot_left.on('mousedown').then((function(_this) {
        return function(event) {
          setup(event);
          return _this.moving_left = true;
        };
      })(this));
      this.dot_right.on('mousedown').then((function(_this) {
        return function(event) {
          setup(event);
          return _this.moving_right = true;
        };
      })(this));
      this.dot_left.on('touchstart').then((function(_this) {
        return function(event) {
          setup(event);
          return _this.moving_left = true;
        };
      })(this));
      this.dot_right.on('touchstart').then((function(_this) {
        return function(event) {
          setup(event);
          return _this.moving_right = true;
        };
      })(this));
      body = this.dom.find('body')[0];
      move = (function(_this) {
        return function(x) {
          var diff_px, diff_unit, end, start;
          if (!_this.moving_right && !_this.moving_left) {
            return;
          }
          if (x < _this.slider_bound_left || _this.slider_bound_right < x) {
            return;
          }
          diff_px = x - _this.mouse_start_x;
          diff_unit = diff_px / _this.px_per_unit;
          if (_this.moving_left) {
            start = nearest(cap(_this.min + _this.dot_offset_left + diff_unit, _this.min, _this.end - _this.step), _this.step);
            if (_this.start !== start) {
              _this.start = start;
              _this.render();
            }
          }
          if (_this.moving_right) {
            end = nearest(cap(_this.max + _this.dot_offset_right + diff_unit, _this.start + _this.step, _this.max), _this.step);
            if (_this.end !== end) {
              _this.end = end;
              return _this.render();
            }
          }
        };
      })(this);
      teardown = (function(_this) {
        return function() {
          if (_this.moving_left || _this.moving_right) {
            _this.moving_left = false;
            _this.moving_right = false;
            return _this.deferred.resolve(_this.start, _this.end);
          }
        };
      })(this);
      body.on('mousemove').then((function(_this) {
        return function(event) {
          return move(event.raw().clientX);
        };
      })(this));
      body.on('touchmove').then((function(_this) {
        return function(event) {
          return move(unify(event.raw()).clientX);
        };
      })(this));
      body.on('mouseup').then((function(_this) {
        return function() {
          return teardown();
        };
      })(this));
      body.on('touchend').then((function(_this) {
        return function() {
          return teardown();
        };
      })(this));
      body.on('mouseleave').then((function(_this) {
        return function() {
          return teardown();
        };
      })(this));
      this.render();
      return this.deferred.promise;
    }

    Range.prototype.render = function() {
      var _range_end_pct, _range_start_pct, _total, end, max, min, start;
      min = this.min;
      max = this.max;
      start = this.start;
      end = this.end;
      _total = max - min;
      _range_start_pct = (start - min) / _total * 100;
      _range_end_pct = (end - min) / _total * 100;
      this.inverse_left.css('width', ((start - min) / _total * 100) + "%");
      this.dot_left.css('left', "calc(" + _range_start_pct + "% - .75em)");
      this.selected_range.css('left', _range_start_pct + "%");
      this.selected_range.css('width', ((end - start) / _total * 100) + "%");
      this.dot_right.css('left', "calc(" + _range_end_pct + "% - .75em)");
      this.inverse_right.css('left', _range_end_pct + "%");
      this.inverse_right.css('width', ((max - end) / _total * 100) + "%");
      this.label_left.text(this.start);
      return this.label_right.text(this.end);
    };

    return Range;

  })();

  RANGE_TEMPLATE = '<div class="clerk-range-inverse-left"></div> <div class="clerk-range-dot-left"> <div class="clerk-range-label-left"></div> </div> <div class="clerk-range-selected-range"></div> <div class="clerk-range-dot-right"> <div class="clerk-range-label-right"></div> </div> <div class="clerk-range-inverse-right"></div>';

  RANGE_STYLING = '.clerk-range { position: relative; width: 100%; height: 2.5em; padding-top: 1.5em; } .clerk-range > * { position: absolute; } .clerk-range-dot-left, .clerk-range-dot-right { z-index: 1; width: 1.5em; height: 1.5em; border-radius: 50%; background-color: #FFF; box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4); cursor: grab; user-select: none; } .clerk-range-dot-left:active, .clerk-range-dot-right:active { cursor: grabbing; } .clerk-range-label-left, .clerk-range-label-right { position: relative; bottom: 2em; right: .6em; width: 3em; padding: .1em; background-color: #FFF; box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2); border-radius: .2em; text-align: center; font-size: .8em; } .clerk-range-inverse-left, .clerk-range-selected-range, .clerk-range-inverse-right { height: .5em; margin: .5em 0; border-radius: .25em; } .clerk-range-selected-range { background-color: #95a5a6; } .clerk-range-inverse-left, .clerk-range-inverse-right { background-color: #eee; }';

}).call(this);

/*
 * File: src/ui/popup.coffee 
 */
(function() {
  var Clerk, POPUP_STYLING, Popup;

  Clerk = window.Clerk;

  Clerk.lib('ui.popup', {
    create: function(element) {
      return new Popup(element);
    }
  });

  Popup = (function() {
    function Popup(element1, duration) {
      this.element = element1;
      this.duration = duration != null ? duration : 250;
      this.dom = Clerk.lib('dom');
      this.logger = Clerk.lib('logger').component("Popup");
      if (!this.element["class"]().has('clerk-popup')) {
        this.element["class"]().add('clerk-popup');
      }
      this.dom.css(POPUP_STYLING);
      this.logger.log('Initialised popup', {
        element: this.element
      });
      if (!this.element["class"]().has('clerk-popup-hidden')) {
        this.show();
      }
      this.element.on('click').then((function(_this) {
        return function(event) {
          _this.logger.log('Click inside popup, stopping propgation', {
            element: _this.element
          });
          return event.stopPropagation(true);
        };
      })(this));
      this.dom.find("body")[0].on('click').then((function(_this) {
        return function() {
          _this.logger.log('Detected click outside element', {
            element: _this.element
          });
          return _this.hide();
        };
      })(this));
    }

    Popup.prototype.show = function() {
      var close_button;
      this.element["class"]().remove('clerk-popup-hidden');
      this.element["class"]().add('clerk-popup-visible');
      this.logger.log('Showing popup', {
        element: this.element
      });
      if (this.dom.find("clerk-popup-close").length === 0) {
        close_button = this.dom.create('<span class="clerk-popup-close">&times;</span>')[0];
        this.element.prepend(close_button);
        this.logger.log('Adding close button', {
          element: this.element,
          button: close_button
        });
        return close_button.on('click').then((function(_this) {
          return function(event) {
            event.stopPropagation();
            return _this.hide();
          };
        })(this));
      }
    };

    Popup.prototype.hide = function() {
      this.element["class"]().remove('clerk-popup-visible');
      this.element["class"]().add('clerk-popup-hidden');
      return this.logger.log('Hiding popup', {
        element: this.element
      });
    };

    return Popup;

  })();

  POPUP_STYLING = '.clerk-popup { position: fixed; top: 10%; z-index: 16777271; display: none; width: 90%; padding: 20px; margin: 0 5%; background-color: white; border :1px solid #eee; border-radius: 5px; box-shadow: 0px 8px 40px 0px rgba(0,0,60,0.15); } .clerk-popup-close { position: absolute; right: 8px; top: 3px; cursor: pointer; font-family: Arial; font-size: 32px; line-height: 1; color: gray; } .clerk-popup-hidden { display: none; } .clerk-popup-visible { display: block; }';

}).call(this);

/*
 * File: src/ui/content/omnisearch.coffee 
 */

/*
Content Manager than manages the omnisearch functionality.
 */

(function() {
  var Clerk, DEFAULT_WRAPPER_CSS, Facet, FacetGroup, OmniSearch, _get_title, _get_url_param, _set_url_param, _to_filter,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  Clerk = window.Clerk;

  Clerk.lib('ui.content.omnisearch', {
    create: function(content) {
      return new OmniSearch(content);
    }
  });

  OmniSearch = (function() {
    function OmniSearch(content1) {
      var exisiting_overlays, facet, facets, fn, group, i, j, l, len, len1, len2, m, ref, ref1, ref2, template_id, title, trigger_element, trigger_selector;
      this.content = content1;
      this.dom = Clerk.lib('dom');
      this.storage = Clerk.lib('storage');
      this.utils = Clerk.lib('utils');
      this.facet_tools = Clerk.lib('facet_tools');
      this.template_lib = Clerk.lib('template');
      this.content.model('api_version', 'v3');
      this.user_activity = false;
      this.sorting = {};
      this.no_url = Clerk.config('omnisearch_ignore_url_persistence') ? true : false;
      this.facet_groups = {};
      this.titles = this.content.model('facets-titles');
      if (!this.titles) {
        this.titles = {};
      }
      this.groups = this.content.model('facets-attributes');
      if (!this.groups) {
        this.groups = [];
      }
      template_id = this.content.model('template');
      facets = Clerk.config('omnisearch-facets-' + template_id);
      if (facets) {
        for (i in facets) {
          facet = facets[i];
          for (group in facet) {
            title = facet[group];
            if (group === 'price') {
              group = '_price_range';
            }
            if (group === 'categories') {
              group = '_category_name';
            }
            this.titles[group] = title;
            this.groups.push(group);
          }
        }
      }
      this.facets_stats = {};
      this.dom.css(DEFAULT_WRAPPER_CSS);
      exisiting_overlays = this.dom.find('.clerk-omnisearch-overlay');
      if (exisiting_overlays.length > 0) {
        this.content.on('update').then((function(_this) {
          return function() {
            return false;
          };
        })(this));
        return;
      }
      this.overlay = document.createElement('div');
      this.overlay.classList.add('clerk-omnisearch-hidden');
      this.overlay.classList.add('clerk-omnisearch-overlay');
      document.body.appendChild(this.overlay);
      this.content.target = this.dom.find('.clerk-omnisearch-overlay')[0];
      this.trigger_elements = this.dom.create(this.content.element._element);
      ref = this.content.model('trigger-element').split(';');
      for (j = 0, len = ref.length; j < len; j++) {
        trigger_selector = ref[j];
        ref1 = this.dom.find(trigger_selector);
        for (l = 0, len1 = ref1.length; l < len1; l++) {
          trigger_element = ref1[l];
          if (this.trigger_elements.contains(trigger_element)) {
            continue;
          }
          this.trigger_elements.push(trigger_element);
        }
      }
      this.content.on('update').then((function(_this) {
        return function() {
          return _this.user_activity;
        };
      })(this));
      ref2 = this.trigger_elements;
      fn = (function(_this) {
        return function(trigger_element) {
          trigger_element.on('click').then(function() {
            _this.show();
            return _this.input_activity(trigger_element, 0);
          });
          return trigger_element.on('focus').then(function() {
            _this.show();
            return _this.input_activity(trigger_element, 0);
          });
        };
      })(this);
      for (m = 0, len2 = ref2.length; m < len2; m++) {
        trigger_element = ref2[m];
        fn(trigger_element);
      }
      window.addEventListener('keyup', (function(_this) {
        return function(event) {
          if (event.key === "Escape") {
            return _this._clear_all();
          }
        };
      })(this));
      window.addEventListener('popstate', (function(_this) {
        return function(event) {
          if (_this.is_shown) {
            _this.facet_groups = _this._transform_from_url({});
            return _this.content.reload();
          }
        };
      })(this));
      this.attributes = {};
      if (!this.content.template) {
        this.content.load_design().then((function(_this) {
          return function() {
            var attribute, len3, len4, n, o, ref3, ref4, results, split_attribute, template_attributes;
            template_attributes = _this.template_lib.attributes(_this.content.template.html);
            for (n = 0, len3 = template_attributes.length; n < len3; n++) {
              attribute = template_attributes[n];
              if (!(attribute)) {
                continue;
              }
              split_attribute = attribute.split('.');
              if (_this.attributes[split_attribute[0]] == null) {
                _this.attributes[split_attribute[0]] = [];
              }
              if (split_attribute.length === 2 && (ref3 = split_attribute[1], indexOf.call(_this.attributes[split_attribute[0]], ref3) < 0)) {
                _this.attributes[split_attribute[0]].push(split_attribute[1]);
              }
            }
            if (_this._get_url_query() || Object.keys(_this.facet_groups).length > 0) {
              ref4 = _this.trigger_elements;
              results = [];
              for (o = 0, len4 = ref4.length; o < len4; o++) {
                trigger_element = ref4[o];
                trigger_element._element.value = _this._get_url_query();
                if (_get_url_param('show_omnisearch') !== 'false') {
                  results.push(_this.input_activity(trigger_element, 0));
                } else {
                  results.push(void 0);
                }
              }
              return results;
            }
          };
        })(this));
      }
      this.content.on('update').then((function(_this) {
        return function() {
          var index_add;
          _this._searches = {};
          index_add = function(index) {
            var filter, index_limit, selected_facets;
            if (index !== 'products' && index !== 'categories' && index !== 'pages') {
              return;
            }
            _this.content.model(index, []);
            index_limit = _this.content.model('omni-search-' + index);
            _this._searches[index] = {
              index: index,
              attributes: (_this.attributes[index] != null) && _this.attributes[index] ? _this.attributes[index] : _this.content.model('attributes')
            };
            if ((_this.sorting[index] != null) && _this.sorting[index]) {
              _this._searches[index].sort = _this.sorting[index];
            }
            if ((index_limit != null) && index_limit) {
              _this._searches[index].limit = index_limit;
            }
            if (index === 'products') {
              if (_this.content.model('limit')) {
                _this._searches[index].limit = _this.content.model('limit');
              }
              filter = {};
              for (group in _this.facet_groups) {
                selected_facets = _this.facet_groups[group].get_selected();
                if (!selected_facets) {
                  continue;
                }
                filter[group] = selected_facets;
              }
              if (Object.keys(filter).length > 0) {
                _this._searches[index].filter = _to_filter(filter);
              }
              return _this._searches[index].facets = _this.groups.join(',');
            }
          };
          index_add('products');
          index_add('categories');
          index_add('pages');
          _this.content.model('searches', _this._searches);
          _this.content.model('query', _this._get_url_query());
          if (_this.content.template) {
            _this.content.model('attributes', null);
          }
          _this.content.model('products', null);
          return true;
        };
      })(this));
      this.content.on('response').then((function(_this) {
        return function(type, response) {
          var context, facet_groups, index, ref3;
          for (index in response.results) {
            if (response.results[index] != null) {
              _this.content.model(index, response.results[index].result);
            }
            if (((ref3 = response.results[index]) != null ? ref3.facets_stats : void 0) != null) {
              _this.facets_stats[index] = response.results[index].facets_stats;
            } else {
              _this.facets_stats[index] = {};
            }
            if (response.results[index].facets != null) {
              facets = response.results[index].facets;
            } else {
              facets = {};
            }
            facet_groups = _this._as_grouped_facets(facets, _this.facets_stats[index]);
            _this.facet_groups = _this._transform_from_url(facet_groups);
          }
          context = _this.facet_context();
          response.facet_context = context;
          _this.content._response = response;
          if (_this.input_field) {
            _this.content.target = _this.dom.find('#clerk-omnisearch-content', _this.overlay)[0];
          }
          _this.content.render();
          if (!_this.input_field) {
            return _this.find_input_field();
          } else {
            return _this.input_field._element.focus();
          }
        };
      })(this));
      this.content.on('rendered').then((function(_this) {
        return function() {
          return _this._add_design_listeners();
        };
      })(this));
      this.facet_groups = {};
      this.facet_groups = this._transform_from_url(this.facet_groups);
    }

    OmniSearch.prototype.facet_context = function() {
      var context, facet_context, group, language, text_search_for, text_show_more;
      facet_context = [];
      for (group in this.facet_groups) {
        facet_context.push(this.facet_groups[group].unpack());
      }
      language = Clerk.config('language');
      if (this.search_for_text) {
        text_search_for = this.search_for_text;
      } else {
        text_search_for = language != null ? this.facet_tools.translations()[language]['search'] : 'Search For';
      }
      if (this.show_more_text) {
        text_show_more = this.show_more_text;
      } else {
        text_show_more = language != null ? this.facet_tools.translations()[language]['more'] : 'Show More';
      }
      context = {
        facet_groups: facet_context,
        translation: {
          show_more: text_show_more,
          search_for: text_search_for
        },
        sorting: this.sorting
      };
      return context;
    };

    OmniSearch.prototype.input_activity = function(element, timeout) {
      if (timeout == null) {
        timeout = 250;
      }
      this.user_activity = true;
      clearTimeout(this._search_timeout);
      return this._search_timeout = setTimeout((function(_this) {
        return function() {
          var query;
          if (element.value()) {
            query = _this.utils.trim(element.value());
            _this._set_url_query(query);
          } else {
            _this._set_url_query(void 0);
          }
          return _this.content.update().then(function(response) {
            return _this.show();
          });
        };
      })(this), timeout);
    };

    OmniSearch.prototype.show = function() {
      this.is_shown = true;
      _set_url_param('show_omnisearch', 'true');
      this.overlay.classList.remove('clerk-omnisearch-hidden');
      this.overlay.classList.add('clerk-omnisearch-visible');
      return this.observe_visibility(this.overlay, this.add_resets);
    };

    OmniSearch.prototype.hide = function() {
      var j, len, ref, results, trigger_element;
      this.is_shown = false;
      _set_url_param('show_omnisearch', 'false');
      this.overlay.classList.remove('clerk-omnisearch-visible');
      this.overlay.classList.add('clerk-omnisearch-hidden');
      document.body.classList.remove('clerk-omnisearch-css-reset-body');
      document.documentElement.classList.remove('clerk-omnisearch-css-reset-html');
      ref = this.trigger_elements;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        trigger_element = ref[j];
        if (trigger_element && this._get_url_query()) {
          results.push(trigger_element._element.value = this._get_url_query());
        }
      }
      return results;
    };

    OmniSearch.prototype.add_resets = function(el) {
      document.body.classList.add('clerk-omnisearch-css-reset-body');
      return document.documentElement.classList.add('clerk-omnisearch-css-reset-html');
    };

    OmniSearch.prototype.observe_visibility = function(element, callback) {
      var observer;
      observer = new IntersectionObserver(function(entries, observer) {
        var entry, j, len, results;
        results = [];
        for (j = 0, len = entries.length; j < len; j++) {
          entry = entries[j];
          if (entry.intersectionRatio > 0) {
            callback(element);
            results.push(observer.disconnect());
          } else {
            results.push(void 0);
          }
        }
        return results;
      });
      observer.observe(element);
      if (!callback) {
        return new Promise(function(r) {
          return callback = r;
        });
      }
    };

    OmniSearch.prototype.find_input_field = function() {
      var assign_regex, frame_html, full_design, k, omnisearch_content_wrapper, parent_assignments, query, ref, template, unescape_entities, v, wrapper_html;
      if (this.input_field) {
        return;
      }
      this.input_field = this.dom.find('#clerk-omnisearch-input', this.overlay)[0];
      if (this.input_field) {
        this.input_field._element.focus();
        this.input_field.on('click').then((function(_this) {
          return function() {
            return _this.input_activity(_this.input_field, 0);
          };
        })(this));
        this.input_field.on('keyup').then((function(_this) {
          return function(event) {
            var ref;
            if ((event != null ? (ref = event._event) != null ? ref.key : void 0 : void 0) === "Escape") {
              return;
            }
            return _this.input_activity(_this.input_field, 200);
          };
        })(this));
        query = this._get_url_query();
        if (query) {
          this.input_field._element.value = query;
        }
      }
      template = this.content.template ? this.content.template.html : this.content._template;
      full_design = new DOMParser().parseFromString(template, 'text/html');
      omnisearch_content_wrapper = full_design.querySelector('#clerk-omnisearch-content');
      wrapper_html = omnisearch_content_wrapper != null ? omnisearch_content_wrapper.innerHTML : void 0;
      full_design.querySelector('#clerk-omnisearch-content').remove();
      frame_html = (ref = full_design.firstChild) != null ? ref.innerHTML : void 0;
      unescape_entities = {
        "&lt;": "<",
        "&gt;": ">",
        "&amp;": "&"
      };
      if (frame_html) {
        for (k in unescape_entities) {
          v = unescape_entities[k];
          frame_html = frame_html.replaceAll(k, v);
        }
      } else {
        frame_html = '';
      }
      assign_regex = /\{\%[\s]+assign[\s]+[^\s%]+ = [^%]+\%\}/g;
      parent_assignments = frame_html.match(assign_regex);
      if (parent_assignments) {
        parent_assignments = parent_assignments.join("");
      }
      if (wrapper_html) {
        for (k in unescape_entities) {
          v = unescape_entities[k];
          wrapper_html = wrapper_html.replaceAll(k, v);
        }
      }
      if (parent_assignments && wrapper_html) {
        wrapper_html = parent_assignments + wrapper_html;
      }
      if (this.content.template) {
        return this.content.template.html = wrapper_html;
      } else {
        return this.content._template = wrapper_html;
      }
    };

    OmniSearch.prototype._add_design_listeners = function() {
      var element, facet_clear, facet_search_input, fn, fn1, fn2, fn3, fn4, fn5, fn6, j, l, len, len1, len2, len3, len4, len5, len6, len7, m, n, o, p, q, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, results, s;
      ref = this.dom.find('.clerk-omnisearch-close', this.overlay);
      fn = (function(_this) {
        return function(element) {};
      })(this);
      for (j = 0, len = ref.length; j < len; j++) {
        element = ref[j];
        fn(element);
        element.on('click').then((function(_this) {
          return function() {
            return _this.hide();
          };
        })(this));
      }
      ref1 = this.dom.find('.clerk-omnisearch-sort', this.overlay);
      fn1 = (function(_this) {
        return function(element) {
          return element.on('change').then(function() {
            var sorting_index;
            sorting_index = element._element.getAttribute('data-sort-type');
            if (!sorting_index || (sorting_index !== 'products' && sorting_index !== 'categories' && sorting_index !== 'pages')) {
              sorting_index = "products";
            }
            _this.sorting[sorting_index] = element.value();
            return _this.content.reload();
          });
        };
      })(this);
      for (l = 0, len1 = ref1.length; l < len1; l++) {
        element = ref1[l];
        fn1(element);
      }
      ref2 = this.dom.find('.clerk-facet-search', this.overlay);
      fn2 = (function(_this) {
        return function(facet_search_input) {
          return facet_search_input.on('keyup').then(function(event) {
            var facet, facet_query, len3, n, ref3, results;
            facet_query = facet_search_input.value().trim().toLowerCase();
            ref3 = _this.dom.find('.clerk-facet', facet_search_input.parent().raw());
            results = [];
            for (n = 0, len3 = ref3.length; n < len3; n++) {
              facet = ref3[n];
              if (facet.text().toLowerCase().indexOf(facet_query) === -1) {
                results.push(facet["class"]().add('hidden'));
              } else {
                results.push(facet["class"]().remove('hidden'));
              }
            }
            return results;
          });
        };
      })(this);
      for (m = 0, len2 = ref2.length; m < len2; m++) {
        facet_search_input = ref2[m];
        fn2(facet_search_input);
      }
      ref3 = this.dom.find('.clerk-omnisearch-full-reset', this.overlay);
      fn3 = (function(_this) {
        return function(facet_clear) {
          return facet_clear.on('click').then(function() {
            var group;
            _this.input_field._element.value = '';
            _this._set_url_query(void 0);
            for (group in _this.facet_groups) {
              _this.facet_groups[group].clear_selected();
            }
            return _this.content.reload();
          });
        };
      })(this);
      for (n = 0, len3 = ref3.length; n < len3; n++) {
        facet_clear = ref3[n];
        fn3(facet_clear);
      }
      ref4 = this.dom.find('.clerk-omnisearch-facet-full-reset', this.overlay);
      fn4 = (function(_this) {
        return function(facet_clear) {
          return facet_clear.on('click').then(function() {
            var group;
            for (group in _this.facet_groups) {
              _this.facet_groups[group].clear_selected();
            }
            return _this.content.reload();
          });
        };
      })(this);
      for (o = 0, len4 = ref4.length; o < len4; o++) {
        facet_clear = ref4[o];
        fn4(facet_clear);
      }
      ref5 = this.dom.find('.clerk-omnisearch-facet-group-reset', this.overlay);
      fn5 = (function(_this) {
        return function(facet_clear) {
          return facet_clear.on('click').then(function() {
            var group, len6, q, ref6;
            group = facet_clear._element.getAttribute('data-facet-group');
            _this.facet_groups[group].clear_selected();
            ref6 = _this.dom.find('.clerk-facet', _this.overlay);
            for (q = 0, len6 = ref6.length; q < len6; q++) {
              element = ref6[q];
              element._element.classList.remove('clerk-facet-selected');
            }
            return _this.content.reload();
          });
        };
      })(this);
      for (p = 0, len5 = ref5.length; p < len5; p++) {
        facet_clear = ref5[p];
        fn5(facet_clear);
      }
      ref6 = this.dom.find('.clerk-omnisearch-facet-reset', this.overlay);
      fn6 = (function(_this) {
        return function(facet_clear) {
          return facet_clear.on('click').then(function() {
            var group, value;
            group = facet_clear._element.getAttribute('data-facet-group');
            value = facet_clear._element.getAttribute('data-facet-value');
            _this.facet_groups[group].click(value);
            return _this.content.reload();
          });
        };
      })(this);
      for (q = 0, len6 = ref6.length; q < len6; q++) {
        facet_clear = ref6[q];
        fn6(facet_clear);
      }
      ref7 = this.dom.find('.clerk-facet', this.overlay);
      results = [];
      for (s = 0, len7 = ref7.length; s < len7; s++) {
        element = ref7[s];
        results.push((function(_this) {
          return function(element) {
            return element.on('click').then(function() {
              var group, value;
              group = element._element.getAttribute('data-facet');
              value = element._element.getAttribute('data-value');
              _this.facet_groups[group].click(value);
              if (_this.facet_groups[group].selected_count) {
                _this.clicked_facetgroup = _this.facet_groups[group];
                _this.clicked_group = group;
              }
              element._element.classList.toggle('clerk-facet-selected');
              return _this.content.reload();
            });
          };
        })(this)(element));
      }
      return results;
    };

    OmniSearch.prototype._as_grouped_facets = function(raw_facets) {
      var facet, group, groups, j, len, no_url, ref;
      groups = {};
      for (group in raw_facets) {
        if (groups[group] == null) {
          groups[group] = new FacetGroup(group, _get_title(group, this.titles), no_url = this.no_url);
        }
        ref = raw_facets[group];
        for (j = 0, len = ref.length; j < len; j++) {
          facet = ref[j];
          groups[group].add(new Facet(facet.v, facet.c, group));
        }
      }
      if (this.clicked_group) {
        groups[this.clicked_group] = this.clicked_facetgroup;
      }
      this.clicked_group = null;
      this.clicked_facetgroup = null;
      return groups;
    };

    OmniSearch.prototype._get_url_query = function() {
      if (this.no_url) {
        return this.query;
      }
      return new URL(location.href).searchParams.get('clerk_query');
    };

    OmniSearch.prototype._set_url_query = function(query) {
      var url_object;
      if (this.no_url) {
        this.query = query;
        return;
      }
      url_object = new URL(window.location);
      if (query) {
        url_object.searchParams.set('clerk_query', query);
      } else {
        url_object.searchParams["delete"]('clerk_query');
      }
      return window.history.pushState({}, '', url_object.href);
    };

    OmniSearch.prototype._clear_all = function() {
      var group;
      this._set_url_query(void 0);
      this.input_field._element.value = '';
      for (group in this.facet_groups) {
        this.facet_groups[group].clear_selected();
      }
      return this.hide();
    };

    OmniSearch.prototype._transform_from_url = function(facet_groups) {
      var url_params;
      if (this.no_url) {
        return facet_groups;
      }
      url_params = new URLSearchParams(window.location.search);
      url_params.forEach((function(_this) {
        return function(value, key) {
          var no_url;
          if (indexOf.call(_this.groups, key) < 0) {
            return;
          }
          if (facet_groups[key] == null) {
            facet_groups[key] = new FacetGroup(key, _get_title(key, _this.titles), no_url = _this.no_url);
          }
          if (!facet_groups[key].exists(value)) {
            facet_groups[key].add(new Facet(value, 0, key));
          }
          if (!facet_groups[key].get(value).selected) {
            facet_groups[key].get(value).selected = true;
            return facet_groups[key].selected_count += 1;
          }
        };
      })(this));
      return facet_groups;
    };

    return OmniSearch;

  })();

  _get_url_param = function(name) {
    var url_object;
    url_object = new URL(window.location);
    return url_object.searchParams.get(name);
  };

  _set_url_param = function(name, value) {
    var url_object;
    url_object = new URL(window.location);
    url_object.searchParams.set(name, value);
    return window.history.pushState({}, '', url_object.href);
  };

  _get_title = function(name, titles) {
    if (titles[name] != null) {
      return titles[name];
    } else {
      return name;
    }
  };

  _to_filter = function(filter_struct) {
    var facet, filter, group, group_length;
    filter = [];
    for (group in filter_struct) {
      group_length = Object.keys(filter_struct[group]).length;
      if (group_length === 0) {
        continue;
      }
      if (group_length === 1) {
        for (facet in filter_struct[group]) {
          filter.push(group + "='" + filter_struct[group][facet] + "'");
        }
      }
      if (group_length > 1) {
        filter.push(group + " in [" + [
          (function() {
            var results;
            results = [];
            for (facet in filter_struct[group]) {
              results.push("'" + facet + "'");
            }
            return results;
          })()
        ] + ']');
      }
    }
    return filter.join(' and ');
  };

  Facet = (function() {
    function Facet(value1, count, group1) {
      this.value = value1;
      this.count = count;
      this.group = group1;
      this.selected = false;
    }

    Facet.prototype.unpack = function() {
      return {
        name: this.value,
        value: this.value,
        count: this.count,
        selected: this.selected
      };
    };

    Facet.prototype.hash = function() {
      return this.value;
    };

    return Facet;

  })();

  FacetGroup = (function() {
    function FacetGroup(name1, title1, no_url1, stats) {
      this.name = name1;
      this.title = title1;
      this.no_url = no_url1 != null ? no_url1 : false;
      if (stats == null) {
        stats = null;
      }
      this._group = {};
      this.selected_count = 0;
      if (!this.title) {
        this.title = this.name;
      }
      if (stats) {
        this.min = stats.min;
        this.max = stats.max;
      }
    }

    FacetGroup.prototype.get_selected = function() {
      var facet, facets, key, ref;
      facets = {};
      ref = this._group;
      for (key in ref) {
        facet = ref[key];
        if (facet.selected) {
          facets[key] = facet.value;
        }
      }
      return facets;
    };

    FacetGroup.prototype.clear_selected = function() {
      var facet, key, ref, url_object;
      url_object = new URL(window.location);
      ref = this._group;
      for (key in ref) {
        facet = ref[key];
        if (!facet.selected) {
          continue;
        }
        facet.selected = false;
        url_object.searchParams["delete"](this.name, facet.value);
      }
      return window.history.pushState({}, '', url_object.href);
    };

    FacetGroup.prototype.click = function(value) {
      var url_object;
      if (this._group[value] == null) {
        return;
      }
      if (this._group[value].selected) {
        this.selected_count -= 1;
      } else {
        this.selected_count += 1;
      }
      this._group[value].selected = !this._group[value].selected;
      if (this.no_url) {
        return;
      }
      url_object = new URL(window.location);
      if (this._group[value].selected) {
        url_object.searchParams.append(this.name, value);
      } else {
        url_object.searchParams["delete"](this.name, value);
      }
      return window.history.pushState({}, '', url_object.href);
    };

    FacetGroup.prototype.get = function(value) {
      return this._group[value];
    };

    FacetGroup.prototype.unpack = function() {
      var facet, facets, key, ref;
      facets = [];
      ref = this._group;
      for (key in ref) {
        facet = ref[key];
        facets.push(facet.unpack());
      }
      return {
        name: this.name,
        title: this.title,
        min: this.min,
        max: this.max,
        facets: facets,
        selected_count: this.selected_count
      };
    };

    FacetGroup.prototype.add = function(facet) {
      if (this.exists(facet) && this._group[facet.hash()].selected) {
        return;
      }
      return this._group[facet.hash()] = facet;
    };

    FacetGroup.prototype.remove = function(facet) {
      return delete this._group[facet.hash()];
    };

    FacetGroup.prototype.exists = function(value) {
      return this._group[value] != null;
    };

    return FacetGroup;

  })();

  DEFAULT_WRAPPER_CSS = ".clerk-omnisearch-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 999999999999; margin: 0; padding: 0; background-color: rgba(31, 40, 45, 30%); } .clerk-omnisearch-hidden { display: none; } .clerk-omnisearch-css-reset-html { overflow: hidden; font-size: unset; font-family: unset; line-height: 1.5; fill: unset; color: unset; letter-spacing: unset; background-color: unset; } .clerk-omnisearch-css-reset-body { overflow: hidden; }";

}).call(this);

/*
 * File: src/ui/content/exitintent.coffee 
 */
(function() {
  var Clerk, Exit;

  Clerk = window.Clerk;

  Clerk.lib('ui.content.exit', {
    create: function(content) {
      return new Exit(content);
    }
  });

  Exit = (function() {
    function Exit(content1) {
      var cooldown, delay, dom, init_timestamp, logger, storage;
      this.content = content1;
      dom = Clerk.lib('dom');
      storage = Clerk.lib('storage');
      logger = Clerk.lib('logger').component("Content/ExitIntent " + this.content.ident);
      delay = this.content.model('exit-intent-delay');
      cooldown = this.content.model('exit-intent-cooldown');
      if (cooldown == null) {
        cooldown = 60 * 60 * 24;
      }
      this.trigger = false;
      init_timestamp = new Date().getTime() / 1000;
      this.content.on('update').then((function(_this) {
        return function() {
          if (_this.trigger) {
            logger.log('Exit intent: Allowed rendering of content', {
              content: _this.content
            });
          } else {
            logger.log('Exit intent: Blocked rendering of content', {
              content: _this.content
            });
          }
          return _this.trigger;
        };
      })(this));
      dom.find('html')[0].on('mouseleave').then((function(_this) {
        return function(event) {
          var now_timestamp, time_since_last_trigger, time_since_page_load;
          if (event.raw().clientY > 20) {
            return;
          }
          now_timestamp = new Date().getTime() / 1000;
          time_since_page_load = now_timestamp - init_timestamp;
          if ((delay != null) && time_since_page_load < delay) {
            logger.log('Exit intent detected but action blocked by delay rule.', {
              content: _this.content,
              delay: delay,
              time_since_page_load: time_since_page_load
            });
            return;
          }
          time_since_last_trigger = now_timestamp - storage.get('__clerk-exit-intent-triggered-time');
          if (time_since_last_trigger < cooldown) {
            logger.log('Exit intent detected but action blocked by cooldown rule.', {
              content: _this.content,
              cooldown: cooldown,
              time_since_last_trigger: time_since_last_trigger
            });
            return;
          }
          storage.set('__clerk-exit-intent-triggered-time', now_timestamp);
          logger.log('Exit intent: Detected!', {
            content: _this.content
          });
          _this.trigger = true;
          return _this.content.reload();
        };
      })(this));
    }

    return Exit;

  })();

}).call(this);

/*
 * File: src/ui/content/visitor.coffee 
 */
(function() {
  var Clerk, Visitor;

  Clerk = window.Clerk;

  Clerk.lib('ui.content.visitor', {
    create: function(content) {
      return new Visitor(content);
    }
  });

  Visitor = (function() {
    function Visitor(content1) {
      var dom, evaluation, expression, logger, visitor;
      this.content = content1;
      dom = Clerk.lib('dom');
      visitor = Clerk.lib('visitor').get();
      logger = Clerk.lib('logger');
      this.trigger = false;
      this.content.on('update').then((function(_this) {
        return function() {
          if (_this.trigger) {
            logger.log('Visitor: Allowed rendering of content', {
              content: _this.content
            });
          } else {
            logger.log('Visitor: Blocked rendering of content', {
              content: _this.content
            });
          }
          return _this.trigger;
        };
      })(this));
      if (this.content.model('show')) {
        expression = this.content.model('show');
        evaluation = visitor["eval"](expression);
      } else if (this.content.model('hide')) {
        expression = this.content.model('hide');
        evaluation = !visitor["eval"](expression);
      }
      if (evaluation) {
        this.trigger = true;
        logger.log('Visitor: evaluated, showing content!', {
          content: this.content,
          evaluation: evaluation,
          expression: expression,
          is_show: this.content.model('show') ? true : false,
          is_hide: this.content.model('hide') ? true : false
        });
        this.content.reload();
      } else {
        logger.log('Visitor: evaluated, hiding content!', {
          content: this.content,
          evaluation: evaluation,
          expression: expression,
          is_show: this.content.model('show') ? true : false,
          is_hide: this.content.model('hide') ? true : false
        });
      }
    }

    return Visitor;

  })();

}).call(this);

/*
 * File: src/ui/content/splittest.coffee 
 */
(function() {
  var Clerk, SplitTest;

  Clerk = window.Clerk;

  Clerk.lib('ui.content.splittest', {
    create: function(content) {
      return new SplitTest(content);
    }
  });

  SplitTest = (function() {
    function SplitTest(content) {
      var all_contents_affected, all_contents_matching, content_lib, dom, i, len, logger, number_of_contents, randomized_test, selected_content, splittest, storage, stored_test, stored_variant, test, tests, variant;
      dom = Clerk.lib('dom');
      content_lib = Clerk.lib('content');
      logger = Clerk.lib('logger');
      storage = Clerk.lib('storage');
      this.trigger = false;
      number_of_contents = 0;
      content.on('update').then((function(_this) {
        return function() {
          if (_this.trigger) {
            logger.log('Split test: Allowed rendering of content', {
              content: _this.content
            });
          } else {
            logger.log('Split test: Blocked rendering of content', {
              content: _this.content
            });
          }
          return _this.trigger;
        };
      })(this));
      splittest = content.model('split-test').split(':');
      test = splittest[0];
      variant = splittest[1];
      all_contents_affected = dom.find("[data-split-test^='" + test + "']");
      all_contents_matching = [];
      for (i = 0, len = all_contents_affected.length; i < len; i++) {
        tests = all_contents_affected[i];
        if (tests.attribute('data-split-test').split(':')[0] === test) {
          all_contents_matching.push(tests);
        }
      }
      stored_test = storage.get('clerk-splittest-' + test);
      if (stored_test != null) {
        stored_variant = stored_test['variant'];
        number_of_contents = stored_test['n'];
      }
      if ((stored_variant != null) && all_contents_matching.length === number_of_contents) {
        if (stored_variant === variant) {
          this.trigger = true;
          content.reload();
        }
      } else {
        randomized_test = Math.floor(Math.random() * all_contents_matching.length);
        selected_content = all_contents_matching[randomized_test].raw();
        storage.set('clerk-splittest-' + test, {
          'variant': selected_content.dataset.splitTest.split(':')[1],
          'n': all_contents_matching.length
        });
        if (variant === selected_content.dataset.splitTest.split(':')[1]) {
          this.trigger = true;
          content.reload();
        }
      }
    }

    return SplitTest;

  })();

}).call(this);

/*
 * File: src/ui/content/facets.coffee 
 */
(function() {
  var Clerk, Facet, Facets, GroupedFacets, RangeFacet, UnitFacet, _as_facet, _as_grouped_facets, _fetch_url_param_facets, _set_selected_facets, _url_diff_to_selected_facet, _url_param_to_facet,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Clerk = window.Clerk;

  Clerk.lib('ui.content.facets', {
    create: function(content) {
      return new Facets(content);
    }
  });

  Facets = (function() {
    function Facets(content1) {
      var deferred, facet_groups, facet_target, facet_target_path, filter, setting, template, template_lib, url_params;
      this.content = content1;
      this.q = Clerk.lib('q');
      this.api = Clerk.lib('api');
      this.dom = Clerk.lib('dom');
      this.utils = Clerk.lib('utils');
      this.ui_range = Clerk.lib('ui.range');
      this.facet_tools = Clerk.lib('facet_tools');
      template_lib = Clerk.lib('template');
      this.logger = Clerk.lib('logger').component("Content/Facets " + this.content.ident);
      this.facets = new GroupedFacets();
      setting = (function(_this) {
        return function(key, def) {
          var value;
          if (def == null) {
            def = null;
          }
          value = _this.content.model(key);
          if (value != null) {
            _this.content.model(key, null);
            return value;
          } else {
            return def;
          }
        };
      })(this);
      this.multiselect = setting('facets-multiselect-attributes', []);
      this.titles = setting('facets-titles', []);
      this.groups = setting('facets-attributes', []);
      this.useUrl = setting('facets-in-url', false);
      this.useDesign = setting('facets-design', false);
      this.price_prepend = setting('facets-price-prepend', '');
      this.price_append = setting('facets-price-append', '');
      this.show_more_text = setting('facets-view-more-text', '');
      this.search_for_text = setting('facets-searchbox-text', '');
      this.use_persistent_filter = setting('facets-persistent-filter', false);
      this.content.model('facets', this.groups);
      if (this.use_persistent_filter) {
        this.persistent_filter = setting('filter');
        filter = this.filter;
      }
      if (this.useUrl) {
        url_params = decodeURIComponent(window.location.search.replace('?', ''));
        facet_groups = _fetch_url_param_facets(url_params, this.groups);
        if (facet_groups) {
          this.facets = facet_groups;
          if (!this.no_filter_facets && this.content._model.query) {
            this.api.call('search/search', this.content.model()).then((function(_this) {
              return function(response) {
                _this.no_filter_facets = _as_grouped_facets(response.facets);
                return _this.reload();
              };
            })(this));
          }
          filter = this.filter();
          if (filter && filter.length > 0) {
            this.content.model('filter', filter);
          }
        }
        window.addEventListener('popstate', (function(_this) {
          return function(event) {
            var ref;
            if (((ref = event.state) != null ? ref.namespace : void 0) !== 'clerk.js/facet') {
              return;
            }
            _this.facets = _fetch_url_param_facets(event.state.params, _this.groups);
            return _this.reload();
          };
        })(this));
      }
      facet_target_path = setting('facets-target');
      facet_target = this.dom.find(facet_target_path);
      if (facet_target.length > 0) {
        this.target = facet_target[0];
      } else {
        this.logger.error('Facet target element could not be found!', {
          target: facet_target_path
        });
        return;
      }
      deferred = this.q.defer();
      if (this.useDesign) {
        this.design_call = this.api.call('config/designs', {
          'ids': [this.useDesign]
        }).then((function(_this) {
          return function(response) {
            var css, html, result, template;
            if (response.results.length === 0) {
              _this.logger.error('Could not find design with id.', {
                id: _this.useDesign
              });
              deferred.reject('Could not find design with id.');
            }
            result = response.results[0];
            if (Clerk('config', 'globals').is_mobile) {
              css = result.css_mobile ? result.css_mobile : result.css;
              html = result.html_mobile ? result.html_mobile : result.html;
              _this.dom.css(css);
              template = html;
            } else {
              _this.dom.css(result.css);
              template = result.html;
            }
            _this.template = template_lib.compile(template);
            _this.logger.log('Using facets design from my.clerk.');
            return deferred.resolve(response);
          };
        })(this), (function(_this) {
          return function(failure) {
            var template;
            _this.logger.log('Could not find design. Using default facet design.');
            _this.dom.css(_this.facet_tools.default_facet_css());
            template = _this.facet_tools.default_facet_template();
            _this.template = template_lib.compile(template);
            return deferred.reject(failure);
          };
        })(this));
      } else {
        if (this.target.children().length === 0) {
          this.dom.css(this.facet_tools.default_facet_css());
          template = this.facet_tools.default_facet_template();
          this.logger.log('Using default facets template.');
        } else {
          template = this.target.html();
          this.logger.log('Using custom facets template.', {
            template: template
          });
        }
        this.template = template_lib.compile(template);
      }
      this.content.on('response').then((function(_this) {
        return function(type, response) {
          var any_facets_selected, count, facet, facets_should_render, group, j, k, l, len, len1, len2, len3, len4, len5, len6, len7, m, n, o, p, q, r_facet, r_product, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, res_facets, response_facets;
          if (response.facets != null) {
            any_facets_selected = false;
            ref = _this.facets.groups();
            for (j = 0, len = ref.length; j < len; j++) {
              group = ref[j];
              if (any_facets_selected) {
                break;
              }
              ref1 = _this.facets.get(group);
              for (k = 0, len1 = ref1.length; k < len1; k++) {
                facet = ref1[k];
                if (facet.selected) {
                  any_facets_selected = true;
                  break;
                }
              }
            }
            facets_should_render = any_facets_selected || response.count;
            if (!facets_should_render) {
              return deferred.resolve();
            }
            response_facets = _as_grouped_facets(response.facets);
            if (_this.useUrl) {
              ref2 = _this.facets.groups();
              for (l = 0, len2 = ref2.length; l < len2; l++) {
                group = ref2[l];
                res_facets = {};
                if (response_facets.get(group) !== null) {
                  ref3 = response_facets.get(group);
                  for (m = 0, len3 = ref3.length; m < len3; m++) {
                    facet = ref3[m];
                    if (facet.value) {
                      res_facets[facet.value] = facet;
                    }
                  }
                }
                ref4 = _this.facets.get(group);
                for (n = 0, len4 = ref4.length; n < len4; n++) {
                  facet = ref4[n];
                  if (res_facets[facet.value]) {
                    facet["name"] = res_facets[facet.value]["name"];
                  }
                }
                ref5 = _this.facets.get(group);
                for (o = 0, len5 = ref5.length; o < len5; o++) {
                  facet = ref5[o];
                  if (facet.count === 0 && facet.type === 'range') {
                    count = 0;
                    ref6 = response.product_data;
                    for (p = 0, len6 = ref6.length; p < len6; p++) {
                      r_product = ref6[p];
                      if (r_product[group] >= facet.min && r_product[group] <= facet.max) {
                        count += 1;
                      }
                    }
                    facet.count = count;
                  }
                  if (facet.count === 0 && facet.type === 'unit') {
                    count = 0;
                    ref7 = response.facets[group];
                    for (q = 0, len7 = ref7.length; q < len7; q++) {
                      r_facet = ref7[q];
                      if (r_facet.value === facet.value) {
                        count += r_facet.count;
                      }
                    }
                    facet.count = count;
                  }
                }
              }
            }
            if (response.hits === 0) {
              response_facets = _as_grouped_facets({});
            }
            return _this.update(response_facets).then(function(new_facets) {
              if (_this.design_call && !_this.template) {
                return _this.design_call.then(function() {
                  return _this.render(new_facets);
                });
              } else {
                return _this.render(new_facets);
              }
            });
          }
        };
      })(this));
    }

    Facets.prototype.update = function(new_facets) {
      var deferred, facet, group, group_has_selected_facets, j, k, l, len, len1, len2, len3, len4, len5, m, n, o, ref, ref1, ref2, ref3, ref4, ref5;
      this.logger.log('Update facets.', {
        facets: new_facets
      });
      deferred = this.q.defer();
      ref = this.facets.groups();
      for (j = 0, len = ref.length; j < len; j++) {
        group = ref[j];
        ref1 = this.facets.get(group);
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          facet = ref1[k];
          if (facet.selected) {
            if (new_facets.exists(group, facet)) {
              new_facets.get(group, facet).select();
            } else {
              new_facets.add(group, facet);
            }
          }
        }
      }
      ref2 = new_facets.groups();
      for (l = 0, len2 = ref2.length; l < len2; l++) {
        group = ref2[l];
        group_has_selected_facets = false;
        if (this.facets.exists(group)) {
          ref3 = this.facets.get(group);
          for (m = 0, len3 = ref3.length; m < len3; m++) {
            facet = ref3[m];
            if (!facet.selected) {
              continue;
            }
            group_has_selected_facets = true;
            break;
          }
        }
        if (this.facets.exists(group) && indexOf.call(this.multiselect, group) >= 0 && group_has_selected_facets) {
          ref4 = new_facets.get(group);
          for (n = 0, len4 = ref4.length; n < len4; n++) {
            facet = ref4[n];
            if (this.facets.exists(group, facet)) {
              this.facets.get(group, facet).set_count(facet.count);
            }
          }
          new_facets.remove(group);
          new_facets.add(group, this.facets.get(group));
          if (this.no_filter_facets && this.useUrl && new_facets.get(group).length < this.no_filter_facets.get(group).length) {
            ref5 = this.no_filter_facets.get(group);
            for (o = 0, len5 = ref5.length; o < len5; o++) {
              facet = ref5[o];
              if (!new_facets.exists(group, facet)) {
                new_facets.add(group, facet);
              }
            }
          }
        } else {
          this.facets.add(group, new_facets.get(group));
        }
      }
      deferred.resolve(new_facets);
      this.no_filter_facets = null;
      return deferred.promise;
    };

    Facets.prototype.render = function(facets) {
      var context, element, end, facet, facet_search_input, fn, group, group_facets, group_is_multiselect, j, k, l, language, len, len1, len2, len3, len4, m, max, min, n, range, ref, ref1, ref2, ref3, results, start, template_facets, text_search_for, text_show_more, type, v, values, wrapper;
      template_facets = [];
      ref = this.groups;
      for (j = 0, len = ref.length; j < len; j++) {
        group = ref[j];
        group_is_multiselect = indexOf.call(this.multiselect, group) >= 0;
        values = facets.get(group);
        if ((values != null) && values.length > 0) {
          type = values[0].type;
          min = max = start = end = null;
          values.sort(function(a, b) {
            switch (false) {
              case !(a.selected && !group_is_multiselect):
                return -1;
              case !(b.selected && !group_is_multiselect):
                return 1;
              case a.type !== 'unit':
                if (a.name <= b.name) {
                  return -1;
                } else {
                  return 1;
                }
              case a.type !== 'range':
                if (a.min <= b.min) {
                  return -1;
                } else {
                  return 1;
                }
            }
          });
          if (type === 'range') {
            min = Math.min.apply(Math, (function() {
              var k, len1, results;
              results = [];
              for (k = 0, len1 = values.length; k < len1; k++) {
                v = values[k];
                results.push(v.min);
              }
              return results;
            })());
            max = Math.max.apply(Math, (function() {
              var k, len1, results;
              results = [];
              for (k = 0, len1 = values.length; k < len1; k++) {
                v = values[k];
                results.push(v.max);
              }
              return results;
            })());
            start = Math.min.apply(Math, (function() {
              var k, len1, results;
              results = [];
              for (k = 0, len1 = values.length; k < len1; k++) {
                v = values[k];
                if (v.selected) {
                  results.push(v.min);
                }
              }
              return results;
            })());
            end = Math.max.apply(Math, (function() {
              var k, len1, results;
              results = [];
              for (k = 0, len1 = values.length; k < len1; k++) {
                v = values[k];
                if (v.selected) {
                  results.push(v.max);
                }
              }
              return results;
            })());
            if (!start) {
              start = min;
            }
            if (!end) {
              end = max;
            }
            if (group === 'price' && (this.price_prepend || this.price_append)) {
              for (k = 0, len1 = values.length; k < len1; k++) {
                v = values[k];
                if (this.price_prepend && v.name.indexOf(this.price_prepend) === -1) {
                  v.name = v.name.replace(/([\d\.,]+)/g, (function(_this) {
                    return function(match) {
                      return _this.price_prepend + match;
                    };
                  })(this));
                }
                if (this.price_append && v.name.indexOf(this.price_append) === -1) {
                  v.name = v.name.replace(/([\d\.,]+)/g, (function(_this) {
                    return function(match) {
                      return match + _this.price_append;
                    };
                  })(this));
                }
              }
            }
          }
          group_facets = (function() {
            var l, len2, results;
            results = [];
            for (l = 0, len2 = values.length; l < len2; l++) {
              facet = values[l];
              if (facet.value || facet.min || facet.max) {
                results.push({
                  group: group,
                  type: facet.type,
                  name: facet.name,
                  value: typeof facet.value === 'string' ? facet.value.replace(/"/g, '&quot;') : facet.value,
                  min: facet.min,
                  max: facet.max,
                  count: facet.count,
                  selected: facet.selected
                });
              }
            }
            return results;
          })();
          if (group_facets.length) {
            template_facets.push({
              group: group,
              title: group in this.titles ? this.titles[group] : group,
              type: type,
              min: min,
              max: max,
              start: start,
              end: end,
              facets: group_facets
            });
          }
        }
      }
      language = Clerk.config('language');
      if (this.search_for_text) {
        text_search_for = this.search_for_text;
      } else {
        text_search_for = language != null ? this.facet_tools.translations()[language]['search'] : 'Search For';
      }
      if (this.show_more_text) {
        text_show_more = this.show_more_text;
      } else {
        text_show_more = language != null ? this.facet_tools.translations()[language]['more'] : 'Show More';
      }
      this.logger.log('Render facets.', {
        facets: template_facets
      });
      context = {
        facets: template_facets,
        translation: {
          show_more: text_show_more,
          search_for: text_search_for
        }
      };
      this.target.html(this.template(context));
      ref1 = this.dom.find('.clerk-range');
      for (l = 0, len2 = ref1.length; l < len2; l++) {
        range = ref1[l];
        wrapper = (function(_this) {
          return function(range) {
            return _this.ui_range.create(range).then(function(start, end) {
              var data;
              data = range.data();
              _this.select(data.group, 'range', null, start, end);
              return _this.reload();
            });
          };
        })(this);
        wrapper(range);
      }
      ref2 = this.dom.find('.clerk-facet');
      fn = (function(_this) {
        return function(element) {
          return element.on('click').then(function() {
            var data;
            data = element.data();
            if (data.value || data.value === false) {
              _this.select(data.facet, 'unit', data.value);
            } else {
              _this.select(data.facet, 'range', null, data.min, data.max);
            }
            return _this.reload();
          });
        };
      })(this);
      for (m = 0, len3 = ref2.length; m < len3; m++) {
        element = ref2[m];
        fn(element);
      }
      ref3 = this.dom.find('.clerk-facet-search');
      results = [];
      for (n = 0, len4 = ref3.length; n < len4; n++) {
        facet_search_input = ref3[n];
        results.push((function(_this) {
          return function(facet_search_input) {
            var facets_to_be_searched;
            facets_to_be_searched = _this.dom.find('.clerk-facet', facet_search_input.parent().raw());
            if (facets_to_be_searched.length > 0) {
              return facet_search_input.on('keyup').then(function() {
                var facet_query, len5, o, results1;
                facet_query = facet_search_input.value().trim().toLowerCase();
                results1 = [];
                for (o = 0, len5 = facets_to_be_searched.length; o < len5; o++) {
                  facet = facets_to_be_searched[o];
                  if (facet.text().toLowerCase().indexOf(facet_query) === -1) {
                    results1.push(facet["class"]().add('hidden'));
                  } else {
                    results1.push(facet["class"]().remove('hidden'));
                  }
                }
                return results1;
              });
            }
          };
        })(this)(facet_search_input));
      }
      return results;
    };

    Facets.prototype.select = function(group, type, value, min, max, _do_pushstate) {
      var data, facet, j, len, params, ref, selected_facet, url;
      if (_do_pushstate == null) {
        _do_pushstate = true;
      }
      if (this.facets.get(group).length > 0 && typeof this.facets.get(group)[0].value === 'string') {
        value = "" + value;
      }
      selected_facet = this.facets.get(group, _as_facet({
        type: type,
        value: value,
        min: min,
        max: max,
        selected: true
      }));
      if (selected_facet != null) {
        selected_facet.select(true);
        this.logger.log('Selected facet', {
          facet: selected_facet
        });
      } else if (type === 'range' && (min != null) && (max != null)) {
        ref = this.facets.get(group);
        for (j = 0, len = ref.length; j < len; j++) {
          facet = ref[j];
          if (facet != null ? facet.custom : void 0) {
            this.facets.remove(group, facet);
          }
        }
        selected_facet = _as_facet({
          type: 'range',
          name: min + " - " + max,
          min: min,
          max: max,
          custom: true,
          selected: true,
          count: ''
        });
        this.facets.add(group, selected_facet);
        this.logger.log('Selected facet (added new range)', {
          facet: selected_facet
        });
      }
      if (this.useUrl && (selected_facet != null) && _do_pushstate) {
        if (!history.pushState) {
          this.logger.warn('You browser does not support dynamically updating filter URL parameters (history.pushState).');
          return;
        }
        params = this.urlParams();
        data = {
          namespace: 'clerk.js/facet',
          params: this.urlParams()
        };
        url = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + params;
        window.history.pushState(data, null, url);
        return this.logger.log('Updated URL with facet parameters.', {
          url: url,
          params: params
        });
      }
    };

    Facets.prototype.filter = function() {
      var facet, filter, group, group_filter, group_is_multiselect, j, join, k, len, len1, ref, ref1;
      filter = [];
      ref = this.facets.groups();
      for (j = 0, len = ref.length; j < len; j++) {
        group = ref[j];
        group_filter = [];
        group_is_multiselect = indexOf.call(this.multiselect, group) >= 0;
        ref1 = this.facets.get(group);
        for (k = 0, len1 = ref1.length; k < len1; k++) {
          facet = ref1[k];
          if (facet.selected) {
            if (facet.type === 'unit') {
              if (this.utils.type(facet.value) === 'string') {
                group_filter.push(group + " = \"" + (facet.value.replace(/\"/g, '\\\"')) + "\"");
              } else {
                group_filter.push(group + " = " + facet.value);
              }
            } else if (facet.type === 'range') {
              group_filter.push("(" + group + " >= " + facet.min + " and " + group + " <= " + facet.max + ")");
            }
          }
        }
        if (group_filter.length === 1) {
          filter.push(group_filter[0]);
        } else if (group_filter.length > 1) {
          join = group_is_multiselect ? ' or ' : ' and ';
          filter.push("(" + (group_filter.join(join)) + ")");
        }
      }
      if (this.persistent_filter) {
        filter.push(this.persistent_filter);
      }
      return filter.join(' and ');
    };

    Facets.prototype.urlParams = function() {
      var facet, group, group_is_multiselect, group_values, j, k, l, len, len1, len2, len3, m, param, params, ref, ref1, ref2, ref3, value;
      params = [];
      ref = window.location.search.replace('?', '').split('&');
      for (j = 0, len = ref.length; j < len; j++) {
        param = ref[j];
        if (!(param)) {
          continue;
        }
        ref1 = param.split('='), group = ref1[0], value = ref1[1];
        if (indexOf.call(this.groups, group) < 0) {
          params.push(group + "=" + value);
        }
      }
      ref2 = this.facets.groups();
      for (k = 0, len1 = ref2.length; k < len1; k++) {
        group = ref2[k];
        group_values = [];
        group_is_multiselect = indexOf.call(this.multiselect, group) >= 0;
        ref3 = this.facets.get(group);
        for (l = 0, len2 = ref3.length; l < len2; l++) {
          facet = ref3[l];
          if (facet.selected) {
            if (facet.type === 'unit') {
              group_values.push(encodeURIComponent(facet.value));
            } else if (facet.type === 'range') {
              group_values.push(facet.min + "-" + facet.max);
            }
          }
        }
        if (group_values.length > 0) {
          group = encodeURIComponent(group);
          if (group_is_multiselect) {
            params.push(group + "=" + (group_values.join('|')));
          } else {
            for (m = 0, len3 = group_values.length; m < len3; m++) {
              value = group_values[m];
              params.push(group + "=" + value);
            }
          }
        }
      }
      return params.join('&');
    };

    Facets.prototype.reload = function() {
      var filter;
      filter = this.filter();
      this.content.model('filter', filter ? filter : null);
      return this.content.reload();
    };

    return Facets;

  })();


  /* HELPER FUNCTIONS */

  _as_facet = function(facet) {
    var facet_tools, language, ref;
    facet_tools = Clerk.lib('facet_tools');
    if (facet.type === 'unit' && ((ref = facet.value) === true || ref === false)) {
      language = Clerk.config('language');
      if (language == null) {
        language = 'english';
      }
      facet.name = facet_tools.translations()[language][facet.value];
    }
    switch (facet.type) {
      case 'unit':
        return new UnitFacet(facet.name, facet.value, facet.count, facet.selected);
      case 'range':
        return new RangeFacet(facet.name, facet.min, facet.max, facet.count, facet.custom, facet.selected);
      default:
        throw 'Unknown facet type ' + facet.type;
    }
  };

  _as_grouped_facets = function(grouped_facets) {
    var facet, facets, gf, group, j, len;
    gf = new GroupedFacets();
    for (group in grouped_facets) {
      facets = grouped_facets[group];
      for (j = 0, len = facets.length; j < len; j++) {
        facet = facets[j];
        gf.add(group, _as_facet(facet));
      }
    }
    return gf;
  };

  _set_selected_facets = function(facets, selected_facets) {
    var facet, found_facet, found_selected_facets, j, k, l, len, len1, len2, len3, m, match_found, selected_facet;
    if (!selected_facets || selected_facets.length === 0) {
      return facets;
    }
    found_selected_facets = [];
    for (j = 0, len = facets.length; j < len; j++) {
      facet = facets[j];
      for (k = 0, len1 = selected_facets.length; k < len1; k++) {
        selected_facet = selected_facets[k];
        if (_is_equal(facet, selected_facet)) {
          facet.selected = true;
          found_selected_facets.push(facet);
        }
      }
    }
    if (found_selected_facets.length < selected_facets.length) {
      for (l = 0, len2 = selected_facets.length; l < len2; l++) {
        selected_facet = selected_facets[l];
        match_found = false;
        for (m = 0, len3 = found_selected_facets.length; m < len3; m++) {
          found_facet = found_selected_facets[m];
          if (_is_equal(selected_facet, found_facet)) {
            match_found = true;
            break;
          }
        }
        if (!(match_found = false)) {
          facets.push(selected_facet);
        }
      }
    }
    return facets;
  };

  _fetch_url_param_facets = function(params, groups) {
    var facet, facet_groups, group, j, k, len, len1, param, ref, ref1, value, values;
    facet_groups = {};
    ref = params.split('&');
    for (j = 0, len = ref.length; j < len; j++) {
      param = ref[j];
      if (!(param)) {
        continue;
      }
      ref1 = param.split('='), group = ref1[0], value = ref1[1];
      if (indexOf.call(groups, group) < 0) {
        continue;
      }
      if (value.match(/[\|]/)) {
        values = value.split('|');
      } else {
        values = [value];
      }
      for (k = 0, len1 = values.length; k < len1; k++) {
        value = values[k];
        facet = _url_param_to_facet(group, value);
        if (group in facet_groups) {
          facet_groups[group].push(facet);
        } else {
          facet_groups[group] = [facet];
        }
      }
    }
    return _as_grouped_facets(facet_groups);
  };

  _url_diff_to_selected_facet = function(current_url, last_url) {
    var direction, facet, group, ref, url_diff, value;
    if (current_url.length > last_url.length) {
      url_diff = current_url.replace(last_url, '');
      direction = 'forward';
    } else if (current_url.length < last_url.length) {
      url_diff = last_url.replace(current_url, '');
      direction = 'back';
    } else {
      return null;
    }
    ref = url_diff.split('='), group = ref[0], value = ref[1];
    facet = _url_param_to_facet(group, value);
    facet.selected = direction === 'forward';
    return _as_facet(facet);
  };

  _url_param_to_facet = function(name, value) {
    var max, min, ref;
    value = decodeURIComponent(value);
    switch (false) {
      case !(value === 'true' || value === 'false'):
        return {
          group: name,
          type: 'unit',
          name: value,
          value: value === 'true',
          selected: true
        };
      case !value.match(/[0-9]+-[0-9]+/):
        ref = value.split('-'), min = ref[0], max = ref[1];
        return {
          group: name,
          type: 'range',
          name: value,
          min: parseInt(min),
          max: parseInt(max),
          selected: true
        };
      case !value.match(/^\d+$/):
        return {
          group: name,
          type: 'unit',
          name: value,
          value: parseInt(value),
          selected: true
        };
      default:
        return {
          group: name,
          type: 'unit',
          name: value,
          value: value,
          selected: true
        };
    }
  };


  /* CLASSES */

  Facet = (function() {
    function Facet() {
      var name1;
      name1 = arguments[0];
      this.name = name1;
    }

    Facet.prototype.equals = function(other) {
      return false;
    };

    Facet.prototype.select = function(toggle) {
      if (toggle == null) {
        toggle = false;
      }
      if (toggle) {
        return this.selected = !this.selected;
      } else {
        return this.selected = true;
      }
    };

    Facet.prototype.set_count = function(count) {
      if (count) {
        return this.count = count;
      }
    };

    return Facet;

  })();

  UnitFacet = (function(superClass) {
    extend(UnitFacet, superClass);

    function UnitFacet(name1, value1, count1, selected) {
      this.name = name1;
      this.value = value1;
      this.count = count1 != null ? count1 : 0;
      this.selected = selected != null ? selected : false;
      this.type = 'unit';
    }

    UnitFacet.prototype.equals = function(other) {
      if (other instanceof UnitFacet) {
        return (this.value + '') === (other.value + '');
      } else {
        return false;
      }
    };

    return UnitFacet;

  })(Facet);

  RangeFacet = (function(superClass) {
    extend(RangeFacet, superClass);

    function RangeFacet(name1, min1, max1, count1, custom, selected) {
      this.name = name1;
      this.min = min1;
      this.max = max1;
      this.count = count1 != null ? count1 : 0;
      this.custom = custom != null ? custom : false;
      this.selected = selected != null ? selected : false;
      this.type = 'range';
    }

    RangeFacet.prototype.equals = function(other) {
      if (other instanceof RangeFacet) {
        return this.min === other.min && this.max === other.max;
      } else {
        return false;
      }
    };

    return RangeFacet;

  })(Facet);

  GroupedFacets = (function() {
    function GroupedFacets() {
      this._groups = {};
      this._utils = Clerk.lib('utils');
    }

    GroupedFacets.prototype.get = function(group, facet) {
      var existing_facet, j, len, ref;
      if (facet == null) {
        facet = null;
      }
      if (this._groups[group] == null) {
        return null;
      }
      if (facet == null) {
        return this._groups[group];
      }
      ref = this._groups[group];
      for (j = 0, len = ref.length; j < len; j++) {
        existing_facet = ref[j];
        if (existing_facet.equals(facet)) {
          return existing_facet;
        }
      }
    };

    GroupedFacets.prototype.exists = function(group, facet) {
      if (facet == null) {
        facet = null;
      }
      return this.get(group, facet) != null;
    };

    GroupedFacets.prototype.add = function(group, facet) {
      var existing_facet, j, len, ref;
      if (this._groups[group] == null) {
        this._groups[group] = [];
      }
      if (this._utils.type(facet) === 'array') {
        this._groups[group] = facet;
        return;
      }
      ref = this._groups[group];
      for (j = 0, len = ref.length; j < len; j++) {
        existing_facet = ref[j];
        if (existing_facet.equals(facet)) {
          return;
        }
      }
      return this._groups[group].push(facet);
    };

    GroupedFacets.prototype.remove = function(group, facet) {
      var existing_facet, i, j, len, ref, results;
      if (facet == null) {
        facet = null;
      }
      if (this._groups[group] == null) {
        return;
      }
      if (facet == null) {
        delete this._groups[group];
        return;
      }
      ref = this._groups[group];
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        existing_facet = ref[j];
        if (existing_facet.equals(facet)) {
          i = this._groups[group].indexOf(existing_facet);
          this._groups[group].splice(i, 1);
          break;
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    GroupedFacets.prototype.groups = function() {
      var _, group, ref, results;
      ref = this._groups;
      results = [];
      for (group in ref) {
        _ = ref[group];
        results.push(group);
      }
      return results;
    };

    return GroupedFacets;

  })();

}).call(this);

/*
 * File: src/ui/content/livesearch.coffee 
 */

/*
Content Manager than manages the instant search functionality.

Makes sure that instant search is shown on input or click and that it is positioned the correct place
 */

(function() {
  var Clerk, LiveSearch,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  Clerk = window.Clerk;

  Clerk.lib('ui.content.livesearch', {
    create: function(content) {
      return new LiveSearch(content);
    }
  });

  LiveSearch = (function() {
    function LiveSearch(content1) {
      var disallowed_input_types, fn, i, input_element, input_selector, len, ref, ref1, ref2;
      this.content = content1;
      this.dom = Clerk.lib('dom');
      this.storage = Clerk.lib('storage');
      this.utils = Clerk.lib('utils');
      this.logger = Clerk.lib('logger').component("Content/InstantSearch " + this.content.ident);
      this.visible = false;
      this.redirect = false;
      this.autocompleted_query = false;
      if (!this.content.target["class"]().has('clerk-instant-search-container')) {
        this.content.target["class"]().add('clerk-instant-search-container');
        this.content.target["class"]().add('clerk-live-search-container');
        this.content.target["class"]().add('clerk-instant-search-hidden');
      }
      this.dom.css('.clerk-instant-search-visible { display: block; } .clerk-instant-search-hidden { display: none; }');
      this.content.on('update').then((function(_this) {
        return function() {
          var is_query_long_enough, query;
          query = _this.content.model('query');
          is_query_long_enough = (query != null) && query.length > 1;
          if (!is_query_long_enough) {
            _this.logger.log('Query is not long enough!', {
              query: query
            });
          }
          return is_query_long_enough;
        };
      })(this));
      this.content.on('response').then((function(_this) {
        return function(_, response) {
          _this.autocompleted_query = response.query;
          return _this.redirect = response.redirect;
        };
      })(this));
      this.dom.find("body")[0].on('click').then((function(_this) {
        return function() {
          if (_this.visible) {
            _this.logger.log('Click detected.');
            return _this.hide();
          }
        };
      })(this));
      this.content.target.on('click').then((function(_this) {
        return function(event) {
          _this.logger.log('Click inside livesearch, stopping propgation');
          return event.stopPropagation(true);
        };
      })(this));
      window.addEventListener('resize', (function(_this) {
        return function() {
          if (_this.visible) {
            _this.logger.log('Window resize detected.');
            return _this.move_to(_this.active_input_element);
          }
        };
      })(this));
      input_selector = this.content.model('instant-search');
      if (input_selector == null) {
        input_selector = this.content.model('bind-live-search');
      }
      disallowed_input_types = ['hidden', 'password'];
      if (input_selector) {
        ref = this.dom.find(input_selector);
        fn = (function(_this) {
          return function(input_element) {
            _this.logger.log('Monitoring input', {
              input: input_element
            });
            input_element.attribute('autocomplete', 'off');
            input_element.on('keyup').then(function() {
              return _this.input_activity(input_element);
            });
            input_element.on('click').then(function() {
              return _this.input_activity(input_element);
            });
            return input_element.on('keydown').then(function(event) {
              return _this.keyboard_navigation(event, input_element);
            });
          };
        })(this);
        for (i = 0, len = ref.length; i < len; i++) {
          input_element = ref[i];
          if (ref1 = input_element != null ? (ref2 = input_element._element) != null ? ref2.type : void 0 : void 0, indexOf.call(disallowed_input_types, ref1) >= 0) {
            this.logger.log('Did not bind input due to being restricted type', {
              input: input_element
            });
            continue;
          }
          fn(input_element);
        }
      } else {
        this.logger.error("Selector was empty! Continuing to next content.");
      }
    }

    LiveSearch.prototype.input_activity = function(input_element) {
      var query;
      this.logger.log("Detected activity on input.", {
        input: input_element.raw()
      });
      this.active_input_element = input_element;
      query = this.utils.trim(input_element.value());
      if (query === this._last_query) {
        this.logger.log('Query has not changed', {
          query: query,
          last_query: query
        });
        return;
      }
      this._last_query = query;
      if (!query || query.length < 2) {
        this.logger.log('Query is too short', {
          query: query
        });
        this.hide();
        return;
      }
      clearTimeout(this._input_typing_timer);
      if ((query.length + 2) % 3 === 0) {
        return this.search(query, input_element);
      } else {
        return this._input_typing_timer = setTimeout((function(_this) {
          return function() {
            return _this.search(query, input_element);
          };
        })(this), 250);
      }
    };

    LiveSearch.prototype.search = function(query, element) {
      var categories, pages, suggestions;
      this.logger.log('Performing new search.', {
        query: query,
        input: element.raw()
      });
      this.content.model('suggestions', []);
      this.content.model('categories', []);
      this.content.model('pages', []);
      if (!this.content.broadcast('live_search_update', query, element)) {
        this.logger.warn('Instant search prevented by event handler for "live_search_update" event.');
        return;
      }
      this.content.model('history', this.get_search_history());
      suggestions = this.content.model('instant-search-suggestions');
      if ((suggestions != null) && suggestions) {
        Clerk.call('search/suggestions', {
          query: query,
          limit: suggestions
        }).then((function(_this) {
          return function(response) {
            _this.content.model('suggestions', response.result);
            return _this.content.render();
          };
        })(this));
      }
      categories = this.content.model('instant-search-categories');
      if ((categories == null) || categories === true) {
        categories = this.content.model('live-search-categories');
        categories = isFinite(categories) && categories !== true ? categories : 5;
      }
      if ((categories != null) && categories) {
        Clerk.call('search/categories', {
          query: query,
          limit: categories
        }).then((function(_this) {
          return function(response) {
            _this.content.model('categories', response.categories);
            return _this.content.render();
          };
        })(this));
      }
      pages = this.content.model('instant-search-pages');
      if ((pages != null) && pages) {
        Clerk.call('search/pages', {
          query: query,
          type: this.content.model('instant-search-pages-type'),
          limit: this.content.model('instant-search-pages')
        }).then((function(_this) {
          return function(response) {
            _this.content.model('pages', response.pages);
            return _this.content.render();
          };
        })(this));
      }
      this.content.model('query', query);
      return this.content.update().then((function(_this) {
        return function(response) {
          _this.content.render();
          _this.show();
          return _this.move_to(element);
        };
      })(this), (function(_this) {
        return function(failure) {
          return _this.hide();
        };
      })(this));
    };

    LiveSearch.prototype.show = function() {
      if (!this.visible) {
        this.visible = true;
        this.content.target["class"]().remove('clerk-instant-search-hidden');
        this.content.target["class"]().add('clerk-instant-search-visible');
        return this.logger.log('Show overlay.');
      }
    };

    LiveSearch.prototype.hide = function() {
      if (this.visible) {
        this.visible = false;
        this.content.target["class"]().remove('clerk-instant-search-visible');
        this.content.target["class"]().add('clerk-instant-search-hidden');
        return this.logger.log('Hide overlay.');
      }
    };

    LiveSearch.prototype.move_to = function(input_element) {
      var left, mode, right, scrollLeft, scrollTop, top;
      mode = this.content.model('instant-search-positioning');
      if (mode === 'off') {
        return;
      }
      if (mode == null) {
        mode = 'left';
      }
      if (this.content.target.parent().raw() !== document.body) {
        this.dom.find('body').append(this.content.target);
      }
      this.content.target.css('z-index', '2147483647');
      this.content.target.css('position', 'absolute');
      if (this.content.model('live-search-fit-width') === false) {
        mode = 'off';
      }
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
      top = input_element.position().top + input_element.size().height + scrollTop;
      left = null;
      right = null;
      this.content.target.css('top', top + "px");
      switch (mode) {
        case 'left':
          left = input_element.position().left + scrollLeft;
          this.content.target.css('left', left + "px");
          this.content.target.css('min-width', Math.max(input_element.size().width, 350) + 'px');
          break;
        case 'center':
          left = input_element.position().left + scrollLeft - ((this.content.target.size().width - input_element.size().width) / 2);
          this.content.target.css('left', left + "px");
          break;
        case 'right':
          right = this.dom.window().width - (input_element.position().left + scrollLeft + input_element.size().width);
          this.content.target.css('right', right + "px");
      }
      return this.logger.log('Moved live search content to active input.', {
        input: input_element.raw(),
        top: top,
        left: left,
        right: right
      });
    };

    LiveSearch.prototype.get_search_history = function() {
      var history;
      history = this.storage.get('search-history');
      if (!history) {
        history = [];
      }
      return history;
    };

    LiveSearch.prototype.update_search_history = function(query) {
      var history, query_index;
      history = get_search_history();
      query_index = history.indexOf(query);
      if (query_index > -1) {
        history.splice(query_index, 1);
      }
      return this.storage.set('search-history', history);
    };

    LiveSearch.prototype.keyboard_navigation = function(event, input_element) {
      var autofill, click, clickable_children, current_item, current_item_class, current_item_path, i, index, input_query, item, key, key_is_down, key_is_enter, key_is_up, last_item, len, logger, navigateable_items, navigateable_items_path, next_item, parent, selected_item;
      logger = this.logger;
      key = event.raw().which;
      key_is_enter = key === 13;
      key_is_up = key === 38;
      key_is_down = key === 40;
      current_item_class = 'clerk-instant-search-key-selected';
      current_item_path = "." + current_item_class;
      navigateable_items_path = '.clerk-instant-search-key-selectable';
      if (key_is_enter) {
        logger.log('Enter key-press detected.');
        selected_item = this.dom.find(current_item_path)[0];
        click = function(element) {
          logger.log('An click-able element was found in keyboard selected element. Click simulated.', {
            element: element.raw()
          });
          return element.trigger('click');
        };
        if (selected_item) {
          logger.log('An element was selected via keyboard navigation.', {
            element: selected_item.raw()
          });
          event.stopPropagation();
          if (selected_item.tag_name() === 'A') {
            click(selected_item);
          } else {
            clickable_children = this.dom.find('a', selected_item.raw());
            if (clickable_children.length > 0) {
              click(clickable_children[0]);
            } else {
              parent = selected_item.parent();
              if (parent.tag_name() === 'A') {
                click(parent);
              } else {
                logger.warn('No click-able elements found for keyboard selected element!', {
                  element: selected_item.raw()
                });
              }
            }
          }
        } else if (this.redirect) {
          this.logger.log("Redirecting to", {
            url: this.redirect
          });
          event.stopPropagation();
          location.href = this.redirect;
        } else {
          autofill = this.content.model('autofill');
          input_query = this.utils.trim(input_element.value());
          if (!(autofill === false || autofill === 'off' || !this.autocompleted_query || this.autocompleted_query.length < input_query.length)) {
            input_element.value(this.autocompleted_query);
            this.logger.log('Auto-filled the search input with auto-completed query.', {
              query: this.autocompleted_query,
              input: input_element.raw()
            });
          }
        }
        return this.hide();
      } else if (key_is_up || key_is_down) {
        if (key_is_up) {
          logger.log('Key up key-press detected.');
        } else {
          logger.log('Key down key-press detected.');
        }
        navigateable_items = this.dom.find(navigateable_items_path, this.content.element.raw());
        if (navigateable_items.length === 0) {
          return;
        }
        selected_item = this.dom.find(current_item_path, this.content.element.raw());
        if (selected_item.length === 0) {
          navigateable_items[0]["class"]().add(current_item_class);
          return logger.log('Keyboard navigation selected element updated.', {
            from: null,
            to: navigateable_items[0].raw()
          });
        } else {
          current_item = 0;
          for (index = i = 0, len = navigateable_items.length; i < len; index = ++i) {
            item = navigateable_items[index];
            if (item["class"]().has(current_item_class)) {
              current_item = index;
              break;
            }
          }
          next_item = key_is_down ? index + 1 : index - 1;
          last_item = navigateable_items.length - 1;
          if (next_item < 0) {
            next_item = last_item;
          } else if (next_item > last_item) {
            next_item = 0;
          }
          selected_item[0]["class"]().remove(current_item_class);
          navigateable_items[next_item]["class"]().add(current_item_class);
          return logger.log('Keyboard navigation selected element updated.', {
            from: selected_item[0].raw(),
            to: navigateable_items[next_item].raw()
          });
        }
      }
    };

    return LiveSearch;

  })();

}).call(this);

/*
 * File: src/ui/content/search.coffee 
 */
(function() {
  var Clerk, Search;

  Clerk = window.Clerk;

  Clerk.lib('ui.content.search', {
    create: function(content) {
      return new Search(content);
    }
  });

  Search = (function() {
    function Search(content1) {
      var categories, pages, query;
      this.content = content1;
      this.dom = Clerk.lib('dom');
      this.logger = Clerk.lib('logger').component("Content/InstantSearch " + this.content.ident);
      categories = this.content.model('search-categories');
      pages = this.content.model('search-pages');
      query = this.content.model('query');
      this.content.model('categories', []);
      this.content.model('pages', []);
      if ((categories != null) && categories) {
        Clerk.call('search/categories', {
          query: query,
          limit: categories
        }).then((function(_this) {
          return function(response) {
            _this.content.model('categories', response.categories);
            return _this.content.render();
          };
        })(this));
      }
      if ((pages != null) && pages) {
        Clerk.call('search/pages', {
          query: query,
          type: this.content.model('search-pages-type'),
          limit: this.content.model('search-pages')
        }).then((function(_this) {
          return function(response) {
            _this.content.model('pages', response.pages);
            return _this.content.render();
          };
        })(this));
      }
    }

    return Search;

  })();

}).call(this);

/*
 * File: src/ui/content/exclude.coffee 
 */
(function() {
  var Clerk, Exclude;

  Clerk = window.Clerk;

  Clerk.lib('ui.content.exclude', {
    create: function(content) {
      return new Exclude(content);
    }
  });

  Exclude = (function() {
    function Exclude(content) {
      var content_lib, dependency, dom, fn, i, len, logger, ref;
      dom = Clerk.lib('dom');
      content_lib = Clerk.lib('content');
      logger = Clerk.lib('logger');
      this.trigger = false;
      content.on('update').then((function(_this) {
        return function() {
          if (_this.trigger) {
            logger.log('Exclude: Allowed rendering of content', {
              content: _this.content
            });
          } else {
            logger.log('Exclude: Blocked rendering of content', {
              content: _this.content
            });
          }
          return _this.trigger;
        };
      })(this));
      this.dependencies = {};
      ref = content.model('exclude-from').split(',');
      fn = (function(_this) {
        return function(dependency) {
          var limit, other_content, ref1, selector;
          ref1 = dependency.split(':'), selector = ref1[0], limit = ref1[1];
          if (limit) {
            limit = parseInt(limit.replace('limit(', '').replace(')', ''));
          }
          other_content = content_lib.get(dom.find(selector));
          if (other_content) {
            _this.dependencies[selector] = null;
            return other_content.on('response').then(function(_, response) {
              var dependencies, excludables, id, j, len1, products, ref2, ref3, result;
              _this.dependencies[selector] = limit ? response.result.slice(0, +(limit - 1) + 1 || 9e9) : response.result;
              excludables = [];
              ref2 = _this.dependencies;
              for (selector in ref2) {
                dependencies = ref2[selector];
                if (!dependencies) {
                  continue;
                }
                for (j = 0, len1 = dependencies.length; j < len1; j++) {
                  result = dependencies[j];
                  if (result === null) {
                    return;
                  }
                  if (typeof result === "object") {
                    excludables = excludables.concat(result);
                  } else {
                    excludables.push(result);
                  }
                }
              }
              _this.trigger = true;
              logger.log('Exclude: excluded', {
                exclude_ids: excludables,
                count: excludables.length
              });
              ref3 = _this.dependencies;
              for (id in ref3) {
                products = ref3[id];
                if (products === null) {
                  _this.trigger = false;
                }
              }
              if (_this.trigger) {
                content.model('exclude', excludables);
                return content.reload();
              }
            });
          } else {
            return logger.error('Exclude: Could not find element with selector "' + selector + '" make sure it exists and loads before this.', {
              content: content
            });
          }
        };
      })(this);
      for (i = 0, len = ref.length; i < len; i++) {
        dependency = ref[i];
        fn(dependency);
      }
    }

    return Exclude;

  })();

}).call(this);

/*
 * File: src/utils/template.coffee 
 */
(function() {
  var AST, ASTBuilder, And, Assign, Clerk, Contains, Expression, ExpressionToken, For, Formatter, If, IfElse, In, LiteralToken, Or, StatementToken, String, Template, Token, _check_existance, _filter_empty, _indexOf, _trim, clean_context, consume_until, createExpression, createFormatterExpression, strip_html, tokenizer,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    slice = [].slice,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  Clerk = window.Clerk;

  Clerk.lib('template', {
    compile: function(template, formatters) {
      var ast, e, error, tokens;
      if (formatters == null) {
        formatters = {};
      }
      try {
        tokens = tokenizer(template);
        ast = ASTBuilder(tokens, formatters, template);
      } catch (error) {
        e = error;
        Clerk.lib('logger').error("Failed while reading template " + e, {
          'template': template,
          'formatters': formatters
        });
        throw e;
      }
      return function(context) {
        context = clean_context(context);
        return ast.render(context).join('');
      };
    },
    attributes: function(template, formatters) {
      var ast, tokens;
      if (formatters == null) {
        formatters = {};
      }
      tokens = tokenizer(template);
      ast = ASTBuilder(tokens, formatters, template);
      return ast.attributes();
    }
  });

  Token = (function() {
    function Token(string) {
      this.string = string;
    }

    return Token;

  })();

  StatementToken = (function(superClass) {
    extend(StatementToken, superClass);

    function StatementToken() {
      return StatementToken.__super__.constructor.apply(this, arguments);
    }

    return StatementToken;

  })(Token);

  ExpressionToken = (function(superClass) {
    extend(ExpressionToken, superClass);

    function ExpressionToken() {
      return ExpressionToken.__super__.constructor.apply(this, arguments);
    }

    return ExpressionToken;

  })(Token);

  LiteralToken = (function(superClass) {
    extend(LiteralToken, superClass);

    function LiteralToken() {
      return LiteralToken.__super__.constructor.apply(this, arguments);
    }

    return LiteralToken;

  })(Token);

  clean_context = function(context) {
    var i, j, len, ref, suggestion;
    if (context.query != null) {
      context.query = strip_html(context.query);
    }
    if (context.suggestion != null) {
      context.suggestion = strip_html(context.suggestion);
    }
    if (context.suggestions != null) {
      ref = context.suggestions;
      for (i = j = 0, len = ref.length; j < len; i = ++j) {
        suggestion = ref[i];
        context.suggestions[i] = strip_html(suggestion);
      }
    }
    return context;
  };

  strip_html = function(html) {
    var domDoc;
    domDoc = new DOMParser().parseFromString(html, 'text/html');
    return domDoc.body.textContent || "";
  };

  tokenizer = function(template) {
    var newLiteral, section, sectionString, tempalteReplaced, templateSections, tokens, trim;
    AST.template(template);
    trim = Clerk.lib('utils').trim;
    tempalteReplaced = (template.replace(/{{{/, "{{")).replace(/}}}/, "}}");
    tempalteReplaced = tempalteReplaced.replace(/&lt;/, "<");
    tempalteReplaced = tempalteReplaced.replace(/&gt;/, ">");
    templateSections = tempalteReplaced.split(/(?={{|}}|{%|%})/);
    templateSections = _filter_empty(templateSections);
    tokens = [];
    while (templateSections.length > 0) {
      section = templateSections.shift();
      switch (section.substr(0, 2)) {
        case "{%":
          sectionString = trim(section.substr(2));
          if (sectionString === "raw") {
            newLiteral = templateSections.shift().replace(/\%\}/, "");
            section = templateSections.shift();
            while (templateSections.length > 0 && (!/\{\% endraw/.test(section)) && (!/\{\%endraw/.test(section))) {
              newLiteral += section;
              section = templateSections.shift();
            }
            tokens.push(new LiteralToken(newLiteral));
          } else {
            tokens.push(new StatementToken(sectionString));
          }
          break;
        case "{{":
          sectionString = trim(section.substr(2));
          tokens.push(new ExpressionToken(sectionString));
          break;
        case "}}":
        case "%}":
          tokens.push(new LiteralToken(section.substr(2)));
          break;
        default:
          tokens.push(new LiteralToken(section));
      }
    }
    return tokens;
  };

  ASTBuilder = function(tokens, formatters, raw_template) {
    var AST, condition, ifbody, inIndex, splitString, startOfStatement, token;
    AST = new Template();
    while (tokens.length > 0) {
      token = tokens.shift();
      if (token instanceof StatementToken) {
        splitString = token.string.split(" ");
        startOfStatement = splitString.shift();
        switch (startOfStatement) {
          case "if":
            condition = new createExpression(splitString.join(" "), formatters);
            ifbody = ASTBuilder(tokens, formatters, raw_template);
            if (tokens[0] === "else") {
              AST.nodes.push(new IfElse(condition, ifbody, ASTBuilder(tokens, formatters, raw_template)));
            } else {
              AST.nodes.push(new If(condition, ifbody));
            }
            break;
          case "assign":
            AST.nodes.push(new Assign(splitString[0], new createExpression(splitString.slice(2).join(" "), formatters)));
            break;
          case "else":
            tokens.unshift("else");
            return AST;
          case "for":
            inIndex = _indexOf(splitString, "in");
            AST.nodes.push(new For(splitString.slice(0, +(inIndex - 1) + 1 || 9e9).join(" "), splitString.slice(inIndex + 1, +splitString.length + 1 || 9e9).join(" "), ASTBuilder(tokens, formatters, raw_template)));
            break;
          case "comment":
            while ((tokens[0] != null) && tokens[0].string !== "endcomment") {
              tokens.shift();
            }
            if ((tokens[0] != null) && tokens[0].string === "endcomment") {
              tokens.shift();
            } else {
              Clerk.lib('logger').warn("Found start comment with no endcomment");
            }
            break;
          case "endif":
          case "endfor":
            return AST;
          default:
            Clerk.lib('logger').error("Unexpected keyword in template: " + startOfStatement);
        }
      }
      if (token instanceof ExpressionToken) {
        AST.nodes.push(createExpression(token.string, formatters));
      }
      if (token instanceof LiteralToken) {
        AST.nodes.push(new String(token.string));
      }
    }
    return AST;
  };

  createExpression = function(token, formatters) {
    var bool_regex, exp1, exp2, find_bool, find_includes, includes_reg, tokenReplaced;
    tokenReplaced = token.replace(/\|\|/, " or ");
    if (/\|/.test(tokenReplaced)) {
      return createFormatterExpression(tokenReplaced, formatters);
    }
    bool_regex = new RegExp(/\ (and|or|&&)\ /);
    if (find_bool = bool_regex.exec(tokenReplaced)) {
      exp1 = tokenReplaced.slice(0, find_bool.index);
      exp2 = tokenReplaced.slice(find_bool.index + find_bool[0].length);
      if (find_bool[1] === 'or') {
        return new Or(createExpression(exp1, formatters), createExpression(exp2, formatters));
      } else {
        return new And(createExpression(exp1, formatters), createExpression(exp2, formatters));
      }
    }
    includes_reg = new RegExp(/\b(contains|in)\b/);
    if (find_includes = includes_reg.exec(tokenReplaced)) {
      exp1 = tokenReplaced.slice(0, find_includes.index);
      exp2 = tokenReplaced.slice(find_includes.index + find_includes[0].length);
      if (find_includes[1] === 'in') {
        return new In(createExpression(exp1, formatters), createExpression(exp2, formatters));
      } else {
        return new Contains(createExpression(exp1, formatters), createExpression(exp2, formatters));
      }
    } else {
      return new Expression(tokenReplaced);
    }
  };

  consume_until = function(list, char) {
    var ret;
    ret = "";
    while (list && list[0] !== char) {
      ret += list[0];
      list = list.slice(1);
    }
    return [list, ret];
  };

  createFormatterExpression = function(formatterString, formatters) {
    var args, char, name, ref, ref1, token, tokensSplit, value, valueString;
    tokensSplit = [];
    while (formatterString) {
      char = formatterString[0];
      if (char !== '"' && char !== "'") {
        ref = consume_until(formatterString, " "), formatterString = ref[0], token = ref[1];
      } else {
        ref1 = consume_until(formatterString.slice(1), char), formatterString = ref1[0], token = ref1[1];
        token = char + token + char;
      }
      formatterString = formatterString.slice(1);
      if (token) {
        tokensSplit.push(token);
      }
    }
    valueString = "";
    while (tokensSplit[0] !== "|" && tokensSplit.length > 0) {
      valueString += tokensSplit.shift();
    }
    tokensSplit.shift();
    value = new Expression(valueString);
    while (tokensSplit.length > 0) {
      name = tokensSplit.shift();
      args = [];
      while (tokensSplit[0] !== "|" && tokensSplit.length > 0) {
        args.push(tokensSplit.shift());
      }
      tokensSplit.shift();
      value = new Formatter(formatters, value, name, args);
    }
    return value;
  };

  AST = (function() {
    function AST() {}

    AST.template = function(new_template) {
      if (new_template) {
        this.raw_template = new_template;
      }
      return this.raw_template;
    };

    AST.prototype.render = function(context) {
      return [''];
    };

    AST.prototype.value = function(context) {
      return null;
    };

    AST.prototype.attributes = function() {
      return [];
    };

    return AST;

  })();

  Template = (function(superClass) {
    extend(Template, superClass);

    function Template(nodes) {
      this.nodes = nodes != null ? nodes : [];
    }

    Template.prototype.attributes = function() {
      var node;
      return [].concat.apply([], (function() {
        var j, len, ref, results;
        ref = this.nodes;
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          node = ref[j];
          results.push(node.attributes());
        }
        return results;
      }).call(this));
    };

    Template.prototype.render = function(context) {
      var j, len, node, ref, ret, sub_rendering;
      ret = [];
      ref = this.nodes;
      for (j = 0, len = ref.length; j < len; j++) {
        node = ref[j];
        sub_rendering = node.render(context);
        if (sub_rendering) {
          ret = ret.concat(sub_rendering);
        }
      }
      return ret;
    };

    return Template;

  })(AST);

  String = (function(superClass) {
    extend(String, superClass);

    function String(string) {
      this.string = string;
    }

    String.prototype.render = function(context) {
      return [this.string];
    };

    return String;

  })(AST);

  Assign = (function(superClass) {
    extend(Assign, superClass);

    function Assign(variable, expression) {
      this.variable = variable;
      this.expression = expression;
    }

    Assign.prototype.render = function(context) {
      context[this.variable] = this.expression.value(context);
      return "";
    };

    return Assign;

  })(AST);

  And = (function(superClass) {
    extend(And, superClass);

    function And(expression1, expression2) {
      this.expression1 = expression1;
      this.expression2 = expression2;
    }

    And.prototype.attributes = function() {
      return this.expression1.attributes().concat(this.expression2.attributes());
    };

    And.prototype.render = function(context) {
      return [this.value(context).toString()];
    };

    And.prototype.value = function(context) {
      return this.expression1.value(context) && this.expression2.value(context);
    };

    return And;

  })(AST);

  Or = (function(superClass) {
    extend(Or, superClass);

    function Or(expression1, expression2) {
      this.expression1 = expression1;
      this.expression2 = expression2;
    }

    Or.prototype.attributes = function() {
      return this.expression1.attributes().concat(this.expression2.attributes());
    };

    Or.prototype.render = function(context) {
      return [this.value(context).toString()];
    };

    Or.prototype.value = function(context) {
      return this.expression1.value(context) || this.expression2.value(context);
    };

    return Or;

  })(AST);

  In = (function(superClass) {
    extend(In, superClass);

    function In(expression1, expression2) {
      this.expression1 = expression1;
      this.expression2 = expression2;
    }

    In.prototype.attributes = function() {
      return this.expression1.attributes().concat(this.expression2.attributes());
    };

    In.prototype.render = function(context) {
      return [this.value(context).toString()];
    };

    In.prototype.value = function(context) {
      return _check_existance(this.expression1.value(context), this.expression2.value(context));
    };

    return In;

  })(AST);

  Contains = (function(superClass) {
    extend(Contains, superClass);

    function Contains(expression1, expression2) {
      this.expression1 = expression1;
      this.expression2 = expression2;
    }

    Contains.prototype.attributes = function() {
      return this.expression1.attributes().concat(this.expression2.attributes());
    };

    Contains.prototype.render = function(context) {
      return [this.value(context).toString()];
    };

    Contains.prototype.value = function(context) {
      return _check_existance(this.expression2.value(context), this.expression1.value(context));
    };

    return Contains;

  })(AST);

  Expression = (function(superClass) {
    extend(Expression, superClass);

    function Expression(expression) {
      this.expression = expression;
      this.utils = Clerk.lib('utils');
      this.expression = this.expression.replace(/(^|\ )not\ /g, ' !');
    }

    Expression.prototype.attributes = function() {
      var is_attribute;
      is_attribute = function(s) {
        return /^[a-zA-Z]/.test(s) && (s !== 'true' && s !== 'false');
      };
      return this.utils.filter(is_attribute, this.expression.replace(/!/g, '').split(' '));
    };

    Expression.prototype.render = function(context) {
      var value;
      value = this.value(context);
      if (value != null) {
        if (!(typeof value.length === 'number' || typeof value === 'string')) {
          return [JSON.stringify(value)];
        } else {
          return [value.toString()];
        }
      } else {
        return [''];
      }
    };

    Expression.prototype.value = function(context) {
      var e, error, out;
      try {
        out = this.utils["eval"](this.expression, context);
        return out;
      } catch (error) {
        e = error;
        Clerk.lib('logger').warn("Could not evaluate statement '" + this.expression + "' is it missing in formatters or context? ", {
          'context': context,
          'template': AST.template(),
          'error': e
        });
        return null;
      }
    };

    return Expression;

  })(AST);

  Formatter = (function(superClass) {
    extend(Formatter, superClass);

    function Formatter(formatters1, expression, name1, args1) {
      this.formatters = formatters1;
      this.expression = expression;
      this.name = name1;
      this.args = args1 != null ? args1 : [];
      this._eval = Clerk.lib('utils')["eval"];
    }

    Formatter.prototype.attributes = function() {
      return this.expression.attributes();
    };

    Formatter.prototype.render = function(context) {
      var arg, e, error, error1, expression_value, formatter_args, j, len, ref, ref1, result;
      if (!(this.name in this.formatters)) {
        Clerk.lib('logger').warn("Could not find '" + this.name + "' in formatters", {
          'formatters': this.formatters,
          'template': AST.template()
        });
        return [""];
      }
      expression_value = this.expression.value(context);
      formatter_args = [];
      try {
        ref = this.args;
        for (j = 0, len = ref.length; j < len; j++) {
          arg = ref[j];
          formatter_args.push(this._eval(arg, context));
        }
      } catch (error) {
        e = error;
        Clerk.lib('logger').error("Error in formatter argument '" + arg + "' for '" + this.name + "'", {
          exception: e
        });
        return [""];
      }
      try {
        result = (ref1 = this.formatters)[this.name].apply(ref1, [expression_value].concat(slice.call(formatter_args)));
      } catch (error1) {
        e = error1;
        Clerk.lib('logger').error("Failed while rendering formatter '" + this.name + "'", {
          exception: e,
          value: expression_value,
          "arguments": formatter_args
        });
        return [""];
      }
      return [result];
    };

    Formatter.prototype.value = function(context) {
      var arg, expression_value, formatter_args, j, len, ref, ref1;
      expression_value = this.expression.value(context);
      formatter_args = [];
      ref = this.args;
      for (j = 0, len = ref.length; j < len; j++) {
        arg = ref[j];
        formatter_args.push(this._eval(arg, context));
      }
      return (ref1 = this.formatters)[this.name].apply(ref1, [expression_value].concat(slice.call(formatter_args)));
    };

    return Formatter;

  })(AST);

  If = (function(superClass) {
    extend(If, superClass);

    function If(condition1, template1) {
      this.condition = condition1;
      this.template = template1;
      this.utils = Clerk.lib('utils');
    }

    If.prototype.attributes = function() {
      return this.condition.attributes().concat(this.template.attributes());
    };

    If.prototype.render = function(context) {
      if (this.condition.value(context)) {
        return this.template.render(context);
      } else {
        return [''];
      }
    };

    return If;

  })(AST);

  IfElse = (function(superClass) {
    extend(IfElse, superClass);

    function IfElse(condition1, templateif, template1) {
      this.condition = condition1;
      this.templateif = templateif;
      this.template = template1;
      this.utils = Clerk.lib('utils');
    }

    IfElse.prototype.attributes = function() {
      return (this.condition.attributes().concat(this.template.attributes())).concat(this.templateif.attributes());
    };

    IfElse.prototype.render = function(context) {
      if (this.condition.value(context)) {
        return this.templateif.render(context);
      } else {
        return this.template.render(context);
      }
    };

    return IfElse;

  })(AST);

  For = (function(superClass) {
    extend(For, superClass);

    function For(replaceName, itterableName, template1) {
      this.replaceName = replaceName;
      this.itterableName = itterableName;
      this.template = template1;
      this._eval = Clerk.lib('utils')["eval"];
    }

    For.prototype.attributes = function() {
      var attribute, inner_attributes, j, len, replaced_attributes;
      inner_attributes = this.template.attributes();
      replaced_attributes = [];
      for (j = 0, len = inner_attributes.length; j < len; j++) {
        attribute = inner_attributes[j];
        replaced_attributes.push(attribute.replace(this.replaceName, this.itterableName));
      }
      return replaced_attributes.concat([this.itterableName]);
    };

    For.prototype.render = function(context) {
      var e, element, error, i, itterList, j, len, ret;
      ret = [];
      try {
        itterList = this._eval(this.itterableName, context);
      } catch (error) {
        e = error;
        Clerk.lib('logger').warn("Could not find '" + this.itterableName + "' in context", {
          'context': context,
          'template': AST.template(),
          'error': e
        });
      }
      if (!itterList) {
        return '';
      }
      i = 0;
      for (j = 0, len = itterList.length; j < len; j++) {
        element = itterList[j];
        if (i > 2000) {
          break;
        }
        context[this.replaceName] = element;
        context['loop'] = {
          index: i,
          index0: i,
          length: itterList.length,
          first: i === 0,
          last: i === itterList.length - 1
        };
        Array.prototype.push.apply(ret, this.template.render(context));
        i++;
      }
      return ret;
    };

    return For;

  })(AST);

  _indexOf = function(list, item) {
    var element, i, j, len;
    if (list.indexOf) {
      return list.indexOf(item);
    } else {
      i = 0;
      for (j = 0, len = list.length; j < len; j++) {
        element = list[j];
        if (element === item) {
          return i;
        }
        i++;
      }
    }
  };

  _filter_empty = function(list) {
    var element, j, len, no_empty;
    if (list.filter) {
      return list.filter(Boolean);
    } else {
      no_empty = [];
      for (j = 0, len = list.length; j < len; j++) {
        element = list[j];
        if (element !== "") {
          no_empty.push(element);
        }
      }
      return no_empty;
    }
  };

  _trim = function(str) {
    if (str.trim) {
      return str.trim();
    } else {
      return str.replace(/^\s+|\s+$/g, '');
    }
  };

  _check_existance = function(x, xs) {
    var element, j, len;
    if ((xs == null) || !xs) {
      return false;
    }
    if (typeof xs.length === 'number' || typeof xs === 'string') {
      if (!Array.prototype.indexOf && typeof xs !== 'string') {
        for (j = 0, len = xs.length; j < len; j++) {
          element = xs[j];
          if (element === x) {
            return true;
          }
        }
        return false;
      } else {
        return xs.indexOf(x) !== -1;
      }
    } else {
      return indexOf.call(xs, x) >= 0 || xs.hasOwnProperty(x);
    }
  };

}).call(this);

/*
 * File: src/utils/dom.coffee 
 */

/* 
The DOM library handles all clerk interactions with the DOM

The most used function is 'find', which searches the dom for a given css selector and returns
an elementSet containing the elements as a clerk Element.
 */

(function() {
  var Clerk, Element, ElementSet, Event, _callback_counter, _css_list, getElementsByClassName, get_browser, get_os, is_incognito, matchesSelector, parsePixelValue,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
    slice = [].slice;

  Clerk = window.Clerk;

  _callback_counter = 0;

  _css_list = [];

  Clerk.lib('dom', {
    create: function(html) {
      var wrapper;
      wrapper = new Element(document.createElement('div'));
      wrapper.html(html);
      return new ElementSet(wrapper.children());
    },
    css: function(style) {
      var create_container, css_container, dom, header, old_style;
      dom = Clerk.lib('dom');
      if (style == null) {
        return;
      }
      if (indexOf.call(_css_list, style) >= 0) {
        return;
      }
      _css_list.push(style);
      css_container = dom.find('#__clerk-global-default-css');
      header = dom.find('head')[0];
      create_container = function(new_style) {
        css_container = document.createElement('style');
        css_container.type = 'text/css';
        css_container.id = '__clerk-global-default-css';
        if (css_container.styleSheet) {
          css_container.styleSheet.cssText = new_style;
        } else {
          css_container.innerHTML = new_style;
        }
        return header.prepend(new Element(css_container));
      };
      if (css_container.length > 0) {
        old_style = css_container[0].raw().innerHTML;
        header.raw().removeChild(css_container[0].raw());
        return create_container(old_style + "\n" + style);
      } else {
        return create_container(style);
      }
    },
    find: function(selector, context) {
      var _element, _elements, _filter, _find_elements, _in, _intersection, _trim, browser, candidates, element, elements, formatter, formatters, i, id, id_element, j, k, l, len, len1, len2, len3, name, query, ref, ref1, ref2, rule, rules, value;
      if (context == null) {
        context = document;
      }
      browser = get_browser();
      if (context.querySelectorAll && !(browser.name === "MSIE" && browser.version < 9)) {
        elements = context.querySelectorAll(selector);
        if (context !== document && matchesSelector(context, selector)) {
          elements = Array.prototype.slice.call(elements);
          elements.push(context);
        }
      } else {
        _in = function(x, ys) {
          var i, len, y;
          for (i = 0, len = ys.length; i < len; i++) {
            y = ys[i];
            if (x === y) {
              return true;
            }
          }
          return false;
        };
        _filter = function(xs, f) {
          var i, len, results, x;
          results = [];
          for (i = 0, len = xs.length; i < len; i++) {
            x = xs[i];
            if (f(x)) {
              results.push(x);
            }
          }
          return results;
        };
        _intersection = function(s1, s2) {
          var i, len, results, s;
          results = [];
          for (i = 0, len = s1.length; i < len; i++) {
            s = s1[i];
            if (_in(s, s2)) {
              results.push(s);
            }
          }
          return results;
        };
        _find_elements = function(ctxt, f) {
          var elm, elms, i, len, ref;
          elms = [];
          ref = ctxt.childNodes;
          for (i = 0, len = ref.length; i < len; i++) {
            elm = ref[i];
            if (elm.nodeType === 1) {
              if (f(elm)) {
                elms.push(elm);
              }
              Array.prototype.push.apply(elms, _find_elements(elm, f));
            }
          }
          return elms;
        };
        _trim = function(s) {
          return s.replace(/^\s+|\s+$/g, '');
        };
        elements = [];
        if (typeof selector === "object") {
          selector = selector.join(',');
        }
        ref = selector.split(',');
        for (i = 0, len = ref.length; i < len; i++) {
          query = ref[i];
          _elements = null;
          rules = (function() {
            var j, len1, ref1, results;
            ref1 = _trim(query).split(/\s+/g);
            results = [];
            for (j = 0, len1 = ref1.length; j < len1; j++) {
              rule = ref1[j];
              results.push(_trim(rule));
            }
            return results;
          })();
          for (j = 0, len1 = rules.length; j < len1; j++) {
            rule = rules[j];
            formatters = rule.slice(1).split(/\.|\[/g);
            id = rule.substring(0, 1);
            rule = formatters[0];
            formatters = formatters.slice(1);
            switch (id) {
              case '#':
                if (context.getElementById) {
                  candidates = [];
                  id_element = context.getElementById(rule);
                  if (id_element) {
                    candidates.push(id_element);
                  }
                } else {
                  candidates = _find_elements(context, function(e) {
                    return e.id === rule;
                  });
                }
                break;
              case '.':
                candidates = getElementsByClassName(rule, context);
                break;
              case '[':
                ref1 = rule.slice(0, -1).split('='), name = ref1[0], value = ref1[1];
                if (value) {
                  candidates = _find_elements(context, function(e) {
                    return e.getAttribute(name) === value.replace(/"/g, "") || e.getAttribute(name) === value;
                  });
                } else {
                  candidates = _find_elements(context, function(e) {
                    return e.hasAttribute(name);
                  });
                }
                break;
              case '*':
                candidates = _find_elements(context, Boolean);
                break;
              default:
                candidates = context.getElementsByTagName(id + rule);
            }
            for (k = 0, len2 = formatters.length; k < len2; k++) {
              formatter = formatters[k];
              if (formatter[formatter.length - 1] === ']') {
                ref2 = formatter.slice(0, -1).split('='), name = ref2[0], value = ref2[1];
                if (value) {
                  candidates = _formatter(candidates, function(e) {
                    return e.getAttribute(name) === value;
                  });
                } else {
                  candidates = _formatter(candidates, function(e) {
                    return e.hasAttribute(name);
                  });
                }
              } else {
                candidates = _formatter(candidates, function(e) {
                  return _in(formatter, e.className.match(/\S+/g));
                });
              }
            }
            if (_elements === null) {
              _elements = candidates;
            } else {
              _elements = _intersection(_elements, candidates);
            }
          }
          for (l = 0, len3 = _elements.length; l < len3; l++) {
            _element = _elements[l];
            if (!_in(_element, elements)) {
              elements.push(_element);
            }
          }
        }
      }
      return new ElementSet((function() {
        var len4, m, results;
        results = [];
        for (m = 0, len4 = elements.length; m < len4; m++) {
          element = elements[m];
          results.push(new Element(element));
        }
        return results;
      })());
    },
    jsonp: function(url, data) {
      var callback, deferred, key, q, script, value;
      q = Clerk.lib('q');
      deferred = q.defer();
      if (!data) {
        data = {};
      }
      callback = '__clerk_cb_' + (_callback_counter++);
      window[callback] = (function(_this) {
        return function(data) {
          var browser, element;
          browser = get_browser();
          if (browser.name === "MSIE" && browser.version < 9) {
            window[callback] = void 0;
          } else {
            delete window[callback];
          }
          element = document.getElementById(callback);
          element.parentNode.removeChild(element);
          return deferred.resolve(data);
        };
      })(this);
      data.callback = callback;
      data = ((function() {
        var results;
        results = [];
        for (key in data) {
          value = data[key];
          results.push((encodeURIComponent(key)) + "=" + (encodeURIComponent(value)));
        }
        return results;
      })()).join('&');
      url = url + (url.indexOf('?' >= 0) ? '?' : '&') + data;
      script = document.createElement('script');
      script.src = url;
      script.id = callback;
      (new Element(script)).on('error', function() {
        return deferred.reject();
      });
      (document.getElementsByTagName('head')[0] || document.body || document.documentElement).appendChild(script);
      return deferred.promise;
    },
    window: function() {
      return {
        width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
        height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
        scrolled: window.pageYOffset || document.documentElement.scrollTop
      };
    },
    device: function() {
      var _browser;
      _browser = get_browser();
      is_incognito(_browser);
      return {
        is_mobile: window.innerWidth < 600,
        is_tablet: window.innerWidth < 800 && window.innerWidth >= 600,
        is_desktop: window.innerWidth >= 800,
        browser: _browser,
        os: get_os()
      };
    }
  });

  Element = (function() {
    function Element(_element1) {
      this._element = _element1;
    }

    Element.prototype.tag_name = function() {
      return this._element.tagName;
    };

    Element.prototype.attribute = function(name, value) {
      if (value === null) {
        this._element.removeAttribute(name);
        return this;
      } else if (value) {
        this._element.setAttribute(name, value);
        return this;
      } else {
        return this._element.getAttribute(name);
      }
    };

    Element.prototype.data = function(name, value) {
      var attribute, data, decode, i, json, len, ref;
      if (value == null) {
        value = void 0;
      }
      json = Clerk.lib('json');
      decode = function(value) {
        var error;
        try {
          return json.decode(value);
        } catch (error) {
          return value;
        }
      };
      if (value !== void 0) {
        this.attribute('data-' + name, json.encode(value));
        return this;
      } else if (name) {
        return decode(this.attribute('data-' + name));
      } else {
        data = {};
        ref = this.raw().attributes;
        for (i = 0, len = ref.length; i < len; i++) {
          attribute = ref[i];
          if (attribute.name.slice(0, 5) === 'data-') {
            data[attribute.name.slice(5)] = decode(attribute.value);
          }
        }
        return data;
      }
    };

    Element.prototype.value = function(value) {
      if (value != null) {
        this.raw().value = value;
        return this;
      } else {
        return this.raw().value;
      }
    };

    Element.prototype["class"] = function() {
      return {
        has: (function(_this) {
          return function(name) {
            if (_this._element.classList != null) {
              return _this._element.classList.contains(name);
            } else {
              return _this._element.className.indexOf(name) !== -1;
            }
          };
        })(this),
        add: (function(_this) {
          return function(name) {
            if (_this._element.classList != null) {
              return _this._element.classList.add(name);
            } else {
              return _this._element.className += _this._element.className ? " " + name : name;
            }
          };
        })(this),
        remove: (function(_this) {
          return function(name) {
            if (_this._element.classList != null) {
              return _this._element.classList.remove(name);
            } else {
              return _this._element.className = _this._element.className ? _this._element.className.remove(name) : _this._element.className;
            }
          };
        })(this)
      };
    };

    Element.prototype.find = function(selector) {
      var dom;
      dom = Clerk.lib('dom');
      return dom.find(selector, this._element);
    };

    Element.prototype.raw = function() {
      return this._element;
    };

    Element.prototype.nearest_parent = function(selector) {
      var element;
      element = this._element;
      while (element !== window.document && element) {
        if (this.matches(selector, element)) {
          return element;
        } else {
          element = element.parentNode;
        }
      }
      return null;
    };

    Element.prototype.matches = function(selector, context) {
      var i, len, matching_element, ref;
      if (context == null) {
        context = document;
      }
      if (context.matches) {
        return this._element.matches(selector);
      }
      if (context.matchesSelector) {
        return this._element.matchesSelector(selector);
      }
      if (context.msMatchesSelector) {
        return this._element.msMatchesSelector(selector);
      }
      if (context.webkitMatchesSelector) {
        return this._element.webkitMatchesSelector(selector);
      }
      ref = this.find(selector);
      for (i = 0, len = ref.length; i < len; i++) {
        matching_element = ref[i];
        if (matching_element._element === this._element) {
          return true;
        }
      }
      return false;
    };

    Element.prototype.children = function() {
      var child;
      return new ElementSet((function() {
        var i, len, ref, results;
        ref = this._element.childNodes;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          child = ref[i];
          if (child.nodeType === 1) {
            results.push(new Element(child));
          }
        }
        return results;
      }).call(this));
    };

    Element.prototype.parent = function() {
      return new Element(this._element.parentNode);
    };

    Element.prototype.prepend = function(element) {
      this._element.insertBefore(element.raw(), this._element.firstChild);
      return this;
    };

    Element.prototype.append = function(element) {
      this._element.appendChild(element.raw());
      return this;
    };

    Element.prototype.size = function() {
      var NaN_check, border_bottom, border_left, border_right, border_top, element_height, element_width, margin_bottom, margin_left, margin_right, margin_top, padding_bottom, padding_left, padding_right, padding_top;
      NaN_check = function(num) {
        if (isNaN(num)) {
          return 0;
        } else {
          return num;
        }
      };
      element_width = this._element.offsetWidth;
      element_height = this._element.offsetHeight;
      padding_top = NaN_check(parsePixelValue(this.css('padding-top')));
      padding_bottom = NaN_check(parsePixelValue(this.css('padding-bottom')));
      padding_left = NaN_check(parsePixelValue(this.css('padding-left')));
      padding_right = NaN_check(parsePixelValue(this.css('padding-right')));
      border_top = NaN_check(parsePixelValue(this.css('border-top-width')));
      border_bottom = NaN_check(parsePixelValue(this.css('border-bottom-width')));
      border_left = NaN_check(parsePixelValue(this.css('border-left-width')));
      border_right = NaN_check(parsePixelValue(this.css('border-right-width')));
      margin_top = NaN_check(parsePixelValue(this.css('margin-top')));
      margin_bottom = NaN_check(parsePixelValue(this.css('margin-bottom')));
      margin_left = NaN_check(parsePixelValue(this.css('margin-left')));
      margin_right = NaN_check(parsePixelValue(this.css('margin-right')));
      return {
        width: element_width,
        height: element_height,
        inner: {
          width: element_width - padding_left - padding_right - border_left - border_right,
          height: element_height - padding_top - padding_bottom - border_top - border_bottom
        },
        outer: {
          width: element_width + margin_left + margin_right,
          height: element_height + margin_top + margin_bottom
        }
      };
    };

    Element.prototype.position = function(top, left) {
      var rectangle;
      if (isFinite(top)) {
        this.css('top', top + "px");
      }
      if (isFinite(left)) {
        this.css('left', left + "px");
      }
      rectangle = this.raw().getBoundingClientRect();
      return {
        left: rectangle.left,
        top: rectangle.top
      };
    };

    Element.prototype.html = function(html) {
      var i, len, newdiv, ref, script, script_element;
      if (html != null) {
        this._element.innerHTML = html;
        newdiv = document.createElement('div');
        newdiv.innerHTML = html;
        ref = newdiv.getElementsByTagName('script');
        for (i = 0, len = ref.length; i < len; i++) {
          script = ref[i];
          script_element = document.createElement('script');
          script_element.innerHTML = script.innerHTML;
          this._element.innerHTML = this._element.innerHTML.split(script_element.outerHTML).join("");
          this._element.appendChild(script_element);
        }
        return this;
      } else {
        return this._element.outerHTML;
      }
    };

    Element.prototype.text = function(text) {
      if (text != null) {
        if (this._element.textContent != null) {
          return this._element.textContent = text;
        } else {
          return this._element.innerText = text;
        }
      } else {
        if (this._element.textContent != null) {
          return this._element.textContent;
        } else {
          return this._element.innerText;
        }
      }
    };

    Element.prototype.css = function(name, value) {
      var styleName, styleValue;
      if (value) {
        this._element.style.cssText = this._element.style.cssText + "; " + name + ": " + value;
        return this;
      } else {
        styleValue = '';
        if (document.defaultView && document.defaultView.getComputedStyle) {
          styleValue = document.defaultView.getComputedStyle(this._element, '').getPropertyValue(name);
        } else if (this._element.currentStyle) {
          if (name.replace) {
            styleName = name.replace(/\-(\w)/g, function(strMatch, p1) {
              return p1.toUpperCase();
            });
          } else {
            styleName = name;
          }
          styleValue = this._element.currentStyle[styleName];
        }
        return styleValue;
      }
    };

    Element.prototype.on = function(name) {
      var deferred, handler, q;
      q = Clerk.lib('q');
      deferred = q.defer();
      handler = (function(_this) {
        return function(e) {
          return deferred.resolve(new Event(e || window.event, _this));
        };
      })(this);
      if (this._element.addEventListener) {
        this._element.addEventListener(name, handler, false);
      } else if (this._element.attachEvent) {
        if (name === "input" && get_browser().version < 9) {
          name = "propertychange";
        }
        this._element.attachEvent("on" + name, handler);
      } else {
        name = "on" + name;
        if (typeof this._element[name] === 'function') {
          handler = (function(f1, f2) {
            return function() {
              f1.apply(this, arguments);
              return f2.apply(this, arguments);
            };
          })(this._element[name], handler);
        }
        this._element[name] = handler;
      }
      return deferred.promise;
    };

    Element.prototype.swipe = function() {
      var deferred, drag, q, start, stop, unify;
      q = Clerk.lib('q');
      deferred = q.defer();
      if (this._element.addEventListener) {
        unify = (function(_this) {
          return function(e) {
            if (e.changedTouches) {
              return e.changedTouches[0];
            } else {
              return e;
            }
          };
        })(this);
        start = (function(_this) {
          return function(e) {
            _this._x0 = unify(e).clientX;
            return _this._y0 = unify(e).clientY;
          };
        })(this);
        stop = (function(_this) {
          return function(e) {
            var dx, dy;
            if (_this._y0 || _this._y0 === 0) {
              dy = unify(e).clientY - _this._y0;
              _this._y0 = null;
            }
            if (_this._x0 || _this._x0 === 0) {
              dx = unify(e).clientX - _this._x0;
              _this._x0 = null;
            }
            return deferred.resolve(dx, dy);
          };
        })(this);
        drag = (function(_this) {
          return function(e) {
            var dx, dy;
            if (_this._y0 || _this._y0 === 0) {
              dy = unify(e).clientY - _this._y0;
            }
            if (_this._x0 || _this._x0 === 0) {
              dx = unify(e).clientX - _this._x0;
            }
            return deferred.notify(dx, dy);
          };
        })(this);
        this._element.addEventListener('mousedown', start, false);
        this._element.addEventListener('touchstart', start, false);
        this._element.addEventListener('mousemove', drag, false);
        this._element.addEventListener('touchmove', drag, false);
        this._element.addEventListener('mouseup', stop, false);
        this._element.addEventListener('touchend', stop, false);
        this._element.addEventListener('mouseleave', stop, false);
      }
      return deferred.promise;
    };

    Element.prototype.off = function(name) {};

    Element.prototype.trigger = function(name) {
      var event;
      if (document.createEvent) {
        event = document.createEvent('HTMLEvents');
        event.initEvent(name, true, true);
      } else {
        event = document.createEventObject();
        event.eventType = name;
      }
      event.eventName = name;
      if (document.createEvent) {
        return this._element.dispatchEvent(event);
      } else {
        return this._element.fireEvent("on" + event.eventType, event);
      }
    };

    return Element;

  })();

  Event = (function() {
    function Event(_event, element1) {
      this._event = _event;
      this.element = element1;
      this.type = this._event.type;
    }

    Event.prototype.raw = function() {
      return this._event;
    };

    Event.prototype.stopPropagation = function(allow_default) {
      if (this._event.stopPropagation) {
        if (!this._event.defaultPrevented) {
          if (!allow_default) {
            this._event.preventDefault();
          }
          this._event.stopPropagation();
          return this._event.stopImmediatePropagation();
        }
      } else {
        return this._event.cancelBubble = true;
      }
    };

    Event.prototype.continuePropagation = function() {
      var browser, newEvent;
      if (this._event.defaultPrevented) {
        newEvent = document.createEvent('MouseEvent');
        newEvent.initMouseEvent(this._event.type, this._event.bubbles, this._event.cancelable, this._event.view, this._event.detail, this._event.screenX, this._event.screenY, this._event.clientX, this._event.clientY, this._event.ctrlKey, this._event.altKey, this._event.shiftKey, this._event.metaKey, this._event.button, this._event.relatedTarget);
        browser = get_browser();
        if (browser.name === "MSIE" && browser.version < 9) {
          return this.element._element.parentNode.fireEvent(newEvent);
        } else {
          return this.element._element.parentNode.dispatchEvent(newEvent);
        }
      }
    };

    return Event;

  })();

  ElementSet = (function() {
    ElementSet.prototype.push = function(item) {
      this[this.length] = item;
      return this.length++;
    };

    ElementSet.prototype.contains = function(element) {
      var i, item, len;
      for (i = 0, len = this.length; i < len; i++) {
        item = this[i];
        if (item._element === element._element) {
          return true;
        }
      }
      return false;
    };

    function ElementSet(items) {
      var f, i, item, len, name, ref;
      this.length = 0;
      for (i = 0, len = items.length; i < len; i++) {
        item = items[i];
        this[this.length] = item;
        this.length++;
      }
      this.type = "ElementSet";
      ref = this[0] || new Element();
      for (name in ref) {
        f = ref[name];
        if (name[0] !== '_') {
          ElementSet.prototype[name] = ((function(_this) {
            return function(name) {
              return function() {
                var args, element, j, len1, result, value;
                args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
                result = [];
                for (j = 0, len1 = _this.length; j < len1; j++) {
                  element = _this[j];
                  value = element[name].apply(element, args);
                  if (value instanceof Array) {
                    Array.prototype.push.apply(result, value);
                  } else {
                    result.push(value);
                  }
                  if (result.length > 0 && result[0] instanceof Element) {
                    result = new ElementSet(result);
                  }
                }
                return result;
              };
            };
          })(this))(name);
        }
      }
      return this;
    }

    return ElementSet;

  })();

  matchesSelector = function(element, selector) {
    var f, p;
    p = window.Element.prototype;
    f = p.matches || p.webkitMatchesSelector || p.mozMatchesSelector || p.msMatchesSelector || function(s) {
      return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
    };
    return f.call(element, selector);
  };

  parsePixelValue = function(value) {
    return parseInt(value.replace('px', ''));
  };

  getElementsByClassName = function(className, context) {
    var checking, class_, classesToCheck, element, elements, i, j, k, len, len1, len2, match, ref, returnElements;
    if (context == null) {
      context = document;
    }
    context = context.parentNode === null ? context : context.parentNode;
    if (context.getElementsByClassName) {
      return context.getElementsByClassName(className);
    }
    classesToCheck = [];
    returnElements = [];
    if (context !== document && indexOf.call(context.className.split(' '), className) >= 0) {
      returnElements.push(context);
    }
    ref = className.split(" ");
    for (i = 0, len = ref.length; i < len; i++) {
      class_ = ref[i];
      classesToCheck.push(new RegExp("(^|\\s)" + class_ + "(\\s|$)"));
    }
    elements = context.all !== void 0 ? context.all : context.getElementsByTagName('*');
    for (j = 0, len1 = elements.length; j < len1; j++) {
      element = elements[j];
      match = false;
      for (k = 0, len2 = classesToCheck.length; k < len2; k++) {
        checking = classesToCheck[k];
        match = checking.test(element.className);
        if (!match) {
          break;
        }
      }
      if (match) {
        returnElements.push(element);
      }
    }
    return returnElements;
  };

  get_os = function() {
    var name, version;
    name = 'Unknown';
    version = 'Unknown';
    if (window.navigator.userAgent.indexOf("Windows NT 10.0") !== -1) {
      name = "Windows 10";
      version = "10.0";
    } else if (window.navigator.userAgent.indexOf("Windows NT 6.2") !== -1) {
      name = "Windows 8";
      version = "6.2";
    } else if (window.navigator.userAgent.indexOf("Windows NT 6.1") !== -1) {
      name = "Windows 7";
      version = "6.1";
    } else if (window.navigator.userAgent.indexOf("Windows NT 6.0") !== -1) {
      name = "Windows Vista";
      version = "6.0";
    } else if (window.navigator.userAgent.indexOf("Windows NT 5.1") !== -1) {
      name = "Windows XP";
      version = "5.1";
    } else if (window.navigator.userAgent.indexOf("Windows NT 5.0") !== -1) {
      name = "Windows 2000";
      version = "5.0";
    } else if (window.navigator.userAgent.indexOf("Mac OS X") !== -1) {
      name = "Mac/iOS";
      version = navigator.userAgent.match(/Mac OS X ([\d_]+)/)[1];
    } else if (window.navigator.userAgent.indexOf("Linux") !== -1) {
      name = "Linux";
      version = navigator.userAgent.match(/Linux (x?[\d_]+)/)[1];
    }
    return {
      'name': name,
      'version': version
    };
  };

  get_browser = function() {
    var M, tem, ua;
    ua = navigator.userAgent;
    M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return {
        name: 'IE',
        version: tem[1] || '',
        language: navigator.language
      };
    }
    if (/chrome/i.test(M[1])) {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem !== null) {
        return {
          name: tem[1],
          version: tem[2],
          language: navigator.language
        };
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    tem = ua.match(/version\/(\d+)/i);
    if (tem !== null) {
      M.splice(1, 1, tem[1]);
    }
    return {
      name: M[0],
      version: M[1],
      language: navigator.language
    };
  };

  is_incognito = function(_browser) {
    var db, e, error, fs, incognito, not_incognito;
    if (/chrome/i.test(_browser.name)) {
      incognito = (function(_this) {
        return function() {
          return _browser.is_incognito = true;
        };
      })(this);
      not_incognito = (function(_this) {
        return function() {
          return _browser.is_incognito = false;
        };
      })(this);
      fs = window.RequestFileSystem || window.webkitRequestFileSystem;
      fs(window.TEMPORARY, 100, not_incognito, incognito);
      return;
    }
    if (/safari/i.test(_browser.name)) {
      try {
        localStorage.test = 2;
        _browser.is_incognito = false;
      } catch (error) {
        e = error;
        _browser.is_incognito = true;
      }
      return;
    }
    if (/firefox/i.test(_browser.name)) {
      db = indexedDB.open("test");
      db.onerror = function() {
        return _browser.is_incognito = true;
      };
      db.onsuccess = function() {
        return _browser.is_incognito = false;
      };
      return;
    }
    if (/ie|edge/i.test(_browser.name)) {
      if (!window.indexedDB && (window.PointerEvent || window.MSPointerEvent)) {
        _browser.is_incognito = true;
      } else {
        _browser.is_incognito = false;
      }
      return;
    }
    return _browser.is_incognito = false;
  };

}).call(this);

/*
 * File: src/utils/q.coffee 
 */
(function() {
  var Clerk, Deferred, Promise,
    slice = [].slice;

  Clerk = window.Clerk;

  Clerk.lib('q', {
    defer: function() {
      return new Deferred();
    }
  });

  Deferred = (function() {
    function Deferred() {
      this.promise = new Promise();
    }

    Deferred.prototype.resolve = function() {
      var args, ref;
      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      return (ref = this.promise)._resolve.apply(ref, args);
    };

    Deferred.prototype.reject = function() {
      var args, ref;
      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      return (ref = this.promise)._reject.apply(ref, args);
    };

    Deferred.prototype.notify = function() {
      var args, ref;
      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      return (ref = this.promise)._notify.apply(ref, args);
    };

    return Deferred;

  })();

  Promise = (function() {
    function Promise() {
      this._isFulfilled = false;
      this._isRejected = false;
      this._onFulfilled = [];
      this._onRejected = [];
      this._onUpdate = [];
      this._args = null;
    }

    Promise.prototype.then = function(onFulfilled, onRejected) {
      if (this._isFulfilled) {
        onFulfilled.apply(null, this._args);
      } else if (this._isRejected) {
        onRejected.apply(null, this._args);
      } else {
        if (onFulfilled) {
          this._onFulfilled.push(onFulfilled);
        }
        if (onRejected) {
          this._onRejected.push(onRejected);
        }
      }
      return this;
    };

    Promise.prototype["catch"] = function(onRejected) {
      if (this._isRejected) {
        onRejected.apply(null, this._args);
      } else {
        this._onRejected.push(onRejected);
      }
      return this;
    };

    Promise.prototype.update = function(onUpdate) {
      this._onUpdate.push(onUpdate);
      return this;
    };

    Promise.prototype._resolve = function() {
      var args, f, i, len, ref, results;
      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      this._isFulfilled = true;
      this._args = args;
      ref = this._onFulfilled;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        f = ref[i];
        results.push(f.apply(null, args));
      }
      return results;
    };

    Promise.prototype._reject = function() {
      var args, f, i, len, ref, results;
      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      this._isRejected = true;
      this._args = args;
      ref = this._onRejected;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        f = ref[i];
        results.push(f.apply(null, args));
      }
      return results;
    };

    Promise.prototype._notify = function() {
      var args, f, i, len, ref, results;
      args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      ref = this._onUpdate;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        f = ref[i];
        results.push(f.apply(null, args));
      }
      return results;
    };

    return Promise;

  })();

}).call(this);

/*
 * File: src/utils/json.coffee 
 */
(function() {
  var Clerk, parse, stringify;

  Clerk = window.Clerk;

  stringify = function(value) {
    var key, typeIsArray, val;
    typeIsArray = Array.isArray || function(value) {
      return {}.toString.call(value) === '[object Array]';
    };
    if (typeIsArray(value)) {
      return "[" + (((function() {
        var i, len, results;
        results = [];
        for (i = 0, len = value.length; i < len; i++) {
          val = value[i];
          results.push(stringify(val));
        }
        return results;
      })()).join(', ')) + "]";
    } else if (typeof value === 'object') {
      return "{" + (((function() {
        var results;
        results = [];
        for (key in value) {
          val = value[key];
          results.push(stringify(key) + ': ' + stringify(val));
        }
        return results;
      })()).join(', ')) + "}";
    } else if (typeof value === 'string') {
      return '"' + value + '"';
    } else {
      return "" + value;
    }
  };

  parse = function(json) {
    var matchesJson;
    matchesJson = /(\[|\{\"|[0-9]|\')/;
    if (matchesJson.test(json.substr(0, 1))) {
      return Clerk.lib('utils')["eval"]("(" + json + ")");
    }
    if (json === "true" || json === "false" || json === 'null') {
      return Clerk.lib('utils')["eval"]("(" + json + ")");
    }
    throw new Error("invalid json: " + json);
  };

  Clerk.lib('json', {
    encode: window.JSON && typeof window.JSON.stringify === 'function' ? JSON.stringify : stringify,
    decode: window.JSON && typeof window.JSON.parse === 'function' ? JSON.parse : parse
  });

}).call(this);

/*
 * File: src/utils/storage.coffee 
 */
(function() {
  var Clerk;

  Clerk = window.Clerk;

  Clerk.lib('storage', {
    get: function(key) {
      var json, value;
      value = localStorage.getItem(key);
      if (!value) {
        value = sessionStorage.getItem(key);
      }
      if (value) {
        json = Clerk.lib('json');
        return json.decode(value);
      }
    },
    set: function(key, value, persistent) {
      var json;
      if (persistent == null) {
        persistent = true;
      }
      json = Clerk.lib('json');
      return (persistent ? localStorage : sessionStorage).setItem(key, json.encode(value));
    },
    remove: function(key) {
      localStorage.removeItem(key);
      return sessionStorage.removeItem(key);
    }
  });

}).call(this);

/*
 * File: src/utils/utils.coffee 
 */
(function() {
  var Clerk, __unique_name_global_counter, _eval, _fast_eval, _key_path_lookup;

  Clerk = window.Clerk;

  __unique_name_global_counter = 0;

  Clerk.lib('utils', {
    sleep: function(milliseconds) {
      var start;
      start = new Date().getTime();
      while (true) {
        if ((new Date().getTime() - start) >= milliseconds) {
          break;
        }
      }
      return null;
    },
    unique_name: function() {
      __unique_name_global_counter++;
      return 'clerk-' + __unique_name_global_counter;
    },
    trim: function(str) {
      return str.replace(/^\s+|\s+$/g, '');
    },
    filter: function(f, xs) {
      var i, len, results, x;
      results = [];
      for (i = 0, len = xs.length; i < len; i++) {
        x = xs[i];
        if (f(x)) {
          results.push(x);
        }
      }
      return results;
    },
    "eval": function(code, environment) {
      if (environment == null) {
        environment = {};
      }
      return _fast_eval(code, environment);
    },
    type: function(obj) {
      if (obj === void 0 || obj === null) {
        return 'null';
      }
      switch (Object.prototype.toString.call(obj)) {
        case '[object Boolean]':
          return 'boolean';
        case '[object Number]':
          return 'number';
        case '[object String]':
          return 'string';
        case '[object Function]':
          return 'function';
        case '[object Array]':
          return 'array';
        case '[object Date]':
          return 'date';
        case '[object RegExp]':
          return 'regexp';
        case '[object Object]':
          return 'object';
      }
    },
    get_URI_components: function() {
      var components, i, key, len, param, params, ref, ref1, value;
      components = {};
      if (window.location.search.length > 1) {
        params = window.location.search.replace('?', '');
        ref = params.split('&');
        for (i = 0, len = ref.length; i < len; i++) {
          param = ref[i];
          ref1 = param.split('='), key = ref1[0], value = ref1[1];
          if (key && value) {
            components[key] = value;
          }
        }
      }
      return components;
    }
  });


  /* eval helper methods */

  _fast_eval = function(code, environment) {
    var exp1, exp2, expr, op;
    code = code.replace(/^\s+|\s+$/g, "");
    if (code.charAt(0) === '!') {
      return !_fast_eval(code.slice(1), environment);
    }
    if (code === 'false') {
      return false;
    }
    if (code === 'true') {
      return true;
    }
    if (code.match(/^[0-9]*$/)) {
      return parseInt(code);
    }
    if (code.match(/^[0-9]+\.[0-9]$/)) {
      return parseFloat(code);
    }
    if (code.match(/^"[^"]*"$/) || code.match(/^'[^']*'$/)) {
      return code.slice(1, -1);
    }
    if (code.match(/^[A-Za-z][A-Za-z0-9._]*$/)) {
      return _key_path_lookup(code, environment);
    }
    expr = code.match(/([0-9a-zA-Z._'"\[\]]+)\s*([!=<>]+[=]?)\s*([0-9a-zA-Z._'"\[\]]+)/);
    if (expr) {
      exp1 = _fast_eval(expr[1], environment);
      op = expr[2];
      exp2 = _fast_eval(expr[3], environment);
      switch (op) {
        case '==':
          return exp1 === exp2;
        case '!=':
          return exp1 !== exp2;
        case '>=':
          return exp1 >= exp2;
        case '<=':
          return exp1 <= exp2;
        case '<':
          return exp1 < exp2;
        case '>':
          return exp1 > exp2;
      }
    }
    return _eval(code, environment);
  };

  _eval = function(code, environment) {
    var f, key, marker, regex, special_char_checker, val;
    for (key in environment) {
      val = environment[key];
      if (!(key)) {
        continue;
      }
      regex = RegExp('\\b' + key + '\\b', 'g');
      special_char_checker = regex.exec(code);
      if (special_char_checker != null) {
        marker = code.substring(special_char_checker.index - 1, special_char_checker.index);
        if (marker === '.') {
          continue;
        }
      }
      code = code.replace(regex, "environment." + key);
    }
    f = new Function('environment', "return " + code);
    return f(environment);
  };

  _key_path_lookup = function(key_path, dictionary) {
    var i, key, len, ref;
    ref = key_path.split('.');
    for (i = 0, len = ref.length; i < len; i++) {
      key = ref[i];
      dictionary = dictionary[key];
    }
    return dictionary;
  };

}).call(this);

/*
 * File: src/utils/facet_tools.coffee 
 */
(function() {
  var Clerk, DEFAULT_FACET_CSS, DEFAULT_FACET_TEMPLATE, TRANSLATIONS;

  Clerk = window.Clerk;

  Clerk.lib('facet_tools', {
    translations: function() {
      return TRANSLATIONS;
    },
    default_facet_template: function() {
      return DEFAULT_FACET_TEMPLATE;
    },
    default_facet_css: function() {
      return DEFAULT_FACET_CSS;
    }
  });

  TRANSLATIONS = {
    'danish': {
      "true": 'Ja',
      "false": 'Nej',
      'more': 'Vis Mere',
      'search': 'Søg Efter'
    },
    'dutch': {
      "true": 'Ja',
      "false": 'Nee',
      'more': 'Laat Meer Zien',
      'search': 'Zoeken naar'
    },
    'english': {
      "true": 'Yes',
      "false": 'No',
      'more': 'Show More',
      'search': 'Search For'
    },
    'finnish': {
      "true": 'Joo',
      "false": 'Ei',
      'more': 'Näytä Lisää',
      'search': 'Etsi'
    },
    'french': {
      "true": 'Oui',
      "false": 'Non',
      'more': 'Montre Plus',
      'search': 'Rechercher'
    },
    'german': {
      "true": 'Ja',
      "false": 'Nein',
      'more': 'Zeig Mehr',
      'search': 'Suche nach'
    },
    'hungarian': {
      "true": 'Igen',
      "false": 'Nem',
      'more': 'Mutass Többet',
      'search': 'Keresése'
    },
    'italian': {
      "true": 'Sì',
      "false": 'No',
      'more': 'Mostra Di Più',
      'search': 'Cerca'
    },
    'norwegian': {
      "true": 'Ja',
      "false": 'Nei',
      'more': 'Vis Mer',
      'search': 'Søk etter'
    },
    'portuguese': {
      "true": 'Sim',
      "false": 'Não',
      'more': 'Mostre Mais',
      'search': 'Pesquisar por'
    },
    'romanian': {
      "true": 'Da',
      "false": 'Nu',
      'more': 'Afișați Mai Multe',
      'search': 'Caută'
    },
    'russian': {
      "true": 'Да',
      "false": 'Нет',
      'more': 'Показать больше',
      'search': 'Поиск'
    },
    'spanish': {
      "true": 'Si',
      "false": 'No',
      'more': 'Mostrar Más',
      'search': 'Buscar'
    },
    'swedish': {
      "true": 'Ja',
      "false": 'Nej',
      'more': 'Visa Mer',
      'search': 'Söka efter'
    },
    'turkish': {
      "true": 'Evet',
      "false": 'Hayır',
      'more': 'Daha Fazla Göster',
      'search': 'Ara'
    }
  };

  DEFAULT_FACET_TEMPLATE = "<div class=\"clerk-facets\">\n    {% for facet_group in facets %}\n        <div class=\"clerk-facet-group clerk-facet-{{ facet_group.group }}\">\n            <div class=\"clerk-facet-group-title\">{{ facet_group.title }}</div>\n\n            {% if facet_group.type == \"range\" %}\n                <div class=\"clerk-range\" data-group=\"{{ facet_group.group}}\" data-min=\"{{ facet_group.min }}\" data-max=\"{{ facet_group.max }}\" data-start=\"{{ facet_group.start }}\" data-end=\"{{ facet_group.end }}\" data-step=\"auto\"></div>\n            {% endif %}\n\n            {% if facet_group.facets.length > 10 %}\n                <input type=\"text\" placeholder=\"{{translation.search_for}} {{ facet_group.title }}...\" class=\"clerk-facet-search\" />\n                <input type=\"checkbox\" id=\"clerk-show-more-{{ facet_group.group }}\" class=\"clerk-facet-show-more\" />\n            {% endif %}\n\n            <div class=\"clerk-facet-group-facets\">\n                {% for facet in facet_group.facets %}\n                    <div class=\"clerk-facet {% if facet.selected %}clerk-facet-selected{% endif %}\" data-facet=\"{{ facet_group.group }}\" data-value=\"{{ facet.value }}\" data-min=\"{{ facet.min }}\" data-max=\"{{ facet.max }}\">\n                        <div class=\"clerk-facet-count\">{{ facet.count }}</div>\n                        <div class=\"clerk-facet-name\">{{ facet.name }}</div>\n                    </div>\n                {% endfor %}\n            </div>\n\n            {% if facet_group.facets.length > 10 %}\n                <label for=\"clerk-show-more-{{ facet_group.group }}\" class=\"clerk-facet-show-more\">{{ translation.show_more }}</label>\n            {% endif %}\n        </div>\n    {% endfor %}\n</div>";

  DEFAULT_FACET_CSS = ".clerk-facets { } .clerk-facet-group { margin-bottom: 1.5em; padding: 1em; background-color: white; border: 1px solid #eee; border-radius: 5px; box-shadow: 0px 2px 4px -2px rgba(0,0,0,.09); } .clerk-facet-group-title { margin-bottom: 1em; text-transform: uppercase; font-size: .8em; font-weight: bold; letter-spacing: 1px; color: #95a5a6; } .clerk-facet-group-facets { overflow: hidden; max-height: 24.5em; transition: max-height .2s ease-in-out; } .clerk-facet-search { width: calc(100% - 1.8em); margin: 0 0 1em 0; padding: .6em .8em; border: 1px solid #eee; font-size: .9em; } input.clerk-facet-show-more { display: none; } label.clerk-facet-show-more { display: block; padding-top: .5em; text-align: center; font-size: .9em; color: #95a5a6; cursor: pointer; } input.clerk-facet-show-more:checked + .clerk-facet-group-facets { max-height: 9001em; } input.clerk-facet-show-more:checked + .clerk-facet-group-facets + label.clerk-facet-show-more { display: none; } .clerk-facet { clear: both; margin: .4em 0; cursor: pointer; } .clerk-facet.hidden { display: none; } .clerk-facet-name { overflow: hidden; height: 1.8em; white-space: nowrap; } .clerk-facet-name:before { position: relative; top: .2em; display: inline-block; content: ''; width: 1em; height: 1em; margin: 0 .5em 0 0; border: 1px solid #95a5a6; border-radius: 4px; transition: all .1s ease-in-out; } .clerk-facet-name:hover:before { background-color: #95a5a6; border-color: #95a5a6; opacity: .8; } .clerk-facet-count { float: right; padding-top: .2em; font-size: .9em; color: #95a5a6; } .clerk-facet-selected { font-weight: bold; } .clerk-facet-selected .clerk-facet-name:before { background-color: #95a5a6; border-color: #95a5a6; }";

}).call(this);

/*
 * File: src/init.coffee 
 */
(function() {
  var Clerk, action, api, clerk_email, clerk_q, content_mode, dom, external, i, init_page_popups, init_page_popups_loop, j, json, key, labels, len, len1, load_config, logger, n, parameter, product_id, ref, storage, tmp_config, tmp_config_key, url_param, utils, value,
    slice = [].slice;

  Clerk = window.Clerk;

  clerk_q = window.__clerk_q;

  if (!Clerk._inited) {
    Clerk._inited = true;
    dom = Clerk.lib('dom');
    logger = Clerk.lib('logger');
    json = Clerk.lib('json');
    utils = Clerk.lib('utils');
    storage = Clerk.lib('storage');

    /* Default configuration */
    Clerk('config', {
      proxy: 'api.clerk.io',
      key: void 0,
      debug: {
        enable: true,
        level: 'warn',
        collect: true
      },
      mode: 'live',
      loaded: false,
      failed_to_load: false,
      collect_email: false,
      language: void 0,
      price_context: void 0,
      formatters: {
        round: function(x) {
          return Math.round(x);
        },
        ceil: function(x) {
          return Math.ceil(x);
        },
        floor: function(x) {
          return Math.floor(x);
        },
        pct: function(x, y) {
          return Math.round(100 - x / y * 100);
        },
        money: function(price, decimals, seperator_thousaind, seperator_decimal) {
          var price_str;
          if (decimals == null) {
            decimals = 2;
          }
          if (seperator_thousaind == null) {
            seperator_thousaind = ',';
          }
          if (seperator_decimal == null) {
            seperator_decimal = '.';
          }
          price_str = parseFloat(price).toFixed(decimals > 0 ? decimals : 1).replace(/(\d)(?=(\d{3})+\.)/g, "$1X").replace('.', seperator_decimal).replace(/X/g, seperator_thousaind);
          if (decimals === 0) {
            price_str = price_str.split(seperator_decimal)[0];
          }
          return price_str;
        },
        money_eu: function(price, decimals) {
          return Clerk('config', 'formatters').money(price, decimals, '.', ',');
        },
        min: function(xs) {
          return Math.min.apply(null, xs);
        },
        max: function(xs) {
          return Math.max.apply(null, xs);
        },
        first: function(xs) {
          return xs[0];
        },
        last: function(xs) {
          return xs.slice(-1)[0];
        },
        nth: function(xs, n) {
          return xs[n];
        },
        includes: function(xs, y) {
          var i, len, x;
          for (i = 0, len = xs.length; i < len; i++) {
            x = xs[i];
            if (x === y) {
              return true;
            }
          }
          return false;
        },
        keys: function(dict) {
          return Object.keys(dict);
        },
        truncate: function(string, length, ending) {
          if (ending == null) {
            ending = '';
          }
          if (string.length > length) {
            return string.substr(0, length) + ending;
          }
          return string;
        },
        fallback: function(x, y) {
          if (x) {
            return x;
          } else {
            return y;
          }
        },
        replace: function(string, searchFor, replaceWith) {
          if (utils.type(searchFor) === 'string' && utils.type(searchFor) === 'string') {
            return string.split(searchFor).join(replaceWith);
          } else {
            return string.replace(searchFor, replaceWith);
          }
        },
        highlight: function(description, keyword, hl_class, inverse) {
          var tmp;
          if (hl_class == null) {
            hl_class = 'clerk-highlight';
          }
          if (inverse == null) {
            inverse = false;
          }
          if (hl_class === 'clerk-highlight') {
            Clerk.lib('dom').css('.clerk-highlight { background-color: #fff2a8; font-weight: bold; }');
          }
          if (inverse) {
            tmp = description.replace(RegExp("" + keyword, "ig"), "</span>$&<span class='" + hl_class + "'>");
            tmp = "<span class='" + hl_class + "'>" + tmp + "</span>";
            return tmp.replace("<span class='" + hl_class + "'></span>", '');
          } else {
            return description.replace(RegExp("" + keyword, "ig"), "<span class='" + hl_class + "'>$&</span>");
          }
        }
      },
      globals: (function() {
        var ref, window;
        window = dom.window();
        return {
          is_mobile: window.width < 768,
          is_tablet: (768 <= (ref = window.width) && ref <= 1024),
          is_desktop: window.width > 1024
        };
      })()
    });

    /* Load custom url parameters */
    tmp_config_key = '__clerk_tmp_config';
    if (window.location.hash.indexOf('clerkjs:') !== -1) {
      tmp_config = window.location.hash.split('clerkjs:')[1];
      sessionStorage.setItem(tmp_config_key, tmp_config);
    } else {
      tmp_config = sessionStorage.getItem(tmp_config_key);
    }
    if (tmp_config != null) {
      ref = tmp_config.split('&');
      for (i = 0, len = ref.length; i < len; i++) {
        parameter = ref[i];
        parameter = parameter.split('=');
        if (parameter.length !== 2) {
          logger.warn('Invatid URL parameter!', {
            param: parameter
          });
          continue;
        }
        key = parameter[0], value = parameter[1];
        if (value === 'yes' || value === 'on' || value === 'true') {
          value = true;
        }
        if (value === 'no' || value === 'off' || value === 'false') {
          value = false;
        }
        Clerk.config(key, value);
      }
    }

    /* Load from temp queue */
    if (clerk_q) {
      for (j = 0, len1 = clerk_q.length; j < len1; j++) {
        action = clerk_q[j];
        action = Array.prototype.slice.call(action);
        Clerk.apply(null, [action[0]].concat(slice.call(action.slice(1))));
      }
    }

    /* Log page */
    logger.log('Clerk.js loaded and ready.', {
      url: window.location.href
    });

    /* AMP support */
    if (typeof define === 'function' && define.amd) {
      define('clerk', [], function() {
        return Clerk;
      });
    }

    /* Add automatic click tracking */
    Clerk('click', "*[data-clerk-product-id]");

    /* Log url parameters */
    logger.log('Clerk.js checking for url parameters.', {
      url: window.location.href
    });
    url_param = function(name) {
      var regex, results;
      name = name.replace(/[\[\]]/g, '\\$&');
      regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
      results = regex.exec(window.location.href);
      if (!results) {
        return void 0;
      }
      if (!results[2]) {
        return '';
      }
      if (name.indexOf('@') === -1) {
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      }
      return decodeURIComponent(results[2]);
    };
    product_id = url_param('clerk_product');
    if (product_id) {
      labels = url_param('clerk_labels');
      api = url_param('clerk_api');
      api = api.replace(/\*/g, '/');
      n = url_param('clerk_n');
      external = url_param('clerk_external');
      clerk_email = url_param('clerk_email');
      if (clerk_email != null) {
        Clerk('call', 'log/email', {
          'email': clerk_email
        });
      }
      if (!isNaN(product_id) && isFinite(product_id)) {
        product_id = parseInt(product_id);
      }

      /* Logging url parameters */
      logger.log('Clerk.js found url parameter.', {
        url: window.location.href,
        clerk_product: product_id,
        clerk_labels: labels,
        clerk_api: api,
        clerk_n: n,
        clerk_external: external,
        clerk_email: clerk_email
      });
      Clerk('click', product_id, {
        labels: labels ? labels.split(',') : void 0,
        api: api,
        n: n ? parseInt(n) : void 0,
        external: !!external
      });
    } else {

      /* Log url parameters */
      logger.log('Clerk.js found no url parameters.', {
        url: window.location.href
      });
    }
    content_mode = url_param('clerk_content_mode');
    if (content_mode && (content_mode === 'live' || content_mode === 'preview')) {
      Clerk('config', 'mode', content_mode);
    }

    /* init all UI popups */
    init_page_popups = function() {
      var element, k, len2, ref1, results1, ui_popup;
      if (document.readyState === 'complete') {
        clearInterval(init_page_popups_loop);
        ui_popup = Clerk.lib('ui.popup');
        ref1 = dom.find('.clerk-popup');
        results1 = [];
        for (k = 0, len2 = ref1.length; k < len2; k++) {
          element = ref1[k];
          results1.push(ui_popup.create(element));
        }
        return results1;
      }
    };
    init_page_popups_loop = setInterval(init_page_popups, 50);

    /* Load additional information and initialize clerk contents */
    load_config = function() {
      if (!Clerk('config', 'key')) {
        setTimeout(load_config, 50);
        return;
      }
      return Clerk('call', 'config/load', {
        mode: Clerk('config', 'mode')
      }, function(response) {
        var additional_formatters, content, content_init_loop, content_key, css_selector, e, element, end_content_init_phase, end_content_init_phase_loop, error1, formatter, function_def, init_content, is_mobile, k, len2, new_carousel, ref1, ref2, ref3, ref4, ref5, ref6, store_settings;
        additional_formatters = {};
        ref1 = response.results.formatters;
        for (k = 0, len2 = ref1.length; k < len2; k++) {
          formatter = ref1[k];
          function_def = formatter.formatter + "; return " + formatter.name;
          try {
            additional_formatters[formatter.name] = new Function(function_def)();
          } catch (error1) {
            e = error1;
            logger.error("Error while loading formatter " + formatter.name + ":", {
              exeption: e,
              formatter: formatter
            });
          }
        }
        if (additional_formatters) {
          Clerk('config', 'formatters', additional_formatters);
        }
        Clerk('config', 'contents', response.results.contents);
        ref2 = response.results.contents;
        for (content_key in ref2) {
          content = ref2[content_key];
          if (content.css_injector != null) {
            is_mobile = Clerk('config', 'globals').is_mobile;
            css_selector = is_mobile ? content.css_injector['mobile'] : content.css_injector['desktop'];
            if (!css_selector) {
              logger.warn('No css_injector found for content', {
                content: content
              });
              continue;
            }
            element = dom.find(css_selector);
            element.attribute('data-template', '@' + content_key);
            element.attribute('data-api', content.api);
            element.attribute('data-trigger-element', content.css_injector['mobile'] + ';' + content.css_injector['desktop']);
            if ((ref3 = content.args) != null ? ref3.limit : void 0) {
              element.attribute('data-limit', content.args.limit);
            }
            if ((ref4 = content.args) != null ? ref4.suggestions : void 0) {
              element.attribute('data-omni-search-suggestions', content.args.suggestions);
            }
            if ((ref5 = content.args) != null ? ref5.categories : void 0) {
              element.attribute('data-omni-search-categories', content.args.categories);
            }
            if ((ref6 = content.args) != null ? ref6.pages : void 0) {
              element.attribute('data-omni-search-pages', content.args.pages);
            }
            Clerk('content', css_selector);
          }
          if (content.facets) {
            Clerk('config', 'omnisearch-facets-' + content_key, content.facets);
          }
        }
        store_settings = response.results.store_settings;
        new_carousel = url_param('clerk_new_carousel');
        if (new_carousel != null) {
          store_settings['use_new_carousel'] = new_carousel === 'true';
        }
        Clerk('config', 'store_settings', store_settings);
        Clerk('config', 'loaded', true);

        /* Init content phase */
        init_content = function() {
          return Clerk('content', '.clerk');
        };
        init_content();
        content_init_loop = setInterval(init_content, 50);
        end_content_init_phase = function() {
          var hostname;
          if (document.readyState === 'complete') {
            clearInterval(content_init_loop);
            clearInterval(end_content_init_phase_loop);
            init_content();
            store_settings = Clerk('config', 'store_settings');
            hostname = window.location.hostname;
            if (store_settings.sales_assistant === true) {
              Clerk('inject_chat');
            }
            return Clerk('call', 'log/pageview');
          }
        };
        return end_content_init_phase_loop = setInterval(end_content_init_phase, 50);
      }, function(error) {
        if ((error != null ? error.code : void 0) === 403) {
          Clerk('config', 'failed_to_load', true);
        }
        Clerk('config', 'loaded', true);
        return Clerk('content', '.clerk');
      });
    };
    load_config();
  }

}).call(this);
